<template>
  <div class="history">
    <h2 class="title AvantGarde">OUR HISTORY</h2>
<!--    <h2 class="title AvantGarde">GROUP HISTORY AND ACHIEVEMENTS</h2>-->
<!--    <h3 class="title-cn YaSiRegular">集团历史及成就</h3>-->
    <h3 class="title-cn YaSiRegular">集团历史</h3>
		<svg version="1.1" class="pc" id="图层_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
				 viewBox="0 0 1920 700" style="enable-background:new 0 0 1920 700;" xml:space="preserve">

			<g>
	<defs>
		<rect id="SVGID_1_" x="67.3" y="-3.9" width="1836.5" height="668.7"/>
	</defs>
				<clipPath id="SVGID_00000062895122819638893540000000552490529325637045_">
		<use xlink:href="#SVGID_1_"  style="overflow:visible;"/>
	</clipPath>
</g>
			<path class="st0" style="stroke:#ccc" d="M69.3,300.6c0,0,31.5,0.1,112.3-0.5c63.3-0.5,69.4,60.1,69.7,72.4l-0.6,181.8l0.8,39
	c1.4,69.7,54.7,68.3,62.5,68.7l150.2,0.3c47.3,0,86.3-2.5,85.5-78.5L546,312.2l-0.7-37.7c0-44,13.1-92.2,87.7-88.9l173.7-0.3
	c51,6.3,70.5,43.3,69.8,102.8l-1.2,148v41c4.3,35.6-8.3,91.5,82.3,90.5l190.7,1.3c47.3,0,76.2-41,73.6-92.4l0-299.8
	c0,0-10-103,67.7-100l202.7-0.2c47.3,0,66.2,23.5,65.2,95.2l-0.3,139.1c0,44,21.6,60.1,68.9,60.1L1902,372"/>
			<g class="a1 ani">
			<path class="st0 blue-long" d="M69.3,300.6c0,0,31.5,0.1,112.3-0.5c63.3-0.5,69.4,60.1,69.7,72.4l-0.6,181.8l0.8,39
	c1.4,69.7,54.7,68.3,62.5,68.7l150.2,0.3c47.3,0,86.3-2.5,85.5-78.5L546,312.2l-0.7-37.7c0-44,13.1-92.2,87.7-88.9l173.7-0.3
	c51,6.3,70.5,43.3,69.8,102.8l-1.2,148v41c4.3,35.6-8.3,91.5,82.3,90.5l190.7,1.3c47.3,0,76.2-41,73.6-92.4l0-299.8
	c0,0-10-103,67.7-100l202.7-0.2c47.3,0,66.2,23.5,65.2,95.2l-0.3,139.1c0,44,21.6,60.1,68.9,60.1L1902,372"/>

	<g>
		<g>
			<path d="M25.4,374.9c0-4.8,2.7-7.8,6.5-7.8c1.8,0,3.2,0.9,4,1.8l-0.7,0.8c-0.8-0.9-1.9-1.5-3.3-1.5c-3.2,0-5.2,2.6-5.2,6.6
				c0,4.1,2,6.7,5.1,6.7c1.5,0,2.7-0.6,3.7-1.8l0.7,0.8c-1.2,1.3-2.6,2.1-4.5,2.1C28,382.6,25.4,379.6,25.4,374.9z M39.2,367.4h8.3
				v1.1h-7.1v5.5h6v1.1h-6v6.4h7.3v1.1h-8.5V367.4z M50.1,374.9c0-4.8,2.6-7.7,6.2-7.7c3.7,0,6.2,3,6.2,7.7c0,4.8-2.6,7.8-6.2,7.8
				C52.7,382.6,50.1,379.5,50.1,374.9z M61.3,374.9c0-4.1-2-6.6-5-6.6s-4.9,2.5-4.9,6.6s2,6.7,4.9,6.7
				C59.3,381.5,61.3,378.9,61.3,374.9z"/>
		</g>
		<g>
			<path d="M75.4,375.4c2,2.8,5.3,5.5,8.2,6.8c-0.2,0.2-0.5,0.6-0.7,0.8c-2.9-1.4-6.3-4.3-8.3-7.3v8.2h-1v-8.2c-2,3-5.3,5.8-8.2,7.2
				c-0.2-0.3-0.5-0.6-0.7-0.8c2.9-1.2,6.1-4,8.1-6.7h-7.7v-1h8.5v-5.6h-7.5v-1h7.5v-2.5h1v2.6h7.7v1h-7.7v5.6h8.6v1h-7.8V375.4z
				 M68.7,369.5c0.9,1.3,1.8,2.9,2.1,4l-0.9,0.4c-0.3-1.1-1.1-2.8-2-4.1L68.7,369.5z M77.3,373.8c0.8-1.1,1.8-3,2.3-4.3l1,0.4
				c-0.7,1.4-1.7,3.2-2.5,4.2L77.3,373.8z M91.7,380.6c1.5-0.3,3-0.6,4.6-0.9v0.9c-3.7,0.7-7.6,1.5-10.2,2l-0.2-1
				c1.3-0.2,3-0.6,4.9-0.9v-3.9h-4.3V376h4.2v-2.5h0.9v2.5H96v0.9h-4.4L91.7,380.6L91.7,380.6z M93.2,368.6c1.2,1.4,2.6,3.3,3.2,4.4
				l-0.8,0.5c-0.2-0.4-0.5-0.9-0.9-1.4c-6.8,0.7-7.5,0.8-7.9,1c-0.1-0.2-0.2-0.7-0.4-1c0.3,0,0.6-0.4,1-0.9s1.4-2,2.2-3.7h-3.7v-0.9
				h10.5v0.9h-5.6c-0.8,1.6-1.8,3.2-2.7,4.4l6.2-0.6c-0.6-0.8-1.2-1.6-1.8-2.3L93.2,368.6z M98.7,379.4h-0.9V367h0.9V379.4z
				 M102.9,365.6v16.2c0,0.8-0.2,1.1-0.7,1.3c-0.6,0.2-1.6,0.2-3,0.2c-0.1-0.3-0.2-0.7-0.4-1.1c1.3,0,2.4,0,2.8,0
				c0.3,0,0.4-0.1,0.4-0.5v-16.3h0.9V365.6z M124.4,382v1h-18.3v-1h7.9v-16.4h1v6.6h7.9v1H115v8.8H124.4z M129.9,374.2
				c-0.7-0.6-2.2-1.5-3.4-2.1l0.5-0.7c1.2,0.5,2.6,1.4,3.4,2L129.9,374.2z M127.1,383c0.8-1.6,2-4.4,2.8-6.7l0.8,0.6
				c-0.7,2.2-1.9,4.9-2.7,6.7L127.1,383z M128.1,365.5c1.3,0.5,2.8,1.4,3.6,2l-0.6,0.8c-0.8-0.7-2.3-1.6-3.6-2.1L128.1,365.5z
				 M134.4,368.6c-0.7,1.4-1.5,2.7-2.3,3.6c-0.2-0.1-0.6-0.4-0.9-0.6c1.5-1.6,2.8-4,3.6-6.5l1,0.2c-0.3,0.8-0.6,1.5-0.9,2.3h9.9v0.9
				h-10.4V368.6z M143.4,376.2c-0.1,1.5-0.2,2.8-0.3,3.8h1.5v0.9H143c-0.2,1.2-0.4,1.8-0.7,2.2c-0.4,0.4-0.7,0.6-1.3,0.6
				s-1.6,0-2.6-0.1c0-0.3-0.1-0.6-0.3-0.9c1.2,0.1,2.2,0.1,2.6,0.1s0.6,0,0.8-0.3c0.2-0.2,0.4-0.7,0.6-1.6h-9.5
				c0.2-1.2,0.5-2.9,0.8-4.7h-2v-0.9h2.1c0.2-1.5,0.4-3.1,0.5-4.3h9.7c0,0,0,0.4,0,0.6c-0.1,1.4-0.1,2.7-0.2,3.8h1.7v0.9h-1.8V376.2
				z M142.2,380c0.1-0.9,0.2-2.2,0.3-3.8h-8.3c-0.2,1.4-0.4,2.7-0.5,3.8H142.2z M134.8,371.9c-0.1,1.1-0.3,2.3-0.5,3.4h8.2
				c0.1-1,0.1-2.1,0.2-3.4H134.8z M139,379.8c-0.5-0.8-1.6-2-2.6-2.8l0.7-0.4c1,0.8,2.1,1.9,2.6,2.7L139,379.8z M137.5,372
				c1,0.7,2.1,1.8,2.6,2.5l-0.7,0.5c-0.5-0.7-1.5-1.8-2.5-2.5L137.5,372z M165.5,377.8h-8.6v4.7c0,0.7-0.2,1-0.8,1.2
				s-1.8,0.2-3.7,0.2c-0.1-0.3-0.3-0.7-0.5-0.9c1.8,0,3.1,0,3.5,0s0.5-0.1,0.5-0.4v-4.7h-8.4V377h8.4v-1.7c1.5-0.5,3.1-1.4,4.3-2.2
				h-9.5v-0.9h10.6l0.2-0.1l0.7,0.5c-1.3,1.2-3.4,2.4-5.3,3.2v1.1h8.6V377.8z M148.9,372.5H148v-3.8h3.5c-0.4-0.8-1.2-2-2-2.9
				l0.8-0.4c0.8,0.9,1.7,2.1,2,2.9l-0.7,0.4h8.7c0.8-0.9,1.8-2.4,2.3-3.4l0.9,0.4c-0.7,1-1.5,2.1-2.2,3h3.6v3.8h-1v-2.9h-15.2v2.9
				H148.9z M156.7,368.8c-0.2-0.9-1-2.3-1.7-3.3l0.9-0.3c0.7,1,1.4,2.4,1.7,3.3L156.7,368.8z M181.6,376.8
				c-4.3,1.5-9.1,3.1-12.2,4.2l-0.4-1c2.9-0.9,7.9-2.6,12.4-4.1L181.6,376.8z M184.7,367.5c-0.1,11-0.3,14.5-1.1,15.5
				c-0.4,0.5-0.8,0.7-1.4,0.7c-0.7,0-2,0-3.1-0.1c0-0.3-0.1-0.7-0.3-1c1.4,0.1,2.6,0.1,3.1,0.1c0.4,0,0.6,0,0.8-0.3
				c0.6-0.7,0.8-4.4,1-14.7h-14.5v-0.9h15.5V367.5z M172.3,370c2,1.3,4.5,3.1,5.7,4.2l-0.7,0.8c-1.2-1.2-3.7-3.1-5.6-4.4L172.3,370z
				"/>
		</g>
		<g>
			<path d="M61.6,393.6v9.3h-1v-1.3h-6.7v6.9h-1v-6.9h-6.7v1.4h-1v-9.4h7.6v-3.7h1v3.7H61.6z M52.9,400.8v-6.1h-6.7v6.1H52.9z
				 M60.6,400.8v-6.1h-6.7v6.1H60.6z M80,394.6c-1.3,3.4-3,6.1-5.2,8.3c2.4,2.1,5.3,3.7,8.7,4.6c-0.2,0.2-0.5,0.6-0.7,0.9
				c-3.4-0.9-6.3-2.6-8.7-4.8c-2.4,2.1-5.3,3.7-8.8,4.9c-0.1-0.3-0.4-0.7-0.6-0.9c3.5-1.1,6.4-2.6,8.7-4.6c-2.2-2.3-4-5.1-5.3-8.3
				h-3.2v-1h18.4v1H80V394.6z M69.1,394.6c1.1,2.9,2.8,5.5,5,7.6c2-2,3.6-4.5,4.8-7.6H69.1z M74.3,393.4c-0.3-0.8-1-2.2-1.7-3.2
				l1-0.3c0.7,1,1.4,2.3,1.8,3.2L74.3,393.4z M90.7,396h3.9v0.9h-3.9v0.6c0.7,0.8,3.1,3.6,3.6,4.3l-0.7,0.8c-0.5-0.8-2-2.7-3-3.9
				v9.8h-1v-10.1c-1.1,2.6-2.7,5.3-4.2,6.8c-0.1-0.3-0.4-0.7-0.6-0.9c1.6-1.6,3.5-4.8,4.5-7.5h-4v-0.9h4.2v-3.9
				c-1.2,0.2-2.5,0.4-3.7,0.5c-0.1-0.2-0.2-0.6-0.3-0.8c2.8-0.4,6.2-1,7.9-1.7l0.7,0.8c-1,0.4-2.3,0.7-3.7,1v4.2H90.7z M102.8,391.9
				v15.8h-1V406h-5.3v1.8h-1v-15.9L102.8,391.9L102.8,391.9z M101.8,405v-12.2h-5.3V405H101.8z M123.4,393.6v9.3h-1v-1.3h-6.7v6.9
				h-1v-6.9H108v1.4h-1v-9.4h7.6v-3.7h1v3.7H123.4z M114.7,400.8v-6.1H108v6.1H114.7z M122.4,400.8v-6.1h-6.7v6.1H122.4z M144.3,391
				v17.7h-1v-1.1h-14.8v1.1h-1V391H144.3z M143.2,406.6v-14.8h-14.8v14.8H143.2z M141.7,403.5v0.9h-11.6v-0.9h5.2v-4.1h-4.2v-0.9
				h4.2V395h-4.8v-0.9h10.8v0.9h-5.1v3.5h4.5v0.9h-4.5v4.1H141.7z M138.5,400c0.9,0.7,1.9,1.8,2.3,2.4l-0.7,0.5
				c-0.5-0.7-1.4-1.8-2.3-2.5L138.5,400z M162.4,394.6c-1.3,3.4-3,6.1-5.2,8.3c2.4,2.1,5.3,3.7,8.7,4.6c-0.2,0.2-0.5,0.6-0.7,0.9
				c-3.4-0.9-6.3-2.6-8.7-4.8c-2.4,2.1-5.3,3.7-8.8,4.9c-0.1-0.3-0.4-0.7-0.6-0.9c3.5-1.1,6.4-2.6,8.7-4.6c-2.2-2.3-4-5.1-5.3-8.3
				h-3.2v-1h18.4v1h-3.3V394.6z M151.5,394.6c1.1,2.9,2.8,5.5,5,7.6c2-2,3.6-4.5,4.8-7.6H151.5z M156.6,393.4
				c-0.3-0.8-1-2.2-1.7-3.2l1-0.3c0.7,1,1.4,2.3,1.8,3.2L156.6,393.4z M174.5,390.2c-0.6,1.4-1.3,2.8-2.1,4.1v14.2h-1v-12.7
				c-0.9,1.3-1.9,2.5-2.9,3.4c-0.1-0.2-0.5-0.7-0.7-0.9c2.2-2.1,4.4-5.2,5.7-8.5L174.5,390.2z M183.9,407.2c1.2,0,1.4-0.9,1.5-4.5
				c0.3,0.2,0.7,0.4,1,0.5c-0.2,3.8-0.5,5-2.5,5h-4c-1.8,0-2.3-0.5-2.3-2.4v-4.4c-1.1,0.7-2.1,1.3-3.2,1.9c-0.2-0.2-0.5-0.6-0.7-0.7
				c1.3-0.7,2.6-1.5,3.9-2.3v-9.9h1v9.2c2.5-1.9,4.7-4.1,6.3-6.4l1,0.6c-1.9,2.6-4.5,5-7.2,7v5.2c0,1.1,0.2,1.3,1.3,1.3h3.9V407.2z"
			/>
		</g>
		<g>
			<path d="M123.4,325.5v25.3h-1.9v-25.3H123.4z"/>
			<path d="M137,351l-1-1.4c5.6-4,8.7-8.2,9.5-12.5c-2,1.3-3.8,1.9-5.6,1.9c-2,0-3.7-0.7-5-2s-2-3-2-4.9c0-2.1,0.7-3.7,2-5.1
				c1.3-1.3,3-2,5.1-2c2.4,0,4.3,0.8,5.7,2.4s2.1,3.7,2.1,6.5C147.8,340.2,144.2,346,137,351z M145.8,335c0-0.4,0.1-0.8,0.1-1.1
				c0-2.2-0.5-3.9-1.5-5.1s-2.4-1.8-4.2-1.8c-1.5,0-2.8,0.5-3.8,1.5s-1.5,2.2-1.5,3.7s0.5,2.7,1.5,3.8c1,1,2.2,1.5,3.7,1.5
				C142.1,337.4,144.1,336.5,145.8,335z"/>
			<path d="M156.1,337.6c-2.2-1.5-3.3-3.4-3.3-5.7c0-1.8,0.7-3.4,2-4.7c1.3-1.3,2.9-2,4.7-2c1.9,0,3.4,0.7,4.8,2
				c1.3,1.3,2,2.9,2,4.7c0,2.4-1.1,4.3-3.2,5.7c2.5,1.5,3.7,3.6,3.7,6.3c0,2-0.7,3.7-2.1,5.1c-1.4,1.4-3.1,2.1-5.1,2.1
				s-3.7-0.7-5.2-2.1c-1.4-1.4-2.1-3-2.1-5C152.3,341.2,153.6,339.1,156.1,337.6z M164.8,343.8c0-1.4-0.5-2.7-1.6-3.7
				c-1-1-2.3-1.5-3.8-1.5s-2.7,0.5-3.7,1.6s-1.5,2.3-1.5,3.8s0.5,2.8,1.6,3.8c1,1,2.3,1.6,3.8,1.6s2.8-0.5,3.8-1.6
				C164.3,346.6,164.8,345.4,164.8,343.8z M154.7,331.9c0,1.4,0.5,2.5,1.4,3.5s2.1,1.4,3.4,1.4c1.4,0,2.5-0.5,3.4-1.4
				c0.9-1,1.4-2.1,1.4-3.6c0-1.3-0.5-2.5-1.4-3.4c-1-0.9-2.1-1.4-3.4-1.4c-1.3,0-2.4,0.5-3.4,1.4
				C155.1,329.4,154.7,330.5,154.7,331.9z"/>
			<path d="M186.4,325.5l-11.6,25.6l-1.6-0.7l10.4-23.2h-13.8v-1.8h16.6V325.5z"/>
		</g>
	</g>
				<g>
		<path class="st1" d="M252.5,367.6c4.6,0,8.3,3.7,8.3,8.3c0,4.6-3.7,8.3-8.3,8.3c-4.6,0-8.3-3.7-8.3-8.3
			C244.2,371.5,247.9,367.6,252.5,367.6z M240.7,374h4.2v4.2h-4.2V374z M232.4,374h4.2v4.2h-4.2V374z M224.1,374h4.2v4.2h-4.2V374z
			 M215.8,374h4.2v4.2h-4.2V374z M207.5,374h4.2v4.2h-4.2V374z M199.2,374h4.2v4.2h-4.2V374z"/>
					<path class="st2" d="M252.5,385.9c-4.2,0-7.7-2.6-9.2-6.2h-2.7c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h2.7
			c1.5-3.6,5-6.2,9.2-6.2c5.4,0,9.8,4.4,9.8,9.8C262.4,381.5,258,385.9,252.5,385.9z M246.3,378.6c1,2.4,3.5,4.1,6.3,4.1
			c3.7,0,6.8-3,6.8-6.8s-3-6.8-6.8-6.8c-2.8,0-5.2,1.7-6.3,4.1c0.1,0.2,0.1,0.4,0.1,0.6v4.2C246.4,378.2,246.4,378.5,246.3,378.6z
			 M242.2,376.5h0.5c0-0.2,0-0.4,0-0.6s0-0.4,0-0.6h-0.5V376.5z M236.6,379.5h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2
			c0-0.8,0.7-1.5,1.5-1.5h4.1c0.8,0,1.5,0.7,1.5,1.5v4.2C238.1,379,237.4,379.5,236.6,379.5z M233.9,376.5h1.1v-1.1h-1.1V376.5z
			 M228.3,379.5h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2
			C229.8,379,229.1,379.5,228.3,379.5z M225.6,376.5h1.1v-1.1h-1.1V376.5z M219.9,379.5h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2
			c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C221.5,379,220.8,379.5,219.9,379.5z M217.3,376.5h1.1v-1.1h-1.1V376.5z
			 M211.6,379.5h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2
			C213.2,379,212.5,379.5,211.6,379.5z M209,376.5h1.1v-1.1H209V376.5z M203.3,379.5h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2
			c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C204.9,379,204.2,379.5,203.3,379.5z M200.7,376.5h1.1v-1.1h-1.1V376.5z"/>
	</g>
</g>
			<g class="a2 ani">
	<g>
		<g>
			<path d="M46,498.4c0-4.8,2.7-7.8,6.5-7.8c1.8,0,3.2,0.9,4,1.8l-0.7,0.8c-0.8-0.9-1.9-1.5-3.3-1.5c-3.2,0-5.2,2.6-5.2,6.6
				c0,4.1,2,6.7,5.1,6.7c1.5,0,2.7-0.6,3.7-1.8l0.7,0.8c-1.2,1.3-2.6,2.1-4.5,2.1C48.6,506.1,46,503.1,46,498.4z M59.8,490.9h8.3
				v1.1H61v5.5h6v1.1h-6v6.4h7.3v1.1h-8.5C59.8,506.1,59.8,490.9,59.8,490.9z M70.7,498.4c0-4.8,2.6-7.7,6.2-7.7
				c3.7,0,6.2,3,6.2,7.7c0,4.8-2.6,7.8-6.2,7.8C73.3,506.1,70.7,503.1,70.7,498.4z M81.9,498.4c0-4.1-2-6.6-5-6.6s-4.9,2.5-4.9,6.6
				s2,6.7,4.9,6.7C79.9,505,81.9,502.5,81.9,498.4z"/>
		</g>
		<g>
			<path d="M92.1,493c-0.7,1.5-1.5,2.9-2.5,4.3v10h-1v-8.8c-0.8,0.9-1.7,1.8-2.7,2.5c-0.1-0.2-0.4-0.6-0.6-0.8
				c2.5-1.8,4.4-4.4,5.7-7.2h-5.3v-1h5.8c0.5-1.1,0.9-2.2,1.2-3.4l1,0.3c-0.3,1.1-0.7,2.1-1.1,3.1h11v1H92.1z M103.6,506v0.9H91.1
				V506h5.7v-6.5h-4.9v-0.9h4.9v-4.3h1v4.3h5v0.9h-5v6.5L103.6,506L103.6,506z M123.4,492.5v9.3h-1v-1.3h-6.7v6.9h-1v-6.9H108v1.4
				h-1v-9.4h7.6v-3.7h1v3.7H123.4z M114.7,499.5v-6.1H108v6.1H114.7z M122.4,499.5v-6.1h-6.7v6.1H122.4z M144.3,489.8v17.7h-1v-1.1
				h-14.8v1.1h-1v-17.7H144.3z M143.2,505.5v-14.8h-14.8v14.8H143.2z M141.7,502.2v0.9h-11.6v-0.9h5.2v-4.1h-4.2v-0.9h4.2v-3.5h-4.8
				v-0.9h10.8v0.9h-5.1v3.5h4.5v0.9h-4.5v4.1H141.7z M138.5,498.9c0.9,0.7,1.9,1.8,2.3,2.4l-0.7,0.5c-0.5-0.7-1.4-1.8-2.3-2.5
				L138.5,498.9z M165.6,498.5h-4.8v9h-1v-9h-6.4c-0.2,3.3-1.3,6.6-5.2,9c-0.2-0.2-0.5-0.6-0.7-0.7c3.7-2.3,4.7-5.3,4.9-8.3h-5v-0.9
				h5.1c0-0.4,0-0.7,0-1.1v-5.3h-4.3v-0.9H165v0.9h-4.1v6.4h4.8v0.9H165.6z M159.8,497.5v-6.4h-6.3v5.3c0,0.4,0,0.7,0,1.1H159.8z
				 M174.7,493.1c-0.3,3.8-0.9,6.7-1.9,9c1,0.8,1.8,1.7,2.4,2.4l-0.6,0.8c-0.5-0.7-1.3-1.5-2.2-2.3c-1,2-2.4,3.4-4,4.4
				c-0.1-0.3-0.4-0.6-0.6-0.8c1.6-0.8,2.9-2.2,3.9-4.2c-1.1-0.8-2.2-1.7-3.3-2.3c0.5-1.5,1.1-3.8,1.6-6h-2.2v-0.9h2.4
				c0.3-1.5,0.5-3,0.7-4.2l0.9,0.1c-0.2,1.3-0.4,2.7-0.7,4.2h2.9h0.2L174.7,493.1z M170.8,494c-0.5,2.1-0.9,4.1-1.4,5.7
				c0.9,0.5,1.8,1.2,2.6,1.8c0.8-2,1.4-4.5,1.7-7.5H170.8z M182.9,491.8c1.4,1.8,2.9,4.2,3.5,5.7l-0.8,0.4c-0.2-0.4-0.4-1-0.7-1.5
				c-8.1,0.6-8.9,0.6-9.4,0.8c-0.1-0.2-0.2-0.7-0.4-1c0.4,0,0.8-0.6,1.3-1.4c0.6-0.7,2.4-3.5,3.5-6.2l1,0.3c-1.3,2.5-2.7,5.1-4.2,7
				l7.6-0.5c-0.7-1.2-1.5-2.4-2.3-3.4L182.9,491.8z M176.4,499.2h8.8v8.1h-1v-0.9h-6.9v0.9h-0.9L176.4,499.2L176.4,499.2z
				 M177.3,500.1v5.4h6.9v-5.4H177.3z"/>
		</g>
		<g>
			<path d="M70.5,513.8c-0.6,1.6-1.4,3.1-2.2,4.5V532h-1v-12.3c-0.8,1.2-1.6,2.2-2.5,3.1c-0.1-0.2-0.4-0.7-0.6-0.9
				c2.1-2.1,4.1-5.3,5.4-8.5L70.5,513.8z M80.8,531c1.3,0,1.5-0.6,1.7-3.1c0.2,0.2,0.6,0.4,0.9,0.4c-0.2,2.7-0.6,3.6-2.7,3.6h-5.9
				c-2.2,0-2.8-0.5-2.8-2.4v-7.3l-2.3,0.9l-0.4-0.9l2.7-1v-5.8h1v5.4l3.6-1.4v-5.9h0.9v5.5l3.9-1.5l0.2-0.1l0.2-0.2l0.7,0.3
				l-0.1,0.2c0,3.8-0.1,7.1-0.3,8c-0.2,0.9-0.7,1.2-1.3,1.3c-0.5,0.1-1.4,0.1-2,0.1c0-0.3-0.1-0.7-0.3-0.9c0.7,0,1.5,0,1.8,0
				c0.4,0,0.7-0.1,0.8-0.7c0.2-0.7,0.3-3.4,0.3-6.8l-3.9,1.5v7.7h-0.9v-7.3L73,522v7.7c0,1.2,0.3,1.5,1.8,1.5h6V531z M90.7,513.6
				c-0.4,1-0.8,2.2-1.1,3.1h3.6V530h-5.9v1.7h-0.9v-14.9h2.3c0.4-1,0.8-2.4,1-3.4L90.7,513.6z M92.2,517.6h-4.9v4.9h4.9V517.6z
				 M92.2,529v-5.5h-4.9v5.5H92.2z M103.2,517.3c-0.4,9.6-0.6,12.7-1.5,13.7c-0.4,0.5-0.8,0.6-1.4,0.6s-1.8,0-3-0.1
				c0-0.3-0.1-0.7-0.3-1c1.4,0.1,2.6,0.1,3,0.1s0.7,0,0.9-0.3c0.7-0.7,1-3.9,1.3-12.7h-5.7c-0.6,1.5-1.3,2.8-2,3.8
				c-0.2-0.1-0.6-0.4-0.8-0.5c1.4-1.9,2.5-4.7,3.2-7.7l1,0.2c-0.2,1.1-0.6,2.2-0.9,3.2h6.4v0.7H103.2z M99.2,526.5
				c-0.7-1.3-2.1-3.3-3.3-4.8l0.8-0.5c1.2,1.5,2.7,3.5,3.4,4.7L99.2,526.5z M124.2,515.8v0.9h-17.9v-0.9h8.8
				c-0.3-0.7-0.6-1.5-0.9-2.2l0.9-0.2c0.4,0.8,0.8,1.7,1.1,2.4H124.2L124.2,515.8z M122.9,530.8c0,0.7-0.2,0.9-0.7,1.1
				c-0.6,0.1-1.5,0.1-3.4,0.1c-0.1-0.2-0.2-0.6-0.4-0.8c1.4,0,2.7,0,3,0c0.4,0,0.5-0.1,0.5-0.5v-9.9h-13.5V532h-0.9V520h9.5
				c0.6-0.8,1.4-2.1,1.8-2.9l1.1,0.3c-0.5,0.9-1.2,1.9-1.8,2.7h4.8V530.8z M113.9,521.8c-1,1.2-2.5,2.6-3.8,3.5
				c-0.1-0.2-0.4-0.6-0.6-0.8c1.3-0.8,2.6-2,3.6-3.1L113.9,521.8z M111.6,517c0.5,0.7,1.1,1.7,1.4,2.3l-0.9,0.4
				c-0.3-0.6-0.9-1.7-1.4-2.4L111.6,517z M112.5,529.5v1h-0.9V525h7.3v4.5H112.5z M112.5,525.8v2.8h5.5v-2.8H112.5z M120.8,525.1
				c-0.9-0.8-2.7-2.2-4.1-3.2l0.6-0.6c1.4,0.9,3.2,2.2,4.1,3.1L120.8,525.1z M133.9,521c0,0,0,0.4,0,0.5c-0.2,6.9-0.3,9.1-0.8,9.8
				c-0.3,0.4-0.6,0.5-1.1,0.5c-0.4,0-1.2,0-1.9,0c0-0.3-0.1-0.7-0.3-0.9c0.8,0.1,1.5,0.1,1.8,0.1s0.4,0,0.6-0.3
				c0.4-0.5,0.5-2.6,0.7-8.8H130c-0.1,3.3-0.5,6.9-2.9,10.1c-0.2-0.2-0.5-0.5-0.7-0.6c2.5-3.2,2.8-7,2.8-10.1v-3.4h-2.4V517h7.9v0.9
				h-4.6v3.1H133.9L133.9,521z M130.9,516.6c-0.2-0.8-0.7-2-1.2-2.9l0.9-0.3c0.5,0.9,1,2,1.3,2.8L130.9,516.6z M137,517.2
				c-0.6,1.2-1.3,2.2-2,3.1c-0.2-0.2-0.6-0.5-0.8-0.6c1.4-1.5,2.6-3.9,3.2-6.3l1,0.2c-0.3,0.9-0.6,1.9-0.9,2.7h7.5v0.9H137
				L137,517.2z M144.8,522.2c-1,1-2.4,2.1-3.5,2.8c0.9,2.7,2.1,4.8,3.9,6c-0.2,0.2-0.5,0.5-0.7,0.8c-2.8-2.1-4.4-6.3-5.2-11.4
				c-0.7,0.2-1.5,0.4-2.2,0.5v9.4l3.4-1.6c0,0.3,0.1,0.7,0.2,0.9c-3.8,1.9-4.3,2.1-4.6,2.5c-0.1-0.2-0.4-0.6-0.5-0.8
				c0.2-0.2,0.6-0.6,0.6-1.5v-9.6c2.6-0.6,5.7-1.4,7.4-2.3l0.9,0.7c-1.2,0.5-2.7,1-4.3,1.4c0.2,1.4,0.5,2.8,0.9,4
				c1.1-0.8,2.3-1.8,3-2.6L144.8,522.2z M165.5,530.5v1h-18.2v-1h8.6v-5.9h-6.4v-1h6.4v-5h-5.2c-0.7,1.4-1.4,2.6-2.3,3.6
				c-0.2-0.1-0.6-0.4-0.9-0.6c1.7-1.9,3-4.7,3.9-7.7l1,0.2c-0.4,1.2-0.8,2.4-1.3,3.5h4.8v-4.2h1v4.2h7.7v0.9h-7.7v5h6.9v1h-6.9v5.9
				h8.6V530.5z M170.9,522.2c-0.7-0.7-2.1-1.6-3.3-2.2l0.6-0.6c1.2,0.6,2.6,1.5,3.3,2.1L170.9,522.2z M172.2,525.1
				c-0.9,2.1-2.1,4.7-3.2,6.5l-0.9-0.6c0.9-1.6,2.3-4.3,3.3-6.5L172.2,525.1z M172,516.8c-0.7-0.7-2.2-1.7-3.4-2.3l0.7-0.6
				c1.2,0.6,2.6,1.6,3.4,2.2L172,516.8z M174.6,520.5c0,3.5-0.3,8.3-2.6,11.7c-0.2-0.1-0.6-0.4-0.8-0.5c2.2-3.3,2.5-7.9,2.5-11.3
				v-5.9h12.7v0.9h-11.7L174.6,520.5L174.6,520.5z M186.3,530.5v0.9h-12.2v-0.9h6V527h-4.6v-0.9h4.6V524h1v2.1h4.6v0.9h-4.6v3.5
				H186.3z M180.2,522.2v-3h-4.1v-0.9h4.1V516h0.9v2.4h4.3v0.9h-4.3v3h5v0.9h-11v-0.9H180.2z"/>
		</g>
		<g>
			<path d="M123.4,450v25.3h-1.9V450H123.4z"/>
			<path d="M137,475.5l-1-1.4c5.6-4,8.7-8.2,9.5-12.5c-2,1.3-3.8,1.9-5.6,1.9c-2,0-3.7-0.7-5-2s-2-3-2-4.9c0-2.1,0.7-3.7,2-5.1
				c1.3-1.3,3-2,5.1-2c2.4,0,4.3,0.8,5.7,2.4s2.1,3.7,2.1,6.5C147.8,464.9,144.2,470.5,137,475.5z M145.8,459.5
				c0-0.4,0.1-0.8,0.1-1.1c0-2.2-0.5-3.9-1.5-5.1s-2.4-1.8-4.2-1.8c-1.5,0-2.8,0.5-3.8,1.5s-1.5,2.2-1.5,3.7s0.5,2.7,1.5,3.8
				c1,1,2.2,1.5,3.7,1.5C142.1,461.9,144.1,461,145.8,459.5z"/>
			<path d="M155.6,475.5l-1-1.4c5.6-4,8.7-8.2,9.5-12.5c-2,1.3-3.8,1.9-5.6,1.9c-2,0-3.7-0.7-5-2s-2-3-2-4.9c0-2.1,0.7-3.7,2-5.1
				c1.3-1.3,3-2,5.1-2c2.4,0,4.3,0.8,5.7,2.4s2.1,3.7,2.1,6.5C166.3,464.9,162.7,470.5,155.6,475.5z M164.3,459.5
				c0-0.4,0.1-0.8,0.1-1.1c0-2.2-0.5-3.9-1.5-5.1s-2.4-1.8-4.2-1.8c-1.5,0-2.8,0.5-3.8,1.5s-1.5,2.2-1.5,3.7s0.5,2.7,1.5,3.8
				c1,1,2.2,1.5,3.7,1.5C160.7,461.9,162.6,461,164.3,459.5z"/>
			<path d="M171.5,453.1v-1.9c1.5-1.1,3.2-1.6,5.3-1.6c2.2,0,4,0.6,5.4,1.8s2.1,2.7,2.1,4.6c0,1.3-0.4,2.5-1.2,3.5s-1.9,1.8-3.4,2.2
				v0.1c3.3,1.1,4.9,3.2,4.9,6.4c0,2.2-0.7,4-2.2,5.3s-3.3,2-5.3,2c-2.1,0-4-0.4-5.8-1.2v-1.7c1.7,0.8,3.6,1.2,5.6,1.2
				c1.7,0,3.2-0.5,4.2-1.5c1.1-1,1.6-2.3,1.6-3.9c0-1.7-0.6-3.1-1.7-4.1c-1.2-1-2.7-1.5-4.8-1.5V461c1.9,0,3.4-0.5,4.5-1.4
				c1.2-1,1.7-2.1,1.7-3.5c0-1.3-0.6-2.5-1.7-3.4c-1.1-0.9-2.5-1.4-4.1-1.4C174.9,451.5,173.1,452,171.5,453.1z"/>
		</g>
	</g>
				<g>
		<path class="st1" d="M252.5,488.1c4.6,0,8.3,3.7,8.3,8.3c0,4.6-3.7,8.3-8.3,8.3c-4.6,0-8.3-3.7-8.3-8.3
			C244.2,492,247.9,488.1,252.5,488.1z M240.7,494.5h4.2v4.2h-4.2V494.5z M232.4,494.5h4.2v4.2h-4.2V494.5z M224.1,494.5h4.2v4.2
			h-4.2V494.5z M215.8,494.5h4.2v4.2h-4.2V494.5z M207.5,494.5h4.2v4.2h-4.2V494.5z M199.2,494.5h4.2v4.2h-4.2V494.5z"/>
					<path class="st2" d="M252.5,506.4c-4.2,0-7.7-2.6-9.2-6.2h-2.7c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h2.7
			c1.5-3.6,5-6.2,9.2-6.2c5.4,0,9.8,4.4,9.8,9.8C262.4,502,258,506.4,252.5,506.4z M246.3,499.1c1,2.4,3.4,4.1,6.3,4.1
			c3.7,0,6.8-3,6.8-6.8c0-3.7-3-6.8-6.8-6.8c-2.8,0-5.2,1.7-6.3,4.1c0.1,0.2,0.1,0.4,0.1,0.6v4.2C246.4,498.8,246.4,499,246.3,499.1
			z M242.2,497h0.5c0-0.2,0-0.4,0-0.6s0-0.4,0-0.6h-0.5V497z M236.6,500h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5
			h4.1c0.8,0,1.5,0.7,1.5,1.5v4.2C238.1,499.5,237.4,500,236.6,500z M233.9,497h1.1v-1.1h-1.1V497z M228.3,500h-4.2
			c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C229.8,499.5,229.1,500,228.3,500z M225.6,497
			h1.1v-1.1h-1.1V497z M219.9,500h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2
			C221.5,499.5,220.8,500,219.9,500z M217.3,497h1.1v-1.1h-1.1V497z M211.6,500h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2
			c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C213.2,499.5,212.5,500,211.6,500z M209,497h1.1v-1.1H209V497z M203.3,500
			h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C204.9,499.5,204.2,500,203.3,500z
			 M200.7,497h1.1v-1.1h-1.1V497z"/>
	</g>
</g>
			<g class="a3 ani">
	<g>
		<g>
			<path d="M51,615l-2.3,0.8v7.3h-1v-6.9l-3.2,1.1l-0.2-1c0.9-0.2,2.1-0.6,3.5-1.1v-5.4H46c-0.2,1.4-0.6,2.7-0.9,3.8
				c-0.2-0.1-0.6-0.4-0.8-0.5c0.7-1.8,1.1-4.5,1.3-7l0.9,0.2c-0.1,0.9-0.2,1.8-0.3,2.6h1.6v-4.3h1v4.3H51v1h-2.2v5.1l2.3-0.7L51,615
				z M60.1,611.8v2.8h2.6v0.9h-2.6v6.1c0,0.7-0.2,1-0.7,1.2c-0.6,0.1-1.6,0.2-3.2,0.2c0-0.3-0.2-0.7-0.3-1c1.4,0,2.5,0,2.9,0
				c0.3,0,0.4-0.1,0.4-0.4v-6.1h-7.8v-0.9h7.8v-2.8h-8v-0.9h5.3v-3.1h-4.2v-0.9h4.2v-2.5h1v2.5h4.3v0.9h-4.3v3.1h5.3v0.9H60.1z
				 M53.4,616.5c1.1,1,2.2,2.4,2.7,3.4l-0.8,0.5c-0.5-1-1.6-2.4-2.7-3.4L53.4,616.5z M82.6,607.7v4.3h-0.9v-3.5h-7.2v5.6h-1v-5.6h-7
				v3.5h-0.9v-4.3h8V606h-6.9V605h14.8v0.9h-7v1.7H82.6z M67.2,612.5h5v0.8h-5V612.5z M67.2,615h13.7v8h-1v-0.7H68.2v0.9h-1V615z
				 M72.3,610v0.8h-4.6V610H72.3z M68.2,615.8v2.3h5.3v-2.3H68.2z M73.5,621.3v-2.4h-5.3v2.4H73.5z M79.9,615.8h-5.4v2.3h5.4V615.8z
				 M79.9,621.3v-2.4h-5.4v2.4H79.9z M80.5,610v0.8h-4.7V610H80.5z M75.8,612.5H81v0.8h-5.2V612.5z M89.4,619.3
				c0.5,0.2,0.9,0.7,1.8,1.2c1.4,0.9,3.1,1,5.4,1c2.5,0,5.4-0.1,7.5-0.3c-0.1,0.3-0.2,0.7-0.3,1c-1.3,0.1-5,0.2-7.3,0.2
				c-2.6,0-4.3-0.2-5.7-1.2c-0.8-0.5-1.5-1.2-2-1.2c-0.7,0-1.8,1.1-2.9,2.6l-0.6-0.8c1.1-1.3,2.2-2.4,3.1-2.6v-6.4h-3.1v-0.9h4
				L89.4,619.3L89.4,619.3z M89.4,609.2c-0.7-0.9-2.2-2.5-3.4-3.5l0.7-0.5c1.2,1,2.7,2.5,3.5,3.4L89.4,609.2z M94.5,606.8
				c1,0.4,2.1,0.8,3.1,1.3c1.3-0.5,2.7-1.3,3.7-2.1h-9.5v-0.9h10.5h0.2l0.6,0.5c-1.2,1.1-2.9,2.2-4.5,3c0.7,0.4,1.4,0.7,1.9,0.9h2.7
				v9.4c0,0.6-0.1,0.9-0.6,1.1c-0.5,0.2-1.3,0.2-2.8,0.2c-0.1-0.3-0.2-0.6-0.3-0.9c1.2,0,2.1,0,2.4,0s0.4-0.1,0.4-0.4v-2.4H98v3.5
				h-0.9v-3.5H93v3.6h-0.9v-10.6h6.6c-1.4-0.7-3.1-1.5-4.7-2.1L94.5,606.8z M92.8,610.3v2.2h4.1v-2.2H92.8z M96.9,615.7v-2.3h-4.1
				v2.3H96.9z M97.9,610.3v2.2h4.3v-2.2H97.9z M102.1,615.7v-2.3h-4.3v2.3H102.1z M108.7,608.8c-0.7,0.8-1.4,1.5-2.2,2.2
				c-0.2-0.2-0.5-0.5-0.7-0.6c2.2-1.8,3.9-4.2,4.8-6l1.1,0.2c-0.4,0.7-0.8,1.4-1.3,2.2h5.5c-0.3-0.6-0.7-1.5-1.1-2.1l0.9-0.3
				c0.5,0.7,1,1.7,1.3,2.4h6.2v0.9h-6.9v1.7h6.1v0.8h-6.1v1.7h6.2v0.8h-6.2v1.8h7.6v0.9h-14.1v0.7h-1v-7.3H108.7z M116.8,617.8
				c2,1.7,5.2,3.2,8,3.9c-0.2,0.2-0.5,0.6-0.6,0.8c-2.9-0.8-6.4-2.6-8.4-4.6v5h-1v-5c-2.1,2-5.5,3.9-8.3,4.8
				c-0.2-0.3-0.5-0.6-0.7-0.8c2.7-0.8,5.9-2.4,7.9-4.1h-7.5V617h8.6v-1.6h1v1.6h8.7v0.9L116.8,617.8L116.8,617.8z M115.1,607.5h-5.5
				v1.7h5.5V607.5z M115.1,610h-5.5v1.7h5.5V610z M115.1,612.5h-5.5v1.8h5.5V612.5z M144.2,605.3V623h-1v-0.9h-14.8v0.9h-1v-17.7
				H144.2z M143.2,621.2v-14.9h-14.8v14.9H143.2z M141.7,611h-3.6v7.3c0,0.6-0.1,0.9-0.6,1.1c-0.5,0.2-1.2,0.2-2.6,0.2
				c0-0.2-0.2-0.6-0.4-0.9c1.1,0,2,0,2.2,0c0.3,0,0.4-0.1,0.4-0.4v-6c-1.8,2.2-4.3,4.2-6.6,5.6c-0.1-0.2-0.4-0.5-0.7-0.7
				c2.6-1.4,5.3-3.8,7-6.2H130v-0.9h7.1v-2.9h1v2.9h3.6L141.7,611L141.7,611z M164.2,611.2c-0.9,2.7-2.1,5-3.7,7
				c0.9,2.3,2,3.6,3.3,3.6c0.7,0,0.9-1.1,1.1-3.9c0.2,0.2,0.6,0.4,0.9,0.5c-0.2,3.3-0.6,4.4-2,4.4c-1.6,0-2.9-1.4-3.9-3.8
				c-1.4,1.5-2.9,2.8-4.8,3.8c-0.1-0.2-0.5-0.6-0.7-0.8c2-1.1,3.7-2.4,5.1-4.1c-0.8-2.4-1.3-5.5-1.6-9h-7.8v3h5.4c0,0,0,0.4,0,0.5
				c-0.1,4.8-0.2,6.5-0.6,7c-0.3,0.3-0.6,0.4-1.1,0.5c-0.5,0-1.5,0-2.5,0c0-0.3-0.1-0.7-0.3-0.9c1.1,0.1,2.1,0.1,2.4,0.1
				c0.3,0,0.5,0,0.7-0.2c0.3-0.3,0.4-1.8,0.5-6h-4.4v0.8c0,2.8-0.3,6.7-2.2,9.4c-0.2-0.2-0.6-0.5-0.8-0.6c1.8-2.6,2-6.1,2-8.7v-5.6
				h8.8c-0.1-1.2-0.1-2.5-0.1-3.7h1c0,1.3,0,2.5,0.1,3.7h6.8v1h-6.7c0.2,3.2,0.7,5.9,1.3,8c1.3-1.8,2.3-3.8,3.1-6.1L164.2,611.2z
				 M163.9,607.8c-0.8-0.7-2.5-1.8-3.9-2.5l0.6-0.6c1.4,0.7,3,1.7,3.9,2.4L163.9,607.8z M186.1,621.2v1H168v-1h10
				c1.2-2.7,2.6-7.3,3.3-10.4l1.1,0.2c-0.9,3.2-2.2,7.5-3.4,10.2H186.1z M185.3,609.3h-16.5v-1h16.5V609.3z M173.9,620
				c-0.4-2.5-1.3-6.2-2.1-9l1-0.2c0.9,2.9,1.8,6.6,2.1,9L173.9,620z M176.8,607.8c-0.2-0.9-0.6-2.3-1-3.3l0.9-0.3
				c0.4,1.1,0.9,2.4,1.1,3.3L176.8,607.8z"/>
		</g>
		<g>
			<path d="M9.8,641.3c-0.7,1.5-1.5,2.9-2.5,4.3v10h-1v-8.8c-0.8,0.9-1.7,1.8-2.7,2.5c-0.1-0.2-0.4-0.6-0.6-0.8
				c2.5-1.8,4.4-4.4,5.7-7.2H3.4v-1h5.7c0.5-1.1,0.9-2.2,1.2-3.4l1,0.3c-0.3,1.1-0.7,2.1-1.1,3.1h11v1L9.8,641.3L9.8,641.3z
				 M21.3,654.2v0.9H8.8v-0.9h5.7v-6.5H9.6v-0.9h4.9v-4.3h1v4.3h5v0.9h-5v6.5H21.3z M41,640.8v9.3h-1v-1.3h-6.7v6.9h-1v-6.9h-6.7
				v1.4h-1v-9.4h7.6V637h1v3.7H41z M32.3,647.8v-6.1h-6.7v6.1H32.3z M40,647.8v-6.1h-6.7v6.1H40z M61.9,638v17.7h-1v-1.1H46.1v1.1
				h-1V638H61.9z M60.9,653.7v-14.8H46.1v14.8H60.9z M59.4,650.5v0.9H47.8v-0.9H53v-4.1h-4.2v-0.9H53V642h-4.8V641H59v0.9h-5.1v3.5
				h4.5v0.9h-4.5v4.1H59.4z M56.2,647c0.9,0.7,1.9,1.8,2.3,2.4l-0.7,0.5c-0.5-0.7-1.4-1.8-2.3-2.5L56.2,647z M71.4,637.3
				c-0.1,0.3-0.3,0.6-0.4,0.9c1.8,1.8,4,4.2,5,5.7l-0.7,0.6c-1-1.4-2.9-3.7-4.7-5.5c-1.3,2.3-3.2,4.5-5.3,6.2
				c-0.2-0.2-0.5-0.5-0.8-0.6c2.7-2,4.8-4.9,6-7.5L71.4,637.3z M73.2,654.5c1,0,1.2-0.5,1.2-3.1c0.3,0.2,0.6,0.3,0.9,0.4
				c-0.1,2.8-0.5,3.6-2.1,3.6h-4.1c-1.8,0-2.3-0.3-2.3-1.8v-9h7.1c0,0,0,0.3,0,0.5c-0.2,3.6-0.5,5-0.9,5.5c-0.3,0.3-0.6,0.4-1.1,0.4
				c-0.4,0-1.2,0-1.9,0c0-0.3-0.1-0.6-0.3-0.9c0.8,0.1,1.6,0.1,1.9,0.1s0.5,0,0.6-0.2c0.3-0.3,0.5-1.5,0.7-4.4h-5.2v8.1
				c0,0.7,0.2,0.9,1.3,0.9L73.2,654.5L73.2,654.5z M78.3,650.7h-0.9v-11.3h0.9V650.7z M82.4,637.2V654c0,0.8-0.3,1.1-0.8,1.3
				c-0.6,0.2-1.6,0.2-3.5,0.2c-0.1-0.2-0.2-0.7-0.4-0.9c1.5,0,2.8,0,3.2,0c0.4,0,0.6-0.1,0.6-0.5v-16.9H82.4z M89.3,652.5
				c0.5,0.1,0.9,0.5,1.8,1c1.3,0.7,3,0.8,5.2,0.8c2.5,0,5.8-0.1,7.9-0.4c-0.1,0.3-0.3,0.8-0.3,1.1c-1.8,0.1-5.5,0.2-7.6,0.2
				c-2.3,0-4.1-0.2-5.4-0.9c-0.8-0.5-1.4-1-1.8-1c-0.7,0-1.8,0.9-2.9,2.1l-0.7-0.9c1-0.9,2-1.7,2.9-2v-6.8h-2.9v-0.9h3.9L89.3,652.5
				L89.3,652.5z M89.2,641.7c-0.6-0.9-2-2.3-3.1-3.3l0.7-0.5c1.2,1,2.5,2.3,3.2,3.2L89.2,641.7z M103.8,644.7H90.6v-0.9h6.2v-3.2
				h-3.6c-0.5,0.9-1.1,1.7-1.6,2.4c-0.2-0.1-0.6-0.4-0.8-0.5c1.2-1.3,2.3-3.3,2.9-5.2l0.9,0.2c-0.3,0.7-0.6,1.5-0.9,2.2h3.1V637h1
				v2.7h5.1v0.9h-5.1v3.2h6L103.8,644.7z M92.3,652.2v-5.7h9.7v5.7H92.3z M93.3,651.3h7.8v-3.9h-7.8V651.3z M111.9,637.3h1v18.1h-1
				v-4.9c-2,0.8-4,1.7-5.6,2.4l-0.5-0.9c1.5-0.5,3.8-1.5,6.1-2.4v-6.3h-5.5v-1h5.5V637.3z M122.6,654.2c1.1,0,1.2-0.9,1.3-4.4
				c0.3,0.2,0.7,0.4,0.9,0.5c-0.1,3.6-0.4,4.9-2.2,4.9H119c-1.6,0-2.2-0.5-2.2-2.3v-15.5h1v7.3c2.1-1.3,4.3-2.8,5.6-4.1l0.8,0.8
				c-1.7,1.4-4.2,2.9-6.4,4.2v7.2c0,1.1,0.2,1.3,1.2,1.3L122.6,654.2L122.6,654.2z M136.1,654.8h-8.8v-16.3h8.8v0.9h-7.8v14.4h7.9
				L136.1,654.8L136.1,654.8z M134.7,652c-0.5-1.2-1.3-2.7-2.2-4.2c-1,1.9-2.2,3.6-3.4,4.9c-0.2-0.2-0.6-0.5-0.8-0.6
				c1.4-1.4,2.6-3.2,3.6-5.3c-1.1-1.7-2.3-3.5-3.5-5l0.8-0.4c1.1,1.4,2.2,2.9,3.2,4.5c0.8-1.7,1.5-3.5,2.1-5.3l0.9,0.2
				c-0.7,2.1-1.5,4.1-2.4,6c1.1,1.7,2.1,3.4,2.6,4.7L134.7,652z M138.3,641.3c-0.5,1.6-1.2,3.1-1.9,4.2c-0.2-0.1-0.6-0.4-0.9-0.5
				c1.4-2,2.3-5,2.8-8.2l1,0.1c-0.2,1.2-0.4,2.3-0.7,3.3h5.9h0.2l0.6,0.2c-0.3,1.7-0.9,3.8-1.4,5l-0.8-0.2c0.4-1,0.8-2.6,1.1-4h-5.9
				V641.3z M140.6,644.2c0,0.6,0,1.2,0,1.8c0.7,4.3,2,6.7,4.6,8.9c-0.2,0.2-0.5,0.5-0.7,0.8c-2.2-1.9-3.4-4-4.2-7
				c-0.4,2.4-1.4,4.9-3.5,7.1c-0.2-0.2-0.5-0.5-0.7-0.7c3.4-3.5,3.6-7.9,3.6-10.9v-1.3h0.9L140.6,644.2L140.6,644.2z M163.2,638.2
				c0,9.3,0,16.3,1.5,16.3c0.3,0,0.5-1.4,0.5-3.1c0.2,0.2,0.5,0.5,0.7,0.6c-0.1,2.8-0.4,3.5-1.3,3.5c-2.4,0-2.4-5.7-2.4-16.3h-11.6
				v5.3c0,3.3-0.3,8-2.7,11.2c-0.2-0.2-0.6-0.6-0.8-0.7c2.2-3.1,2.5-7.4,2.5-10.6v-6.3L163.2,638.2L163.2,638.2z M159.8,641
				c-0.7,2.1-1.5,4.1-2.6,6c1.6,2.1,3.2,4.1,4.1,5.7l-0.9,0.6c-0.8-1.4-2.2-3.3-3.7-5.3c-1.4,2.3-3.1,4.2-4.8,5.5
				c-0.2-0.2-0.6-0.6-0.8-0.8c1.8-1.2,3.5-3.2,5-5.5c-1.3-1.7-2.7-3.4-4.1-4.9l0.8-0.5c1.2,1.4,2.5,2.9,3.8,4.5
				c1-1.7,1.8-3.6,2.4-5.4L159.8,641z M167.4,646c0.5-1.4,0.8-3.6,1-5.2l0.8,0.1c-0.1,1.6-0.4,3.9-0.9,5.4L167.4,646z M169.9,637
				h0.9v18.6h-0.9V637z M172.1,640c0.5,0.9,0.9,2.2,1.1,2.9l-0.8,0.4c-0.2-0.8-0.6-2.1-1.1-3L172.1,640z M186.3,643.8v0.8h-13.4
				v-0.8h6.1V642h-5v-0.8h5v-1.6h-5.5v-0.8h5.5v-1.7h1v1.7h5.7v0.8H180v1.6h5.2v0.8H180v1.8H186.3z M184.5,654.2
				c0,0.6-0.1,0.9-0.6,1.1c-0.5,0.2-1.4,0.2-2.8,0.1c0-0.2-0.2-0.6-0.3-0.9c1.2,0,2.2,0,2.4,0c0.3,0,0.4-0.1,0.4-0.4v-2h-8.2v3.3
				h-0.9v-9.6h10V654.2z M175.4,646.8v1.9h8.2v-1.9H175.4z M183.6,651.5v-2h-8.2v2H183.6z"/>
		</g>
		<g>
			<path d="M43.8,663.8h4.1c3,0,5,1.1,5,3.6c0,1.5-0.8,2.8-2.3,3.3v0.1c1.9,0.3,3.2,1.5,3.2,3.6c0,2.9-2.2,4.4-5.6,4.4h-4.5
				L43.8,663.8L43.8,663.8z M47.6,670.3c3,0,4.2-1.1,4.2-2.8c0-2-1.4-2.8-4-2.8h-2.6v5.5L47.6,670.3L47.6,670.3z M48,677.8
				c2.9,0,4.7-1,4.7-3.4c0-2.1-1.7-3.1-4.7-3.1h-2.9v6.4L48,677.8L48,677.8z M56.2,673.3c0-3.7,2.3-5.8,5-5.8s5,2.1,5,5.8
				c0,3.6-2.3,5.7-5,5.7S56.2,677,56.2,673.3z M64.9,673.3c0-2.8-1.6-4.7-3.7-4.7s-3.7,1.9-3.7,4.7s1.6,4.7,3.7,4.7
				S64.9,676.2,64.9,673.3z M68.6,671.3c0-4.8,2.7-7.8,6.5-7.8c1.8,0,3.2,0.9,4,1.8l-0.7,0.8c-0.8-0.9-1.9-1.5-3.3-1.5
				c-3.2,0-5.2,2.6-5.2,6.6c0,4.1,2,6.7,5.1,6.7c1.5,0,2.7-0.6,3.7-1.8l0.7,0.8c-1.2,1.3-2.6,2.1-4.5,2.1
				C71.2,679,68.6,676.2,68.6,671.3z M81.4,673.3c0-3.7,2.3-5.8,5-5.8s5,2.1,5,5.8c0,3.6-2.3,5.7-5,5.7
				C83.7,679,81.4,677,81.4,673.3z M90.1,673.3c0-2.8-1.6-4.7-3.7-4.7s-3.7,1.9-3.7,4.7s1.6,4.7,3.7,4.7S90.1,676.2,90.1,673.3z
				 M94.6,667.8h1l0.1,1.7l0,0c1.1-1.1,2.2-2,3.8-2c2.3,0,3.3,1.4,3.3,4.2v7h-1.2v-6.9c0-2.3-0.7-3.3-2.4-3.3c-1.3,0-2.2,0.7-3.5,2
				v8.2h-1.2L94.6,667.8L94.6,667.8z M106.1,673.3c0-3.7,2.4-5.8,5.1-5.8c1.5,0,2.5,0.7,3.2,1.3l-0.7,0.8c-0.7-0.6-1.5-1.1-2.5-1.1
				c-2.2,0-3.9,1.9-3.9,4.7s1.5,4.7,3.8,4.7c1.1,0,2.1-0.6,2.9-1.2l0.6,0.8c-0.9,0.8-2.1,1.4-3.5,1.4
				C108.3,679,106.1,677,106.1,673.3z M116.4,673.3c0-3.6,2.3-5.8,4.8-5.8c2.7,0,4.2,1.9,4.2,5.1c0,0.3,0,0.6-0.1,0.9h-7.8
				c0.1,2.7,1.6,4.6,4,4.6c1.2,0,2.1-0.4,2.9-0.9l0.5,0.9c-0.9,0.6-1.9,1.1-3.5,1.1C118.7,679,116.4,677,116.4,673.3z M124.4,672.5
				c0-2.7-1.2-4-3.1-4c-1.8,0-3.4,1.5-3.6,4H124.4z M128.6,667.8h1l0.1,1.3l0,0c1.1-0.8,2.3-1.6,3.7-1.6c2.9,0,4.4,2.2,4.4,5.6
				c0,3.8-2.3,5.9-4.8,5.9c-1,0-2.1-0.5-3.2-1.3v2v4h-1.2V667.8z M136.6,673.2c0-2.6-0.9-4.6-3.4-4.6c-1.1,0-2.1,0.6-3.4,1.8v6.3
				c1.2,1,2.3,1.3,3.1,1.3C135.1,678,136.6,676.2,136.6,673.2z M141.2,675.7v-6.8h-1.7V668l1.8-0.1l0.1-3.2h1v3.2h3.2v1h-3.2v6.9
				c0,1.4,0.4,2.3,1.8,2.3c0.4,0,0.9-0.1,1.3-0.3l0.3,0.9c-0.6,0.2-1.3,0.4-1.8,0.4C141.9,679,141.2,677.8,141.2,675.7z"/>
		</g>
		<g>
			<path d="M148,671.5h7v8.6h-1v-1h-5v1.2h-0.9v-8.8H148z M149,672.5v5.7h5v-5.7H149z M161.9,669h-10.8v-6.5h10.8V669z M160.9,663.5
				h-8.8v4.6h8.8V663.5z M165,671.5v8.7h-1v-1h-5.5v1.2h-1v-8.8h7.5V671.5z M164,678.2v-5.7h-5.5v5.7H164z M169.7,670
				c0,0.6,0,1.1,0,1.7h4v8.6h-0.9v-7.6h-3.1c-0.1,2.6-0.4,5.4-1.4,7.7c-0.2-0.1-0.6-0.3-0.9-0.4c1.2-2.9,1.4-6.9,1.4-10v-8h0.9v5.5
				h2.2v-5.9h0.9v5.9h1.8v0.9h-5v1.6H169.7z M186.3,676h-4.1v4.4h-0.9V676h-6.6V675h6.6v-3.5h0.9v3.5h4.1V676z M180,671.5
				c-0.7,1.2-1.9,2.3-3.7,3.4c-0.2-0.2-0.5-0.5-0.7-0.6c1.5-0.8,2.6-1.8,3.3-2.7h-3V664h3.2c0.3-0.7,0.6-1.5,0.7-2.2l1.1,0.2
				c-0.2,0.7-0.5,1.4-0.8,2h5.4v7.7H180V671.5z M176.7,667.2h3.5c0-0.2,0-0.5,0-0.7v-1.9h-3.6v2.6H176.7z M179.4,670.7
				c0.5-0.9,0.7-1.8,0.8-2.6h-3.5v2.6H179.4z M184.4,668h-3.2c-0.1,0.8-0.3,1.7-0.7,2.6h3.9V668z M184.4,664.7h-3.2v1.9
				c0,0.2,0,0.4,0,0.7h3.2V664.7z"/>
		</g>
		<g>
			<path d="M123.4,564.7V590h-1.9v-25.3H123.4z"/>
			<path d="M137,590.2l-1-1.4c5.6-4,8.7-8.2,9.5-12.5c-2,1.3-3.8,1.9-5.6,1.9c-2,0-3.7-0.7-5-2s-2-3-2-4.9c0-2.1,0.7-3.7,2-5.1
				s3-2,5.1-2c2.4,0,4.3,0.8,5.7,2.4c1.4,1.6,2.1,3.7,2.1,6.5C147.8,579.5,144.2,585.2,137,590.2z M145.8,574.2
				c0-0.4,0.1-0.8,0.1-1.1c0-2.2-0.5-3.9-1.5-5.1c-1-1.2-2.4-1.8-4.2-1.8c-1.5,0-2.8,0.5-3.8,1.5s-1.5,2.2-1.5,3.7s0.5,2.7,1.5,3.8
				c1,1,2.2,1.5,3.7,1.5C142.1,576.5,144.1,575.7,145.8,574.2z"/>
			<path d="M155.6,590.2l-1-1.4c5.6-4,8.7-8.2,9.5-12.5c-2,1.3-3.8,1.9-5.6,1.9c-2,0-3.7-0.7-5-2s-2-3-2-4.9c0-2.1,0.7-3.7,2-5.1
				s3-2,5.1-2c2.4,0,4.3,0.8,5.7,2.4c1.4,1.6,2.1,3.7,2.1,6.5C166.3,579.5,162.7,585.2,155.6,590.2z M164.3,574.2
				c0-0.4,0.1-0.8,0.1-1.1c0-2.2-0.5-3.9-1.5-5.1c-1-1.2-2.4-1.8-4.2-1.8c-1.5,0-2.8,0.5-3.8,1.5s-1.5,2.2-1.5,3.7s0.5,2.7,1.5,3.8
				c1,1,2.2,1.5,3.7,1.5C160.7,576.5,162.6,575.7,164.3,574.2z"/>
			<path d="M183.1,564.7v1.8h-8.9v8c0.7-0.1,1.4-0.2,2-0.2c2.5,0,4.5,0.7,6.1,2.1c1.5,1.4,2.3,3.3,2.3,5.7c0,2.3-0.8,4.3-2.3,5.8
				c-1.6,1.6-3.5,2.3-5.8,2.3c-1.9,0-4-0.6-6.1-1.7v-2.2c2.4,1.4,4.4,2,6.1,2c1.8,0,3.3-0.6,4.5-1.8s1.8-2.7,1.8-4.5
				c0-2-0.6-3.5-1.9-4.6c-1.2-1.1-2.9-1.7-5-1.7c-1.1,0-2.3,0.2-3.5,0.5v-11.8h10.7V564.7z"/>
		</g>
	</g>
				<g>
		<path class="st1" d="M252.5,604.5c4.6,0,8.3,3.7,8.3,8.3s-3.7,8.3-8.3,8.3c-4.6,0-8.3-3.7-8.3-8.3S247.9,604.5,252.5,604.5z
			 M240.7,610.8h4.2v4.2h-4.2V610.8z M232.4,610.8h4.2v4.2h-4.2V610.8z M224.1,610.8h4.2v4.2h-4.2V610.8z M215.8,610.8h4.2v4.2h-4.2
			V610.8z M207.5,610.8h4.2v4.2h-4.2V610.8z M199.2,610.8h4.2v4.2h-4.2V610.8z"/>
					<path class="st2" d="M252.5,622.7c-4.2,0-7.7-2.6-9.2-6.2h-2.7c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h2.7
			c1.5-3.6,5-6.2,9.2-6.2c5.4,0,9.8,4.4,9.8,9.8S258,622.7,252.5,622.7z M246.3,615.5c1,2.4,3.4,4.1,6.3,4.1c3.7,0,6.8-3,6.8-6.8
			c0-3.7-3-6.8-6.8-6.8c-2.8,0-5.2,1.7-6.3,4.1c0.1,0.2,0.1,0.4,0.1,0.6v4.2C246.4,615.2,246.4,615.3,246.3,615.5z M242.2,613.3h0.5
			c0-0.2,0-0.4,0-0.6c0-0.2,0-0.4,0-0.6h-0.5V613.3z M236.6,616.5h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.1
			c0.8,0,1.5,0.7,1.5,1.5v4.2C238.1,615.8,237.4,616.5,236.6,616.5z M233.9,613.3h1.1v-1.1h-1.1V613.3z M228.3,616.5h-4.2
			c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C229.8,615.8,229.1,616.5,228.3,616.5z
			 M225.6,613.3h1.1v-1.1h-1.1V613.3z M219.9,616.5h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2
			c0.8,0,1.5,0.7,1.5,1.5v4.2C221.5,615.8,220.8,616.5,219.9,616.5z M217.3,613.3h1.1v-1.1h-1.1V613.3z M211.6,616.5h-4.1
			c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C213.2,615.8,212.5,616.5,211.6,616.5z
			 M209,613.3h1.1v-1.1H209V613.3z M203.3,616.5h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5
			v4.2C204.9,615.8,204.2,616.5,203.3,616.5z M200.7,613.3h1.1v-1.1h-1.1V613.3z"/>
	</g>
</g>
			<g class="a5 ani">
	<g>
		<g>
			<path d="M628.5,445l-2.3,0.8v7.3h-1v-6.9l-3.2,1.1l-0.2-1c0.9-0.2,2.1-0.6,3.5-1.1v-5.4h-1.8c-0.2,1.4-0.6,2.7-0.9,3.8
				c-0.2-0.1-0.6-0.4-0.8-0.5c0.7-1.8,1.1-4.5,1.3-7l0.9,0.2c-0.1,0.9-0.2,1.8-0.3,2.6h1.6v-4.3h1v4.3h2.2v1h-2.2v5.1l2.3-0.7
				L628.5,445z M637.5,441.9v2.8h2.6v0.9h-2.6v6.1c0,0.7-0.2,1-0.7,1.2c-0.6,0.1-1.6,0.2-3.2,0.2c0-0.3-0.2-0.7-0.3-1
				c1.4,0,2.5,0,2.9,0c0.3,0,0.4-0.1,0.4-0.4v-6.1h-7.8v-0.9h7.8v-2.8h-8V441h5.4v-3.1h-4.2V437h4.2v-2.5h1v2.5h4.3v0.9H635v3.1h5.3
				v0.9L637.5,441.9L637.5,441.9z M630.8,446.5c1.1,1,2.2,2.4,2.7,3.4l-0.8,0.5c-0.5-1-1.6-2.4-2.7-3.4L630.8,446.5z M660,437.6v4.3
				h-0.9v-3.5h-7.2v5.6h-1v-5.6h-7v3.5H643v-4.3h8v-1.7h-6.9V435H659v0.9h-7v1.7H660z M644.7,442.5h5v0.8h-5V442.5z M644.7,445h13.7
				v8h-1v-0.7h-11.7v0.9h-1V445z M649.7,440.1v0.8h-4.6v-0.8H649.7z M645.6,445.9v2.3h5.3v-2.3H645.6z M651,451.5v-2.4h-5.3v2.4H651
				z M657.4,445.9H652v2.3h5.4V445.9z M657.4,451.5v-2.4H652v2.4H657.4z M657.9,440.1v0.8h-4.7v-0.8H657.9z M653.2,442.5h5.2v0.8
				h-5.2V442.5z M666.9,449.5c0.5,0.2,0.9,0.7,1.8,1.2c1.4,0.9,3.1,1,5.4,1c2.5,0,5.4-0.1,7.5-0.3c-0.1,0.3-0.2,0.7-0.3,1
				c-1.3,0.1-5,0.2-7.3,0.2c-2.6,0-4.3-0.2-5.7-1.2c-0.8-0.5-1.5-1.2-2-1.2c-0.7,0-1.8,1.1-2.9,2.6l-0.6-0.8
				c1.1-1.3,2.2-2.4,3.1-2.6V443h-3.1v-0.9h4L666.9,449.5L666.9,449.5z M666.8,439.4c-0.7-0.9-2.2-2.5-3.4-3.5l0.7-0.5
				c1.2,1,2.7,2.5,3.5,3.4L666.8,439.4z M671.9,436.9c1,0.4,2.1,0.8,3.1,1.3c1.3-0.5,2.7-1.3,3.7-2.1h-9.5v-0.8h10.5h0.2l0.6,0.5
				c-1.2,1.1-2.9,2.2-4.5,3c0.7,0.4,1.4,0.7,1.9,0.9h2.7v9.4c0,0.6-0.1,0.9-0.6,1.1s-1.3,0.2-2.8,0.2c-0.1-0.3-0.2-0.6-0.3-0.9
				c1.2,0,2.1,0,2.4,0c0.3,0,0.4-0.1,0.4-0.4v-2.4h-4.3v3.5h-0.9v-3.5h-4.1v3.6h-0.9v-10.6h6.6c-1.4-0.7-3.1-1.5-4.7-2.1
				L671.9,436.9z M670.3,440.4v2.2h4.1v-2.2H670.3z M674.4,445.8v-2.3h-4.1v2.3H674.4z M675.3,440.4v2.2h4.3v-2.2H675.3z
				 M679.6,445.8v-2.3h-4.3v2.3H679.6z M701.8,451v1h-18.3v-1h7.9v-16.4h1v6.6h7.9v1h-7.8v8.8H701.8z M707.3,443.5
				c-0.7-0.6-2.2-1.5-3.4-2.1l0.5-0.7c1.2,0.5,2.6,1.4,3.4,2L707.3,443.5z M704.6,452.1c0.8-1.6,2-4.4,2.8-6.7l0.8,0.6
				c-0.7,2.2-1.9,4.9-2.7,6.7L704.6,452.1z M705.6,434.6c1.3,0.5,2.8,1.4,3.6,2l-0.6,0.8c-0.8-0.7-2.3-1.6-3.6-2.1L705.6,434.6z
				 M711.8,437.9c-0.7,1.4-1.5,2.7-2.3,3.6c-0.2-0.1-0.6-0.4-0.9-0.6c1.5-1.6,2.8-4,3.6-6.5l1,0.2c-0.3,0.8-0.6,1.5-0.9,2.3h9.9v0.9
				h-10.4V437.9z M720.9,445.5c-0.1,1.5-0.2,2.8-0.3,3.8h1.5v0.9h-1.6c-0.2,1.2-0.4,1.8-0.7,2.2c-0.4,0.4-0.7,0.6-1.3,0.6
				s-1.6,0-2.6-0.1c0-0.3-0.1-0.6-0.3-0.9c1.2,0.1,2.2,0.1,2.6,0.1c0.4,0,0.6,0,0.8-0.3c0.2-0.2,0.4-0.7,0.6-1.6h-9.5
				c0.2-1.2,0.5-2.9,0.8-4.7h-2v-0.9h2.1c0.2-1.5,0.4-3.1,0.5-4.3h9.7c0,0,0,0.4,0,0.6c-0.1,1.4-0.1,2.7-0.2,3.8h1.7v0.9h-1.8V445.5
				z M719.6,449.1c0.1-0.9,0.2-2.2,0.3-3.8h-8.3c-0.2,1.4-0.4,2.7-0.5,3.8H719.6z M712.3,441c-0.1,1.1-0.3,2.3-0.5,3.4h8.2
				c0.1-1,0.1-2.1,0.2-3.4H712.3z M716.4,448.9c-0.5-0.8-1.6-2-2.6-2.8l0.7-0.4c1,0.8,2.1,1.9,2.6,2.7L716.4,448.9z M715,441.2
				c1,0.7,2.1,1.8,2.6,2.5l-0.7,0.5c-0.5-0.7-1.5-1.8-2.5-2.5L715,441.2z M730.9,444.5c-0.8,0.3-1.6,0.5-2.3,0.7v6.3
				c0,0.7-0.2,1-0.6,1.1c-0.5,0.2-1.2,0.2-2.6,0.2c-0.1-0.2-0.2-0.6-0.4-0.9c1.1,0,2,0,2.2,0c0.3,0,0.4-0.1,0.4-0.4v-6
				c-1.1,0.3-2.1,0.6-2.9,0.9l-0.4-1c0.9-0.2,2-0.6,3.3-0.9v-4.9h-3v-0.9h3v-4.3h1v4.3h2.8v0.9h-2.8v4.6l2.2-0.7L730.9,444.5z
				 M741.5,443.9c-0.9,2.4-2.4,4.4-4.3,5.8c1.6,1.2,3.6,2,5.9,2.5c-0.2,0.2-0.5,0.6-0.6,0.9c-2.3-0.6-4.3-1.5-6-2.8
				c-1.9,1.3-4.1,2.2-6.3,2.8c-0.1-0.3-0.3-0.7-0.5-0.9c2.1-0.5,4.2-1.3,6.1-2.6c-1.6-1.4-2.8-3.1-3.7-5.2h-0.7v-0.9h9.4l0.2-0.1
				L741.5,443.9z M734.4,437.5c0,1.8-0.5,3.9-2.9,5.4c-0.1-0.2-0.4-0.6-0.6-0.7c2.2-1.4,2.6-3.2,2.6-4.7v-2.3h6.1v4.9
				c0,0.6,0.1,0.8,0.4,0.8h1.9c0.2,0,0.7,0,0.9-0.1c0,0.2,0.1,0.7,0.1,0.9c-0.2,0.1-0.7,0.1-1,0.1H740c-1.1,0-1.3-0.4-1.3-1.7v-4
				h-4.2L734.4,437.5L734.4,437.5z M732.9,444.5c0.8,1.8,2,3.3,3.5,4.6c1.6-1.2,2.9-2.7,3.7-4.6H732.9z M763.1,443h-15.2v1.8
				c0,2.4-0.3,5.8-2.1,8.2c-0.2-0.2-0.6-0.5-0.8-0.6c1.6-2.3,1.9-5.4,1.9-7.6V442h9.8c0.6-1,1.4-2.6,1.8-3.6l1,0.4
				c-0.5,1.1-1.2,2.3-1.9,3.3h5.5V443z M762.5,438h-16v-0.9h8.1c-0.3-0.7-0.9-1.6-1.5-2.4l0.9-0.3c0.7,0.8,1.3,1.8,1.6,2.5l-0.4,0.2
				h7.2v0.9H762.5z M751.6,441.9c-0.3-0.8-1.1-2.1-1.8-3l0.8-0.3c0.7,0.9,1.5,2.2,1.9,3L751.6,441.9z"/>
		</g>
		<g>
			<path d="M625.3,470v6.4c0,0.7-0.2,0.9-0.6,1.1c-0.4,0.2-1.1,0.2-2.5,0.2c0-0.2-0.2-0.6-0.3-0.9c1,0,1.8,0,2.1,0s0.4-0.1,0.4-0.4
				v-6.1c-1,0.3-1.9,0.7-2.7,0.9l-0.3-1c0.8-0.3,1.9-0.6,3-1v-5h-2.8v-0.9h2.8v-4.3h0.9v4.3h2.5v0.9h-2.5v4.7l2.3-0.8l0.2,0.9
				L625.3,470z M639.6,476.4c0,0.7-0.2,1-0.7,1.2s-1.4,0.2-2.8,0.2c-0.1-0.2-0.2-0.7-0.4-1c1.2,0,2.1,0,2.4,0c0.3,0,0.4-0.1,0.4-0.4
				v-5.3h-4v6.4h-0.9v-6.4h-4c-0.2,2.3-0.8,4.8-2.4,6.7c-0.2-0.2-0.5-0.5-0.7-0.6c2.1-2.6,2.3-6.2,2.3-9.1v-7.4h10.7v15.7H639.6z
				 M633.7,470.1v-3.9h-3.9v1.7c0,0.7,0,1.4-0.1,2.1L633.7,470.1L633.7,470.1z M629.8,461.5v3.9h3.9v-3.9H629.8z M638.6,461.5h-4
				v3.9h4V461.5z M638.6,470.1v-3.9h-4v3.8h4V470.1z M649.2,462.9c-0.4,1-0.9,1.9-1.5,2.8h10.2v10.6c0,0.7-0.2,1.1-0.7,1.2
				c-0.6,0.2-1.7,0.2-3.5,0.2c-0.1-0.3-0.2-0.7-0.4-1c1.5,0.1,2.8,0,3.2,0s0.5-0.1,0.5-0.5v-2.7h-9.3v4.2h-1v-10.6
				c-1.1,1.5-2.4,2.8-3.9,3.8c-0.1-0.2-0.4-0.6-0.6-0.8c2.6-1.8,4.6-4.5,6-7.4h-5.6v-0.9h6c0.4-0.9,0.7-1.8,1-2.8l1,0.2
				c-0.3,0.9-0.6,1.7-0.9,2.5h10.8v0.9h-11.3V462.9z M657,466.5h-9.3v2.6h9.3V466.5z M657,472.6V470h-9.3v2.6H657z M679.1,462v15.7
				h-1v-1.1h-11.7v1.3h-1v-15.8h5.1c0.4-0.9,0.8-2.1,1-2.9l1.1,0.2c-0.3,0.9-0.7,1.9-1.1,2.7h7.6V462z M666.4,463v3.6h11.7V463
				H666.4z M666.4,467.5v3.5h11.7v-3.5H666.4z M678.1,475.6V472h-11.7v3.6H678.1z M698.1,476.2c2.3,0,2.6-0.7,2.9-3.9
				c0.3,0.2,0.7,0.4,1,0.4c-0.3,3.5-0.8,4.5-3.9,4.5h-8.4c-3,0-3.9-0.4-3.9-2.4v-7.8h12.6v-5.7h-12.9v-1h13.9v9.1h-1v-1.4h-11.6v6.9
				c0,1.1,0.5,1.4,2.8,1.4h8.5V476.2z M709.3,459.2c-0.4,1-0.8,2.2-1.1,3.1h3.6v13.2h-5.9v1.7H705v-14.9h2.3c0.4-1,0.8-2.4,1-3.4
				L709.3,459.2z M710.8,463.2h-4.9v4.9h4.9V463.2z M710.8,474.6v-5.5h-4.9v5.5H710.8z M721.9,463c-0.4,9.6-0.6,12.7-1.5,13.7
				c-0.4,0.5-0.8,0.6-1.4,0.6c-0.6,0-1.8,0-3-0.1c0-0.3-0.1-0.7-0.3-1c1.4,0.1,2.6,0.1,3,0.1s0.7,0,0.9-0.3c0.7-0.7,1-3.9,1.3-12.7
				h-5.8c-0.6,1.5-1.3,2.8-2,3.8c-0.2-0.1-0.6-0.4-0.8-0.5c1.4-1.9,2.5-4.7,3.2-7.7l1,0.2c-0.2,1.1-0.6,2.2-0.9,3.2h6.4v0.7H721.9z
				 M717.8,472.1c-0.7-1.3-2.1-3.3-3.3-4.8l0.8-0.5c1.2,1.5,2.7,3.5,3.4,4.7L717.8,472.1z M730.8,465.6h5.3v0.9h-5.3v2.4h4.4v5.9
				c0,0.6-0.1,0.8-0.5,1s-1.2,0.2-2.4,0.2c-0.1-0.3-0.2-0.6-0.4-0.9c1.1,0,1.8,0,2.1,0c0.2,0,0.3-0.1,0.3-0.3V470h-3.5v7.8h-0.9V470
				h-3.3v6.1h-0.9v-7h4.2v-2.4h-5.2v-0.9h5.2v-2.5h-3.1c-0.4,0.9-0.8,1.7-1.2,2.4c-0.2-0.1-0.6-0.3-0.9-0.4c1-1.4,1.7-3.4,2.2-5.5
				l1,0.2c-0.2,0.8-0.4,1.6-0.7,2.3h2.7v-3h0.9v3h4.5v0.9h-4.5L730.8,465.6L730.8,465.6z M738.8,472.4h-0.9v-11.2h0.9V472.4z
				 M742.5,459.2v16.9c0,0.9-0.2,1.2-0.8,1.4c-0.5,0.2-1.6,0.2-3.1,0.2c-0.1-0.3-0.2-0.8-0.4-1.1c1.3,0,2.5,0,2.9,0
				c0.3,0,0.4-0.1,0.4-0.5v-16.9H742.5z M749.1,474.5c0.5,0.1,0.9,0.5,1.8,1c1.3,0.7,3,0.8,5.2,0.8c2.5,0,5.8-0.1,7.9-0.4
				c-0.1,0.3-0.3,0.8-0.3,1.1c-1.8,0.1-5.5,0.2-7.6,0.2c-2.3,0-4.1-0.2-5.4-0.9c-0.8-0.5-1.4-1-1.8-1c-0.7,0-1.8,0.9-2.9,2.1
				l-0.7-0.9c1-0.9,2-1.7,2.9-2v-6.8h-2.9v-0.9h3.9v7.7H749.1z M749,463.9c-0.6-0.9-2-2.3-3.1-3.3l0.7-0.5c1.2,1,2.5,2.3,3.2,3.2
				L749,463.9z M763.6,466.9h-13.2V466h6.2v-3.2H753c-0.5,0.9-1.1,1.7-1.6,2.4c-0.2-0.1-0.6-0.4-0.8-0.5c1.2-1.3,2.3-3.3,2.9-5.2
				l0.9,0.2c-0.3,0.7-0.6,1.5-0.9,2.2h3.1v-2.7h1v2.7h5.1v0.9h-5.2v3.2h6L763.6,466.9L763.6,466.9z M752.1,474.5v-5.7h9.7v5.7H752.1
				z M753.1,473.5h7.8v-3.9h-7.8V473.5z M784.2,475v1h-18.3v-1h8.6v-12.6H767v-1h16.3v1h-7.8V475H784.2z M804.4,461.8h-15v5
				c0,3.2-0.3,7.8-2.3,10.9c-0.2-0.2-0.6-0.5-0.9-0.6c2-3,2.1-7.3,2.1-10.4v-6h16v1.1H804.4z"/>
		</g>
		<g>
			<path d="M630.8,395.6v25.3h-1.9v-25.3H630.8z"/>
			<path d="M644.5,421.2l-1-1.4c5.6-4,8.7-8.2,9.5-12.5c-2,1.3-3.8,1.9-5.6,1.9c-2,0-3.7-0.7-5-2c-1.4-1.3-2-3-2-4.9
				c0-2.1,0.7-3.7,2-5.1s3-2,5.1-2c2.4,0,4.3,0.8,5.7,2.4s2.1,3.7,2.1,6.5C655.2,410.5,651.6,416.1,644.5,421.2z M653.2,405.1
				c0-0.4,0.1-0.8,0.1-1.1c0-2.2-0.5-3.9-1.5-5.1s-2.4-1.8-4.2-1.8c-1.5,0-2.8,0.5-3.8,1.5s-1.5,2.2-1.5,3.7s0.5,2.7,1.5,3.8
				c1,1,2.2,1.5,3.7,1.5C649.6,407.5,651.5,406.8,653.2,405.1z"/>
			<path d="M663,421.2l-1-1.4c5.6-4,8.7-8.2,9.5-12.5c-2,1.3-3.8,1.9-5.6,1.9c-2,0-3.7-0.7-5-2c-1.4-1.3-2-3-2-4.9
				c0-2.1,0.7-3.7,2-5.1s3-2,5.1-2c2.4,0,4.3,0.8,5.7,2.4s2.1,3.7,2.1,6.5C673.7,410.5,670.2,416.1,663,421.2z M671.8,405.1
				c0-0.4,0.1-0.8,0.1-1.1c0-2.2-0.5-3.9-1.5-5.1s-2.4-1.8-4.2-1.8c-1.5,0-2.8,0.5-3.8,1.5s-1.5,2.2-1.5,3.7s0.5,2.7,1.5,3.8
				c1,1,2.2,1.5,3.7,1.5C668.1,407.5,670,406.8,671.8,405.1z"/>
			<path d="M681.5,421.2l-1-1.4c5.6-4,8.7-8.2,9.5-12.5c-2,1.3-3.8,1.9-5.6,1.9c-2,0-3.7-0.7-5-2c-1.4-1.3-2-3-2-4.9
				c0-2.1,0.7-3.7,2-5.1s3-2,5.1-2c2.4,0,4.3,0.8,5.7,2.4s2.1,3.7,2.1,6.5C692.3,410.5,688.7,416.1,681.5,421.2z M690.3,405.1
				c0-0.4,0.1-0.8,0.1-1.1c0-2.2-0.5-3.9-1.5-5.1s-2.4-1.8-4.2-1.8c-1.5,0-2.8,0.5-3.8,1.5s-1.5,2.2-1.5,3.7s0.5,2.7,1.5,3.8
				c1,1,2.2,1.5,3.7,1.5C686.6,407.5,688.6,406.8,690.3,405.1z"/>
		</g>
	</g>
				<g>
		<path class="st1" d="M547.2,434.1c-4.6,0-8.3,3.7-8.3,8.3c0,4.6,3.7,8.3,8.3,8.3s8.3-3.7,8.3-8.3S551.8,434.1,547.2,434.1z
			 M559,440.5h-4.2v4.2h4.2V440.5z M567.3,440.4h-4.2v4.2h4.2V440.4z M575.6,440.4h-4.1v4.2h4.2v-4.2H575.6z M583.9,440.4h-4.2v4.2
			h4.2V440.4z M592.2,440.4H588v4.2h4.2V440.4z M600.6,440.4h-4.2v4.2h4.2V440.4z"/>
					<path class="st2" d="M547.2,452.4c-5.4,0-9.8-4.4-9.8-9.8s4.4-9.8,9.8-9.8c4.1,0,7.7,2.6,9.2,6.2h2.7c0.8,0,1.5,0.7,1.5,1.5v4.2
			c0,0.8-0.7,1.5-1.5,1.5h-2.7C554.9,449.8,551.3,452.4,547.2,452.4z M547.2,435.6c-3.7,0-6.8,3-6.8,6.8c0,3.7,3,6.8,6.8,6.8
			c2.8,0,5.2-1.7,6.3-4.1c-0.1-0.2-0.1-0.4-0.1-0.6v-4.2c0-0.2,0-0.4,0.1-0.6C552.4,437.4,550,435.6,547.2,435.6z M557,443h0.5v-1.1
			H557c0,0.2,0,0.4,0,0.6C557,442.6,557,442.9,557,443z M600.5,446h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.1
			c0.8,0,1.5,0.7,1.5,1.5v4.2C602.1,445.4,601.4,446,600.5,446z M597.9,443h1.1v-1.1h-1.1V443z M592.2,446h-4.1
			c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.1c0.8,0,1.5,0.7,1.5,1.5v4.2C593.8,445.4,593.1,446,592.2,446z M589.6,443
			h1.1v-1.1h-1.1V443z M583.9,446h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2
			C585.5,445.4,584.8,446,583.9,446z M581.3,443h1.1v-1.1h-1.1V443z M575.6,446h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2
			c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C577.1,445.4,576.5,446,575.6,446z M573,443h1.1v-1.1H573V443z M567.3,446
			h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C568.8,445.4,568.2,446,567.3,446z
			 M564.7,443h1.1v-1.1h-1.1V443z"/>
	</g>
</g>
			<g class="a4 ani">
	<g>
		<g>
			<path d="M627.3,576c-0.4,2.9-1,5.2-1.9,7.1c2,2.3,5.1,2.8,8.9,2.8c0.6,0,5.1,0,6,0c-0.2,0.2-0.4,0.7-0.4,0.9h-5.6
				c-4,0-7.1-0.6-9.3-2.9c-0.8,1.4-1.7,2.5-2.7,3.3c-0.1-0.2-0.5-0.6-0.8-0.7c1.1-0.8,2-1.9,2.8-3.4c-0.8-1-1.4-2.3-1.9-3.9l0.8-0.4
				c0.4,1.4,0.9,2.5,1.5,3.4c0.7-1.5,1.2-3.4,1.5-5.5h-3.4c0.9-1.5,2.2-3.8,3.1-5.7h-4v-0.9h5.5c-0.9,1.8-2.1,4.1-3,5.7h2.1h0.2
				L627.3,576z M633,571.5h-4.2v-0.9h4.2v-1.8h0.9v1.8h4.5v2.7h1.6v0.8h-1.6v2.8h-4.5v1.9h4.9v0.8h-4.9v2.1h5.8v0.9h-5.8v2.5H633
				v-2.5h-5.5v-0.9h5.5v-2.1h-4.5v-0.8h4.5v-1.9h-4.4V576h4.4v-1.8h-5.7v-0.8h5.7V571.5z M634,571.5v1.9h3.5v-1.9H634z M637.5,574.2
				H634v1.9h3.5V574.2z M660.6,585.5v1h-18.1v-1h10c1.2-2.7,2.6-7.3,3.3-10.4l1.1,0.2c-0.9,3.2-2.2,7.5-3.4,10.2H660.6z
				 M659.8,573.8h-16.5v-1h16.5V573.8z M648.4,584.5c-0.4-2.5-1.3-6.2-2.1-9l1-0.2c0.9,2.9,1.8,6.6,2.1,9L648.4,584.5z M651.3,572.3
				c-0.2-0.9-0.6-2.3-1-3.3l0.9-0.3c0.4,1.1,0.9,2.4,1.1,3.3L651.3,572.3z M667.4,574.2c-0.7,2.9-1.9,6.6-3.9,8.9
				c-0.2-0.2-0.6-0.4-0.9-0.5c1.9-2.2,3.1-5.7,3.7-8.6L667.4,574.2z M672.7,569v16.8c0,0.9-0.3,1.3-0.9,1.4
				c-0.6,0.2-1.8,0.2-3.7,0.2c-0.1-0.3-0.3-0.7-0.4-1.1c1.6,0,3,0,3.5,0c0.4,0,0.5-0.1,0.5-0.5v-16.8L672.7,569L672.7,569z
				 M677.6,573.8c1.9,2.9,3.6,6.7,4.2,9.1l-1,0.4c-0.5-2.4-2.2-6.2-4.1-9.1L677.6,573.8z M702,585.8v0.9h-18.6v-0.9h9v-3.2h-6.8
				v-0.9h6.8v-2.7h1v2.7h6.4v0.9h-6.4v3.2H702z M687.6,574.8c-0.2,1.8-0.9,3.8-3,5.2c-0.1-0.2-0.5-0.6-0.7-0.7
				c1.9-1.3,2.5-2.9,2.7-4.5h-2.7v-0.9h2.8v-0.3v-2.9h-2.1v-0.9h9.2v0.9h-2.2v3.2h2.6v0.9h-2.6v4.7h-0.9v-4.7H687.6z M687.6,573.8h3
				v-3.2h-3v2.9V573.8z M696.7,576.8h-0.9V570h0.9V576.8z M700.6,578.2c0,0.7-0.2,1-0.7,1.2s-1.5,0.2-3,0.2c0-0.3-0.2-0.7-0.4-0.9
				c1.3,0,2.3,0,2.7,0c0.3,0,0.4-0.1,0.4-0.4v-9.4h0.9L700.6,578.2L700.6,578.2z M704.5,574.7c1.3,0.6,2.9,1.5,3.8,2.1l-0.6,0.8
				c-0.8-0.7-2.4-1.6-3.8-2.2L704.5,574.7z M708.4,579.8l0.7,0.6c-1.1,2.2-2.6,4.9-3.8,6.7l-0.8-0.7
				C705.7,584.8,707.3,582,708.4,579.8z M705.5,569c1.4,0.6,3.1,1.5,3.9,2.2l-0.6,0.8c-0.8-0.7-2.5-1.7-3.9-2.3L705.5,569z
				 M712.9,572.5c-0.6,2.6-1.6,5.2-2.7,7c-0.2-0.1-0.6-0.4-0.9-0.5c1.1-1.7,2-4.2,2.6-6.7L712.9,572.5z M721,578.5
				c-1.6,4.7-5.1,7.7-11.1,9c-0.1-0.3-0.4-0.6-0.6-0.9c5.9-1.2,9.2-4,10.8-8.4L721,578.5z M716.2,568.8v12.1h-1v-12.1H716.2z
				 M719.5,572c1.3,1.8,2.6,4.2,3.1,5.7l-0.9,0.4c-0.5-1.6-1.8-4-3-5.8L719.5,572z M740.4,577.3c-0.8,2.6-2.3,4.7-4.1,6.3
				c1.9,1.4,4.2,2.5,6.8,3c-0.2,0.2-0.5,0.6-0.6,0.9c-2.7-0.6-5-1.7-7-3.2c-1.9,1.5-4.2,2.5-6.6,3.2c-0.1-0.2-0.3-0.6-0.5-0.8
				c2.2-0.6,4.4-1.6,6.3-3c-1.5-1.3-2.7-2.9-3.6-4.8c-1.4,2.8-3.4,5.1-6.2,6.9c-0.1-0.2-0.5-0.5-0.7-0.7c3.8-2.5,6.2-6,7.5-10.5h-3
				c-1.4,0-2,0.1-2.2,0.3c-0.1-0.2-0.2-0.8-0.4-1c0.3-0.1,0.5-0.4,0.7-0.8c0.2-0.4,1-2.1,1.4-3.7l1.1,0.2c-0.4,1.4-1,2.9-1.5,4h4.2
				c0.4-1.5,0.7-3.2,0.9-4.9l1.1,0.2c-0.2,1.7-0.5,3.2-0.9,4.7h9.3v1h-9.6c-0.2,0.9-0.5,1.7-0.8,2.5h7.5l0.2-0.1L740.4,577.3z
				 M731.9,578c0.9,1.9,2.1,3.6,3.7,5c1.5-1.3,2.7-3,3.5-5H731.9z M740.2,572.8c-0.6-0.8-1.8-2.1-2.7-3.1l0.8-0.5
				c0.9,0.9,2.1,2.2,2.8,3L740.2,572.8z M751.4,575.3h5.3v0.9h-5.3v2.4h4.4v5.9c0,0.6-0.1,0.8-0.5,1s-1.2,0.2-2.4,0.2
				c-0.1-0.3-0.2-0.6-0.4-0.9c1.1,0,1.8,0,2.1,0c0.2,0,0.3-0.1,0.3-0.3v-4.9h-3.5v7.8h-0.9v-7.8h-3.3v6.1h-0.9v-7h4.2v-2.5h-5.2
				v-0.9h5.2v-2.5h-3.1c-0.4,0.9-0.8,1.7-1.2,2.4c-0.2-0.1-0.6-0.3-0.9-0.4c1-1.4,1.7-3.4,2.2-5.5l1,0.2c-0.2,0.8-0.4,1.6-0.7,2.3
				h2.7v-3h0.9v3h4.5v0.9h-4.5L751.4,575.3L751.4,575.3z M759.4,582h-0.9v-11.2h0.9V582z M763.1,568.8v16.9c0,0.9-0.2,1.2-0.8,1.4
				c-0.5,0.2-1.6,0.2-3.1,0.2c-0.1-0.3-0.2-0.8-0.4-1.1c1.3,0,2.5,0,2.9,0c0.3,0,0.4-0.1,0.4-0.5v-16.9L763.1,568.8L763.1,568.8z
				 M769.6,584.2c0.5,0.1,0.9,0.5,1.8,1c1.3,0.7,3,0.8,5.2,0.8c2.5,0,5.8-0.1,7.9-0.4c-0.1,0.3-0.3,0.8-0.3,1.1
				c-1.8,0.1-5.5,0.2-7.6,0.2c-2.3,0-4.1-0.2-5.4-0.9c-0.8-0.5-1.4-1-1.8-1c-0.7,0-1.8,0.9-2.9,2.1l-0.7-0.9c1-0.9,2-1.7,2.9-2v-6.8
				h-2.9v-0.9h3.9v7.7H769.6z M769.6,573.5c-0.6-0.9-2-2.3-3.1-3.3l0.7-0.5c1.2,1,2.5,2.3,3.2,3.2L769.6,573.5z M784.1,576.5h-13.2
				v-0.9h6.2v-3.2h-3.6c-0.5,0.9-1.1,1.7-1.6,2.4c-0.2-0.1-0.6-0.4-0.8-0.5c1.2-1.3,2.3-3.3,2.9-5.2l0.9,0.2
				c-0.3,0.7-0.6,1.5-0.9,2.2h3.1v-2.7h1v2.7h5.1v0.9h-5.1v3.2h6L784.1,576.5L784.1,576.5z M772.7,584.2v-5.7h9.7v5.7H772.7z
				 M773.7,583.2h7.8v-3.9h-7.8V583.2z M804.5,583.3h-7.6v4.1h-1v-4.1h-9.2v-1h9.2v-3.6h-5c-1.3,0-1.9,0.1-2.1,0.3
				c-0.1-0.2-0.2-0.8-0.4-1c0.4-0.1,0.8-0.7,1.4-1.7c0.4-0.5,1.1-1.9,1.9-3.5H787v-1h5.2c0.5-1,0.9-2,1.2-3.1l1.1,0.3
				c-0.4,0.9-0.8,1.8-1.2,2.7h10.9v1h-11.4c-0.9,1.8-1.9,3.5-2.8,5h5.9v-3.4h1v3.4h5.9v0.9h-5.9v3.6h7.6L804.5,583.3L804.5,583.3z
				 M808,573.2h1v14.3h-1V573.2z M809.1,569.2c0.9,0.8,2.1,2,2.6,2.8l-0.8,0.6c-0.5-0.8-1.6-2-2.5-2.9L809.1,569.2z M812.5,574.8
				h7.4v9.1h-7.4V574.8z M824.4,586c0,0.7-0.1,1-0.6,1.2s-1.3,0.2-2.5,0.2c-0.1-0.2-0.2-0.7-0.4-1c1,0,1.9,0,2.1,0
				c0.3,0,0.4-0.1,0.4-0.4V571h-10.1V570h11.1V586z M813.4,578.8h5.5v-3.2h-5.5V578.8z M813.4,583h5.5v-3.3h-5.5V583z"/>
		</g>
		<g>
			<path d="M639,599c-0.4,8.4-0.6,11.3-1.5,12.2c-0.4,0.5-0.8,0.6-1.5,0.6s-2,0-3.3-0.1c0-0.3-0.1-0.7-0.3-1
				c1.4,0.1,2.8,0.1,3.3,0.1s0.7,0,0.9-0.3c0.7-0.7,1-3.5,1.3-11.2h-7.7c-0.5,4.1-2.1,8.7-7.6,12.4c-0.2-0.2-0.5-0.5-0.8-0.7
				c5.3-3.5,6.9-7.9,7.4-11.7h-6.8v-1h6.9c0.1-1,0.1-1.9,0.1-2.8v-2.2h1v2.2c0,0.9,0,1.8-0.1,2.8h8.7L639,599L639,599z M626.6,597.5
				c-0.5-0.8-1.4-2.1-2.3-3.1l0.8-0.4c0.9,0.9,1.9,2.2,2.3,3L626.6,597.5z M634.2,607c-0.6-1.1-1.9-2.9-3.1-4.1l0.8-0.4
				c1.2,1.3,2.5,2.9,3.1,4.1L634.2,607z M648.2,593.8h1v18.1h-1V607c-2,0.8-4,1.7-5.6,2.4l-0.5-0.9c1.5-0.5,3.8-1.5,6.1-2.4v-6.3
				h-5.5v-1h5.5V593.8z M658.9,610.7c1.1,0,1.2-0.9,1.3-4.4c0.3,0.2,0.7,0.4,0.9,0.5c-0.1,3.6-0.4,4.9-2.2,4.9h-3.6
				c-1.6,0-2.2-0.5-2.2-2.3v-15.5h1v7.3c2.1-1.3,4.3-2.8,5.6-4.1l0.8,0.8c-1.7,1.4-4.2,2.9-6.4,4.2v7.2c0,1.1,0.2,1.3,1.2,1.3
				L658.9,610.7L658.9,610.7z M672.3,611.2h-8.8V595h8.8v0.9h-7.8v14.4h7.9v1H672.3z M671,608.5c-0.5-1.2-1.3-2.7-2.2-4.2
				c-1,1.9-2.2,3.6-3.4,4.9c-0.2-0.2-0.6-0.5-0.8-0.6c1.4-1.4,2.6-3.2,3.6-5.3c-1.1-1.7-2.3-3.5-3.5-5l0.8-0.4
				c1.1,1.4,2.2,2.9,3.2,4.5c0.8-1.7,1.5-3.5,2.1-5.3l0.9,0.2c-0.7,2.1-1.5,4.1-2.4,6c1.1,1.7,2.1,3.4,2.6,4.7L671,608.5z
				 M674.5,598c-0.5,1.6-1.2,3.1-1.9,4.2c-0.2-0.1-0.6-0.4-0.9-0.5c1.4-2,2.3-5,2.8-8.2l1,0.1c-0.2,1.2-0.4,2.3-0.7,3.3h5.9h0.2
				l0.6,0.2c-0.3,1.7-0.9,3.8-1.4,5l-0.8-0.2c0.4-1,0.8-2.6,1.1-4h-5.9V598z M676.9,600.7c0,0.6,0,1.2,0,1.8c0.7,4.3,2,6.7,4.6,8.9
				c-0.2,0.2-0.5,0.5-0.7,0.8c-2.2-1.9-3.4-4-4.2-7c-0.4,2.4-1.4,4.9-3.5,7.1c-0.2-0.2-0.5-0.5-0.7-0.7c3.4-3.5,3.6-7.9,3.6-10.9
				v-1.3h0.9L676.9,600.7L676.9,600.7z M699.4,594.7c0,9.3,0,16.3,1.5,16.3c0.3,0,0.5-1.4,0.5-3.1c0.2,0.2,0.5,0.5,0.7,0.6
				c-0.1,2.8-0.4,3.5-1.3,3.5c-2.4,0-2.4-5.7-2.4-16.3h-11.6v5.3c0,3.3-0.3,8-2.7,11.2c-0.2-0.2-0.6-0.6-0.8-0.7
				c2.2-3.1,2.5-7.4,2.5-10.6v-6.3L699.4,594.7L699.4,594.7z M696.1,597.5c-0.7,2.1-1.5,4.1-2.6,6c1.6,2.1,3.2,4.1,4.1,5.7l-0.9,0.6
				c-0.8-1.4-2.2-3.3-3.7-5.3c-1.4,2.3-3.1,4.2-4.8,5.5c-0.2-0.2-0.6-0.6-0.8-0.8c1.8-1.2,3.5-3.2,5-5.5c-1.3-1.7-2.7-3.4-4.1-4.9
				l0.8-0.5c1.2,1.4,2.5,2.9,3.8,4.5c1-1.7,1.8-3.6,2.4-5.4L696.1,597.5z M703.7,602.7c0.5-1.4,0.8-3.6,1-5.2l0.8,0.1
				c-0.1,1.6-0.4,3.9-0.9,5.4L703.7,602.7z M706.2,593.5h0.9V612h-0.9V593.5z M708.4,596.7c0.5,0.9,0.9,2.2,1.1,2.9l-0.8,0.4
				c-0.2-0.8-0.6-2.1-1.1-3L708.4,596.7z M722.6,600.2v0.8h-13.4v-0.8h6.1v-1.8h-5v-0.8h5v-1.6h-5.5v-0.8h5.5v-1.7h1v1.7h5.7v0.8
				h-5.7v1.6h5.2v0.8h-5.2v1.8L722.6,600.2L722.6,600.2z M720.8,610.8c0,0.6-0.1,0.9-0.6,1.1c-0.5,0.2-1.4,0.2-2.8,0.1
				c0-0.2-0.2-0.6-0.3-0.9c1.2,0,2.2,0,2.4,0c0.3,0,0.4-0.1,0.4-0.4v-2h-8.2v3.3h-0.9v-9.6h10.1v8.4H720.8z M711.7,603.3v1.9h8.2
				v-1.9H711.7z M719.9,608v-2h-8.2v2H719.9z M730.8,600h5.3v0.9h-5.3v2.4h4.4v5.9c0,0.6-0.1,0.8-0.5,1s-1.2,0.2-2.4,0.2
				c-0.1-0.3-0.2-0.6-0.4-0.9c1.1,0,1.8,0,2.1,0c0.2,0,0.3-0.1,0.3-0.3v-4.9h-3.5v7.8h-0.9v-7.8h-3.3v6.1h-0.9v-7h4.2V601h-5.2v-0.9
				h5.2v-2.5h-3.1c-0.4,0.9-0.8,1.7-1.2,2.4c-0.2-0.1-0.6-0.3-0.9-0.4c1-1.4,1.7-3.4,2.2-5.5l1,0.2c-0.2,0.8-0.4,1.6-0.7,2.3h2.7v-3
				h0.9v3h4.5v0.9h-4.5L730.8,600L730.8,600z M738.8,606.8h-0.9v-11.2h0.9V606.8z M742.5,593.5v16.9c0,0.9-0.2,1.2-0.8,1.4
				c-0.5,0.2-1.6,0.2-3.1,0.2c-0.1-0.3-0.2-0.8-0.4-1.1c1.3,0,2.5,0,2.9,0c0.3,0,0.4-0.1,0.4-0.5v-16.9L742.5,593.5L742.5,593.5z
				 M749.1,609c0.5,0.1,0.9,0.5,1.8,1c1.3,0.7,3,0.8,5.2,0.8c2.5,0,5.8-0.1,7.9-0.4c-0.1,0.3-0.3,0.8-0.3,1.1
				c-1.8,0.1-5.5,0.2-7.6,0.2c-2.3,0-4.1-0.2-5.4-0.9c-0.8-0.5-1.4-1-1.8-1c-0.7,0-1.8,0.9-2.9,2.1l-0.7-0.9c1-0.9,2-1.7,2.9-2v-6.7
				h-2.9v-0.9h3.9v7.6H749.1z M749,598.2c-0.6-0.9-2-2.3-3.1-3.3l0.7-0.5c1.2,1,2.5,2.3,3.2,3.2L749,598.2z M763.6,601.2h-13.2v-0.9
				h6.2v-3.2H753c-0.5,0.9-1.1,1.7-1.6,2.4c-0.2-0.1-0.6-0.4-0.8-0.5c1.2-1.3,2.3-3.3,2.9-5.2l0.9,0.2c-0.3,0.7-0.6,1.5-0.9,2.2h3.1
				v-2.7h1v2.7h5.1v0.9h-5.2v3.2h6L763.6,601.2L763.6,601.2z M752.1,608.8v-5.7h9.7v5.7H752.1z M753.1,608h7.8V604h-7.8V608z
				 M766.2,599.3c1.3,0.6,2.9,1.5,3.8,2.1l-0.6,0.8c-0.8-0.7-2.4-1.6-3.8-2.2L766.2,599.3z M770.2,604.5l0.7,0.6
				c-1.1,2.2-2.6,4.9-3.8,6.7l-0.8-0.7C767.4,609.5,769,606.8,770.2,604.5z M767.3,593.8c1.4,0.6,3.1,1.5,3.9,2.2l-0.6,0.8
				c-0.8-0.7-2.5-1.7-3.9-2.3L767.3,593.8z M774.6,597.2c-0.6,2.6-1.6,5.2-2.7,7c-0.2-0.1-0.6-0.4-0.9-0.5c1.1-1.7,2-4.2,2.6-6.7
				L774.6,597.2z M782.8,603.2c-1.6,4.7-5.1,7.7-11.1,9c-0.1-0.3-0.4-0.6-0.6-0.9c5.9-1.2,9.2-4,10.8-8.4L782.8,603.2z M778,593.5
				v12.1h-1v-12.1H778z M781.3,596.8c1.3,1.8,2.6,4.2,3.1,5.7l-0.9,0.4c-0.5-1.6-1.8-4-3-5.8L781.3,596.8z M802.2,602
				c-0.8,2.6-2.3,4.7-4.1,6.3c1.9,1.4,4.2,2.5,6.8,3c-0.2,0.2-0.5,0.6-0.6,0.9c-2.7-0.6-5-1.7-7-3.2c-1.9,1.5-4.2,2.5-6.6,3.2
				c-0.1-0.2-0.3-0.6-0.5-0.8c2.2-0.6,4.4-1.6,6.3-3c-1.5-1.3-2.7-2.9-3.6-4.8c-1.4,2.8-3.4,5.1-6.2,6.9c-0.1-0.2-0.5-0.5-0.7-0.7
				c3.8-2.5,6.2-6,7.5-10.5h-3c-1.4,0-2,0.1-2.2,0.3c-0.1-0.2-0.2-0.8-0.4-1c0.3-0.1,0.5-0.4,0.7-0.8c0.2-0.4,1-2.1,1.4-3.7l1.1,0.2
				c-0.4,1.4-1,2.9-1.5,4h4.2c0.4-1.5,0.7-3.2,0.9-4.9l1.1,0.2c-0.2,1.7-0.5,3.2-0.9,4.7h9.3v1h-9.6c-0.2,0.9-0.5,1.7-0.8,2.5h7.5
				l0.2-0.1L802.2,602z M793.6,602.8c0.9,1.9,2.1,3.6,3.7,5c1.5-1.3,2.7-3,3.5-5H793.6z M802,597.5c-0.6-0.8-1.8-2.1-2.7-3.1
				l0.8-0.5c0.9,0.9,2.1,2.2,2.8,3L802,597.5z"/>
		</g>
		<g>
			<path d="M630.8,529v25.3h-1.9V529H630.8z"/>
			<path d="M644.5,554.7l-1-1.4c5.6-4,8.7-8.2,9.5-12.5c-2,1.3-3.8,1.9-5.6,1.9c-2,0-3.7-0.7-5-2c-1.4-1.3-2-3-2-4.9
				c0-2.1,0.7-3.7,2-5.1c1.3-1.3,3-2,5.1-2c2.4,0,4.3,0.8,5.7,2.4c1.4,1.6,2.1,3.7,2.1,6.5C655.2,543.8,651.6,549.5,644.5,554.7z
				 M653.2,538.5c0-0.4,0.1-0.8,0.1-1.1c0-2.2-0.5-3.9-1.5-5.1c-1-1.2-2.4-1.8-4.2-1.8c-1.5,0-2.8,0.5-3.8,1.5s-1.5,2.2-1.5,3.7
				s0.5,2.7,1.5,3.8c1,1,2.2,1.5,3.7,1.5C649.6,541,651.5,540.2,653.2,538.5z"/>
			<path d="M663,554.7l-1-1.4c5.6-4,8.7-8.2,9.5-12.5c-2,1.3-3.8,1.9-5.6,1.9c-2,0-3.7-0.7-5-2c-1.4-1.3-2-3-2-4.9
				c0-2.1,0.7-3.7,2-5.1c1.3-1.3,3-2,5.1-2c2.4,0,4.3,0.8,5.7,2.4c1.4,1.6,2.1,3.7,2.1,6.5C673.7,543.8,670.2,549.5,663,554.7z
				 M671.8,538.5c0-0.4,0.1-0.8,0.1-1.1c0-2.2-0.5-3.9-1.5-5.1c-1-1.2-2.4-1.8-4.2-1.8c-1.5,0-2.8,0.5-3.8,1.5s-1.5,2.2-1.5,3.7
				s0.5,2.7,1.5,3.8c1,1,2.2,1.5,3.7,1.5C668.1,541,670,540.2,671.8,538.5z"/>
			<path d="M693.8,529l-11.6,25.6l-1.6-0.7l10.4-23.2h-13.8v-1.8h16.6V529z"/>
		</g>
	</g>
				<g>
		<path class="st1" d="M547.2,571.2c-4.6,0-8.3,3.7-8.3,8.3s3.7,8.3,8.3,8.3s8.3-3.7,8.3-8.3C555.5,575,551.8,571.2,547.2,571.2z
			 M559,577.5h-4.2v4.2h4.2V577.5z M567.3,577.5h-4.2v4.2h4.2V577.5z M575.6,577.5h-4.1v4.2h4.2v-4.2H575.6z M583.9,577.5h-4.2v4.2
			h4.2V577.5z M592.2,577.5H588v4.2h4.2V577.5z M600.6,577.5h-4.2v4.2h4.2V577.5z"/>
					<path class="st2" d="M547.2,589.5c-5.4,0-9.8-4.4-9.8-9.8c0-5.4,4.4-9.8,9.8-9.8c4.1,0,7.7,2.6,9.2,6.2h2.7c0.8,0,1.5,0.7,1.5,1.5
			v4.2c0,0.8-0.7,1.5-1.5,1.5h-2.7C554.9,586.8,551.3,589.5,547.2,589.5z M547.2,572.8c-3.7,0-6.8,3-6.8,6.8s3,6.8,6.8,6.8
			c2.8,0,5.2-1.7,6.3-4.1c-0.1-0.2-0.1-0.4-0.1-0.6v-4.2c0-0.2,0-0.4,0.1-0.6C552.4,574.5,550,572.8,547.2,572.8z M557,580.2h0.5
			v-1.1H557c0,0.2,0,0.4,0,0.6C557,579.8,557,580,557,580.2z M600.5,583.2h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5
			h4.1c0.8,0,1.5,0.7,1.5,1.5v4.2C602.1,582.5,601.4,583.2,600.5,583.2z M597.9,580.2h1.1v-1.1h-1.1V580.2z M592.2,583.2h-4.1
			c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.1c0.8,0,1.5,0.7,1.5,1.5v4.2C593.8,582.5,593.1,583.2,592.2,583.2z
			 M589.6,580.2h1.1v-1.1h-1.1V580.2z M583.9,583.2h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2
			c0.8,0,1.5,0.7,1.5,1.5v4.2C585.5,582.5,584.8,583.2,583.9,583.2z M581.3,580.2h1.1v-1.1h-1.1V580.2z M575.6,583.2h-4.1
			c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C577.1,582.5,576.5,583.2,575.6,583.2z
			 M573,580.2h1.1v-1.1H573V580.2z M567.3,583.2h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5
			v4.2C568.8,582.5,568.2,583.2,567.3,583.2z M564.7,580.2h1.1v-1.1h-1.1V580.2z"/>
	</g>
</g>
			<g class="a7 ani">
	<g>
		<g>
			<path d="M956.5,356.5c0,0,0,0.3,0,0.4c-0.2,2.4-0.5,3.4-0.8,3.7c-0.3,0.3-0.6,0.4-1,0.4s-1.3,0-2.2-0.1c0-0.2-0.1-0.6-0.2-0.8
				c0.9,0.1,1.8,0.1,2.1,0.1s0.5,0,0.6-0.1c0.2-0.2,0.4-1,0.6-2.8h-3.3c-0.6,1.9-1.7,3.1-4,3.9c-0.1-0.2-0.4-0.5-0.6-0.7
				c2.1-0.7,3.1-1.7,3.7-3.2h-3v-0.8h3.2c0.1-0.5,0.2-0.9,0.2-1.5h0.9c-0.1,0.5-0.1,1-0.2,1.5H956.5z M965.8,344v0.8h-8.5v1.5h7.1
				v0.8h-15.1v-0.8h7v-1.5H948V344h8.3v-1.5h1v1.5H965.8z M961,352.4c-0.3,0.5-0.7,1.1-1,1.5h5.6v0.8H948v-0.8h5.7
				c-0.2-0.5-0.6-1.2-1.1-1.6l0.6-0.2h-3v-3.6h13.4v3.6h-3.5L961,352.4z M951.2,351.4h11.5v-2h-11.5V351.4z M953.6,352.1
				c0.5,0.5,0.9,1.1,1.1,1.5l-0.8,0.3h5.1c0.4-0.6,0.8-1.3,1.1-1.8H953.6z M957.9,356h6.9v5.1h-0.9v-0.7h-5v0.8H958L957.9,356
				L957.9,356z M958.8,356.8v2.8h5v-2.8H958.8z M974.7,355.2c-1.3,2-3.6,4.3-5.7,5.7c-0.2-0.2-0.5-0.6-0.8-0.7
				c2-1.4,4.3-3.5,5.4-5.4L974.7,355.2z M986.5,352.5v1h-18.2v-1H986.5z M969.4,344.5c1.4,1.8,2.7,4.3,3.3,5.9l-0.9,0.4
				c-0.6-1.6-1.9-4.1-3.2-6L969.4,344.5z M975.6,343c1.1,2,2.1,4.5,2.4,6.2l-1,0.3c-0.3-1.7-1.3-4.3-2.3-6.2L975.6,343z M980.9,355
				c1.9,1.7,4.3,4,5.6,5.5l-0.8,0.5c-1.2-1.4-3.6-3.9-5.6-5.6L980.9,355z M986.1,343.9c-1.3,2.6-3.3,5.9-4.8,8l-0.9-0.4
				c1.5-2.1,3.6-5.5,4.7-8L986.1,343.9z M1004.1,353.4c-1.1,1.9-2.9,3.4-5,4.6c2.4,1.2,5.2,1.9,8.4,2.2c-0.2,0.2-0.5,0.6-0.6,0.9
				c-3.4-0.4-6.4-1.3-8.9-2.6c-2.7,1.3-5.8,2.2-8.8,2.7c-0.1-0.3-0.3-0.7-0.4-0.9c2.8-0.4,5.7-1.1,8.2-2.3c-1.5-0.9-2.8-2.1-3.7-3.5
				c-1.1,0.8-2.3,1.6-3.7,2.3c-0.2-0.2-0.5-0.5-0.7-0.7c3-1.4,5.3-3.3,6.6-4.9h-6.6v-0.9h8.6v-2.2h-6.4v-0.8h6.4v-2h-7.6v-1h7.6
				v-1.7h1v1.7h7.8v0.9h-7.8v2h6.7v0.8h-6.7v2.2h8.7v0.9h-10.3c-0.5,0.6-1.1,1.3-1.8,1.9h8.1l0.2-0.1L1004.1,353.4z M994.1,353.9
				c0.9,1.4,2.3,2.6,4,3.6c1.8-1,3.4-2.1,4.5-3.6H994.1z M1009.6,360.8c1-0.8,1.9-2.2,2.4-3.5l0.9,0.2c-0.6,1.3-1.5,2.8-2.5,3.7
				L1009.6,360.8z M1016,343.5c1.1,1,2.4,2.5,2.9,3.5l-0.8,0.5c-0.2-0.3-0.4-0.7-0.7-1.1c-6.3,0.5-7,0.6-7.4,0.8
				c0-0.2-0.2-0.7-0.3-0.9c0.3,0,0.6-0.3,1-0.6c0.4-0.4,1.7-1.8,2.6-3.2l0.9,0.4c-0.9,1.2-1.9,2.4-2.9,3.3l5.5-0.4
				c-0.5-0.6-1.1-1.2-1.6-1.7L1016,343.5z M1017.7,355c0,0.6-0.1,0.9-0.6,1c-0.5,0.2-1.4,0.2-2.8,0.2c-0.1-0.3-0.2-0.6-0.4-0.8
				c1.3,0,2.2,0,2.5,0s0.4-0.1,0.4-0.4v-1.7h-4.9v3.1h-0.9v-8.6h6.8L1017.7,355L1017.7,355z M1011.8,348.6v1.6h4.9v-1.6H1011.8z
				 M1016.7,352.6V351h-4.9v1.6H1016.7z M1016.4,357.6c0.3,1.1,0.5,2.4,0.5,3.2l-0.9,0.1c0-0.8-0.2-2.2-0.4-3.3L1016.4,357.6z
				 M1020.8,357.5c0.5,1,1,2.4,1.2,3.2l-0.9,0.2c-0.2-0.8-0.7-2.2-1.2-3.3L1020.8,357.5z M1022,349.2c-1.6,0-2.1-0.3-2.1-1.5v-5.2
				h0.9v2.6c1.8-0.5,3.8-1.1,5-1.6l0.7,0.7c-1.5,0.6-3.7,1.3-5.7,1.7v1.8c0,0.5,0.2,0.6,1.2,0.6h3.7c0.8,0,0.9-0.3,1-2
				c0.2,0.2,0.6,0.3,0.9,0.4c-0.1,2-0.4,2.5-1.8,2.5H1022z M1025.9,355.5c0.8,0,0.9-0.2,1-2c0.2,0.2,0.6,0.3,0.9,0.4
				c-0.1,2-0.5,2.5-1.8,2.5h-3.9c-1.7,0-2.1-0.3-2.1-1.5v-5.3h0.9v2.5c1.8-0.5,3.9-1.1,5-1.7l0.7,0.7c-1.4,0.7-3.8,1.4-5.7,1.9v1.9
				c0,0.5,0.2,0.6,1.2,0.6H1025.9z M1025,357.4c1,1,2.2,2.5,2.7,3.4l-0.9,0.4c-0.5-0.9-1.6-2.4-2.6-3.5L1025,357.4z M1048.3,358.5v1
				H1030v-1h8.6v-12.6h-7.5v-1h16.3v1h-7.7v12.6H1048.3z M1068.6,345.1h-15v5c0,3.2-0.3,7.8-2.3,10.9c-0.2-0.2-0.6-0.5-0.9-0.6
				c2-3,2.1-7.3,2.1-10.4v-6h16v1.1H1068.6z M1077.4,352.6c-0.8,0.3-1.6,0.5-2.3,0.7v6.3c0,0.7-0.2,1-0.6,1.1
				c-0.5,0.2-1.2,0.2-2.6,0.2c-0.1-0.2-0.2-0.6-0.4-0.9c1.1,0,2,0,2.2,0c0.3,0,0.4-0.1,0.4-0.4v-6c-1.1,0.3-2.1,0.6-2.9,0.9l-0.4-1
				c0.9-0.2,2-0.6,3.3-0.9v-4.9h-3v-0.9h3v-4.3h1v4.3h2.8v0.9h-2.8v4.6l2.2-0.7L1077.4,352.6z M1088,352c-0.9,2.4-2.4,4.4-4.3,5.8
				c1.6,1.2,3.6,2,5.9,2.5c-0.2,0.2-0.5,0.6-0.6,0.9c-2.3-0.6-4.3-1.5-6-2.8c-1.9,1.3-4.1,2.2-6.3,2.8c-0.1-0.3-0.3-0.7-0.5-0.9
				c2.1-0.5,4.2-1.3,6.1-2.6c-1.6-1.4-2.8-3.1-3.7-5.2h-0.7v-0.9h9.4l0.2-0.1L1088,352z M1080.9,345.5c0,1.8-0.5,3.9-2.9,5.4
				c-0.1-0.2-0.4-0.6-0.6-0.7c2.2-1.4,2.6-3.2,2.6-4.7v-2.3h6.1v4.9c0,0.6,0.1,0.8,0.4,0.8h1.9c0.2,0,0.7,0,0.9-0.1
				c0,0.2,0.1,0.7,0.1,0.9c-0.2,0.1-0.7,0.1-1,0.1h-1.9c-1.1,0-1.3-0.4-1.3-1.7v-4h-4.2L1080.9,345.5L1080.9,345.5z M1079.5,352.6
				c0.8,1.8,2,3.3,3.5,4.6c1.6-1.2,2.9-2.7,3.7-4.6H1079.5z M1109.6,351.2h-15.2v1.8c0,2.4-0.3,5.8-2.1,8.2
				c-0.2-0.2-0.6-0.5-0.8-0.6c1.6-2.3,1.9-5.4,1.9-7.6v-2.8h9.8c0.6-1,1.4-2.6,1.8-3.6l1,0.4c-0.5,1.1-1.2,2.3-1.9,3.3h5.5
				L1109.6,351.2L1109.6,351.2z M1109,346.1h-16v-0.9h8.1c-0.3-0.7-0.9-1.6-1.5-2.4l0.9-0.3c0.7,0.8,1.3,1.8,1.6,2.5l-0.4,0.2h7.2
				v0.9H1109z M1098.1,350c-0.3-0.8-1.1-2.1-1.8-3l0.8-0.3c0.7,0.9,1.5,2.2,1.9,3L1098.1,350z"/>
		</g>
		<g>
			<path d="M966,377h-4.8v9h-1v-9h-6.4c-0.2,3.3-1.3,6.6-5.2,9c-0.2-0.2-0.5-0.6-0.7-0.7c3.7-2.3,4.7-5.3,4.9-8.3h-5v-0.9h5.1
				c0-0.4,0-0.7,0-1.1v-5.3h-4.4v-0.9h16.8v0.9h-4.1v6.4h4.8V377z M960.2,376v-6.4h-6.3v5.3c0,0.4,0,0.7,0,1.1H960.2z M971.4,375.5
				c0,3.1-0.5,7.4-2.6,10.4c-0.2-0.2-0.6-0.6-0.8-0.7c2.2-3,2.5-7.2,2.5-10.2v-4.8h14.3v5.3L971.4,375.5L971.4,375.5z M971.4,371.1
				v3.4h12.4v-3.4H971.4z M985,378v7.7h-1v-1.4h-10.4v1.5h-1v-7.7H985V378z M984,383.4v-4.3h-10.4v4.3H984z M977.2,367.1
				c0.6,0.8,1.2,2,1.5,2.7l-0.9,0.4c-0.3-0.7-0.9-1.9-1.4-2.7L977.2,367.1z M996.8,379.6c-2.8,0.8-5.8,1.6-7.9,2.2l-0.3-1
				c1-0.2,2.2-0.6,3.5-0.9v-9.3h-3.3v-0.9h7.4v0.9H993v9c1.2-0.3,2.4-0.7,3.6-1L996.8,379.6z M1007,372c0,0,0,0.4,0,0.6
				c-0.4,8.6-0.7,11.5-1.5,12.4c-0.4,0.5-0.8,0.6-1.5,0.6c-0.6,0-1.9,0-3.1-0.1c0-0.3-0.1-0.7-0.3-1c1.4,0.1,2.6,0.1,3,0.1
				c0.5,0,0.7-0.1,0.9-0.3c0.7-0.7,1.1-3.6,1.4-11.4h-4.9c-0.4,5.4-1.5,10.2-6.4,12.8c-0.1-0.2-0.5-0.6-0.7-0.7
				c4.6-2.4,5.8-6.9,6.1-12.1h-3.7v-1h3.8c0.1-1.5,0.1-3,0.1-4.5h1c0,1.5,0,3-0.1,4.5h5.9V372z M1015.6,368.5
				c1.1,1.4,2.3,3.2,2.8,4.5l-0.8,0.4c-0.1-0.3-0.3-0.7-0.5-1.1c-6.1,0.4-6.7,0.5-7.1,0.6c0-0.2-0.2-0.7-0.3-1
				c0.3,0,0.6-0.4,0.9-0.8c0.4-0.4,1.6-2.1,2.3-3.8l1,0.4c-0.8,1.5-1.8,3-2.7,4.1l5.5-0.3c-0.5-0.9-1.2-1.8-1.8-2.6L1015.6,368.5z
				 M1017.6,384.5c0,0.7-0.1,0.9-0.6,1.1s-1.4,0.2-2.7,0.2c0-0.3-0.2-0.7-0.4-1c1.1,0,2,0,2.3,0s0.4-0.1,0.4-0.3v-3h-5.1v4.3h-0.9
				v-11.4h7V384.5z M1011.5,375.4v2.2h5.1v-2.2H1011.5z M1016.6,380.6v-2.3h-5.1v2.3H1016.6z M1021.9,376c-1.7,0-2.2-0.3-2.2-1.7
				v-7.2h1v3.8c2-0.6,4.1-1.4,5.4-2.1l0.7,0.7c-1.6,0.7-4,1.5-6.1,2.1v2.6c0,0.6,0.2,0.8,1.2,0.8h3.9c0.9,0,1-0.4,1.1-2.5
				c0.2,0.2,0.6,0.3,0.9,0.4c-0.1,2.4-0.5,3-2,3h-3.9V376z M1025.9,384.8c0.9,0,1.1-0.4,1.2-2.9c0.2,0.2,0.6,0.3,0.9,0.4
				c-0.1,2.7-0.5,3.4-2,3.4h-4c-1.7,0-2.2-0.3-2.2-1.7v-7.2h1v3.5c2.1-0.6,4.4-1.4,5.7-2.3l0.7,0.8c-1.6,0.9-4.2,1.8-6.4,2.3v2.9
				c0,0.6,0.2,0.8,1.3,0.8L1025.9,384.8L1025.9,384.8z M1030.4,373c1.3,0.6,2.9,1.5,3.8,2.1l-0.6,0.8c-0.8-0.7-2.4-1.6-3.8-2.2
				L1030.4,373z M1034.4,378.1l0.7,0.6c-1.1,2.2-2.6,4.9-3.8,6.7l-0.8-0.7C1031.6,383.4,1033.2,380.5,1034.4,378.1z M1031.5,367.5
				c1.4,0.6,3.1,1.5,3.9,2.2l-0.6,0.8c-0.8-0.7-2.5-1.7-3.9-2.3L1031.5,367.5z M1038.8,371c-0.6,2.6-1.6,5.2-2.7,7
				c-0.2-0.1-0.6-0.4-0.9-0.5c1.1-1.7,2-4.2,2.6-6.7L1038.8,371z M1046.9,377c-1.6,4.7-5.1,7.7-11.1,9c-0.1-0.3-0.4-0.6-0.6-0.9
				c5.9-1.2,9.2-4,10.8-8.4L1046.9,377z M1042.1,367.4v12.1h-1v-12.1H1042.1z M1045.5,370.5c1.3,1.8,2.6,4.2,3.1,5.7l-0.9,0.4
				c-0.5-1.6-1.8-4-3-5.8L1045.5,370.5z M1066.4,375.8c-0.8,2.6-2.3,4.7-4.1,6.3c1.9,1.4,4.2,2.5,6.8,3c-0.2,0.2-0.5,0.6-0.6,0.9
				c-2.7-0.6-5-1.7-7-3.2c-1.9,1.5-4.2,2.5-6.6,3.2c-0.1-0.2-0.3-0.6-0.5-0.8c2.2-0.6,4.4-1.6,6.3-3c-1.5-1.3-2.7-2.9-3.6-4.8
				c-1.4,2.8-3.4,5.1-6.2,6.9c-0.1-0.2-0.5-0.5-0.7-0.7c3.8-2.5,6.2-6,7.5-10.5h-3c-1.4,0-2,0.1-2.2,0.3c-0.1-0.2-0.2-0.8-0.4-1
				c0.3-0.1,0.5-0.4,0.7-0.8s1-2.1,1.4-3.7l1.1,0.2c-0.4,1.4-1,2.9-1.5,4h4.2c0.4-1.5,0.7-3.2,0.9-4.9l1.1,0.2
				c-0.2,1.7-0.5,3.2-0.9,4.7h9.3v1h-9.6c-0.2,0.9-0.5,1.7-0.8,2.5h7.5l0.2-0.1L1066.4,375.8z M1057.8,376.5c0.9,1.9,2.1,3.6,3.7,5
				c1.5-1.3,2.7-3,3.5-5H1057.8z M1066.1,371.2c-0.6-0.8-1.8-2.1-2.7-3.1l0.8-0.5c0.9,0.9,2.1,2.2,2.8,3L1066.1,371.2z
				 M1071.2,368.5h7.1v0.9h-3.3c-0.4,1.9-0.8,3.7-1.4,5.4h4.3v8.5h-4.3v1.7h-0.9v-8.1c-0.4,0.7-0.8,1.4-1.2,2.1
				c-0.1-0.2-0.4-0.7-0.6-0.9c1.5-2.1,2.5-5.2,3.1-8.6h-2.8L1071.2,368.5L1071.2,368.5z M1073.6,375.6v6.7h3.4v-6.7H1073.6z
				 M1089.7,376.8h-2.4v9.1h-0.9v-9.1h-4c-0.1,3.2-0.5,6.6-2.9,9.2c-0.2-0.2-0.6-0.5-0.8-0.6c2.3-2.4,2.8-5.7,2.8-8.6h-2.5v-0.9h2.5
				v-6.4h-1.9v-0.9h9.8v0.9h-2v6.4h2.4L1089.7,376.8L1089.7,376.8z M1086.3,375.8v-6.4h-4v6.4H1086.3z M1107.5,375.8
				c-0.8,2.6-2.3,4.7-4.1,6.3c1.9,1.4,4.2,2.5,6.8,3c-0.2,0.2-0.5,0.6-0.6,0.9c-2.7-0.6-5-1.7-7-3.2c-1.9,1.5-4.2,2.5-6.6,3.2
				c-0.1-0.2-0.3-0.6-0.5-0.8c2.2-0.6,4.4-1.6,6.3-3c-1.5-1.3-2.7-2.9-3.6-4.8c-1.4,2.8-3.4,5.1-6.2,6.9c-0.1-0.2-0.5-0.5-0.7-0.7
				c3.8-2.5,6.2-6,7.5-10.5h-3c-1.4,0-2,0.1-2.2,0.3c-0.1-0.2-0.2-0.8-0.4-1c0.3-0.1,0.5-0.4,0.7-0.8s1-2.1,1.4-3.7l1.1,0.2
				c-0.4,1.4-1,2.9-1.5,4h4.2c0.4-1.5,0.7-3.2,0.9-4.9l1.1,0.2c-0.2,1.7-0.5,3.2-0.9,4.7h9.3v1h-9.6c-0.2,0.9-0.5,1.7-0.8,2.5h7.5
				l0.2-0.1L1107.5,375.8z M1099,376.5c0.9,1.9,2.1,3.6,3.7,5c1.5-1.3,2.7-3,3.5-5H1099z M1107.3,371.2c-0.6-0.8-1.8-2.1-2.7-3.1
				l0.8-0.5c0.9,0.9,2.1,2.2,2.8,3L1107.3,371.2z M1118.5,373.8h5.3v0.9h-5.3v2.4h4.4v5.9c0,0.6-0.1,0.8-0.5,1s-1.2,0.2-2.4,0.2
				c-0.1-0.3-0.2-0.6-0.4-0.9c1.1,0,1.8,0,2.1,0c0.2,0,0.3-0.1,0.3-0.3v-4.9h-3.5v7.8h-0.9v-7.8h-3.3v6.1h-0.9v-7h4.2v-2.4h-5.2
				v-0.9h5.2v-2.6h-3.1c-0.4,0.9-0.8,1.7-1.2,2.4c-0.2-0.1-0.6-0.3-0.9-0.4c1-1.4,1.7-3.4,2.2-5.5l1,0.2c-0.2,0.8-0.4,1.6-0.7,2.3
				h2.7v-3h0.9v3h4.5v0.9h-4.5L1118.5,373.8L1118.5,373.8z M1126.5,380.5h-0.9v-11.2h0.9V380.5z M1130.2,367.4v16.9
				c0,0.9-0.2,1.2-0.8,1.4c-0.5,0.2-1.6,0.2-3.1,0.2c-0.1-0.3-0.2-0.8-0.4-1.1c1.3,0,2.5,0,2.9,0c0.3,0,0.4-0.1,0.4-0.5v-16.9
				H1130.2z M1136.7,382.6c0.5,0.1,0.9,0.5,1.8,1c1.3,0.7,3,0.8,5.2,0.8c2.5,0,5.8-0.1,7.9-0.4c-0.1,0.3-0.3,0.8-0.3,1.1
				c-1.8,0.1-5.5,0.2-7.6,0.2c-2.3,0-4.1-0.2-5.4-0.9c-0.8-0.5-1.4-1-1.8-1c-0.7,0-1.8,0.9-2.9,2.1l-0.7-0.9c1-0.9,2-1.7,2.9-2v-6.8
				h-2.9V375h3.9L1136.7,382.6L1136.7,382.6z M1136.7,372c-0.6-0.9-2-2.3-3.1-3.3l0.7-0.5c1.2,1,2.5,2.3,3.2,3.2L1136.7,372z
				 M1151.3,375h-13.2v-0.9h6.2v-3.2h-3.6c-0.5,0.9-1.1,1.7-1.6,2.4c-0.2-0.1-0.6-0.4-0.8-0.5c1.2-1.3,2.3-3.3,2.9-5.2l0.9,0.2
				c-0.3,0.7-0.6,1.5-0.9,2.2h3.1v-2.7h1v2.7h5.1v0.9h-5.1v3.2h6V375z M1139.8,382.5v-5.7h9.7v5.7H1139.8z M1140.8,381.6h7.8v-3.9
				h-7.8V381.6z"/>
		</g>
		<g>
			<path d="M948.2,308v-2.2c1.9-1.5,3.8-2.3,5.9-2.3c2.1,0,3.8,0.7,5.3,2.1c1.4,1.4,2.2,3.1,2.2,5.1c0,4-3.1,9.6-9.3,16.6h11.8v1.7
				h-16c7.8-7.5,11.7-13.6,11.7-18.3c0-1.6-0.5-2.9-1.6-3.9c-1.1-1.1-2.4-1.6-4-1.6c-1.1,0-2,0.2-2.9,0.7S949.3,307,948.2,308z"/>
			<path d="M974.3,303.5c2.3,0,4.2,1.1,5.7,3.4c1.6,2.3,2.3,5.5,2.3,9.7c0,3.9-0.8,7-2.3,9.3s-3.4,3.5-5.7,3.5
				c-2.4,0-4.4-1.2-5.9-3.4c-1.5-2.3-2.3-5.3-2.3-9.1c0-4.7,0.8-8.1,2.5-10.2C970.4,304.5,972.2,303.5,974.3,303.5z M974.3,327.5
				c1.9,0,3.4-1.1,4.5-3.2c1.2-2.1,1.7-4.8,1.7-8.1c0-3.2-0.6-5.8-1.7-8c-1.1-2.1-2.6-3.2-4.5-3.2c-1.8,0-3.3,1-4.4,3.1
				c-1.2,2.1-1.7,4.8-1.7,8.1c0,3.3,0.6,6,1.7,8.1S972.5,327.5,974.3,327.5z"/>
			<path d="M993.8,303.8V329h-1.9v-25.3H993.8z"/>
			<path d="M1016.1,303.5v14.3h3.5v1.5h-3.5v9.8h-1.9v-9.8h-11.5v-0.6l12.7-15.2L1016.1,303.5L1016.1,303.5z M1014.2,317.8V307
				l-8.9,10.7H1014.2z"/>
		</g>
	</g>
				<g>
		<path class="st1" d="M875.4,342.8c-4.6,0-8.3,3.7-8.3,8.3s3.7,8.3,8.3,8.3s8.3-3.7,8.3-8.3S880,342.8,875.4,342.8z M887.3,349
			h-4.2v4.2h4.2V349z M895.6,349h-4.2v4.2h4.2V349z M903.9,349h-4.2v4.2h4.2V349z M912.2,349H908v4.2h4.2V349z M920.5,349h-4.2v4.2
			h4.2V349z M928.8,349h-4.2v4.2h4.2V349z"/>
					<path class="st2" d="M875.4,360.9c-5.4,0-9.8-4.4-9.8-9.8s4.4-9.8,9.8-9.8c4.2,0,7.7,2.6,9.2,6.2h2.7c0.8,0,1.5,0.7,1.5,1.5v4.2
			c0,0.8-0.7,1.5-1.5,1.5h-2.7C883.1,358.4,879.6,360.9,875.4,360.9z M875.4,344.2c-3.7,0-6.8,3-6.8,6.8c0,3.7,3,6.8,6.8,6.8
			c2.8,0,5.2-1.7,6.3-4.1c-0.1-0.2-0.1-0.4-0.1-0.6v-4.2c0-0.2,0-0.4,0.1-0.6C880.7,346,878.2,344.2,875.4,344.2z M885.3,351.6h0.5
			v-1.1h-0.5c0,0.2,0,0.4,0,0.6C885.3,351.2,885.3,351.5,885.3,351.6z M928.8,354.6h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2
			c0-0.8,0.7-1.5,1.5-1.5h4.1c0.8,0,1.5,0.7,1.5,1.5v4.2C930.3,354,929.6,354.6,928.8,354.6z M926.2,351.6h1.1v-1.1h-1.1V351.6z
			 M920.5,354.6h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2
			C922,354,921.3,354.6,920.5,354.6z M917.9,351.6h1.1v-1.1h-1.1V351.6z M912.2,354.6H908c-0.8,0-1.5-0.7-1.5-1.5v-4.2
			c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C913.7,354,913,354.6,912.2,354.6z M909.5,351.6h1.1v-1.1h-1.1V351.6z
			 M903.9,354.6h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2
			C905.4,354,904.7,354.6,903.9,354.6z M901.2,351.6h1.1v-1.1h-1.1V351.6z M895.6,354.6h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2
			c0-0.8,0.7-1.5,1.5-1.5h4.1c0.8,0,1.5,0.7,1.5,1.5v4.2C897.1,354,896.4,354.6,895.6,354.6z M892.9,351.6h1.1v-1.1h-1.1V351.6z"/>
	</g>
</g>
			<g class="a8 ani">
	<g>
		<g>
			<path d="M947.6,490l0.8-0.9c1.1,1.2,2.6,2,4.3,2c2.2,0,3.6-1.2,3.6-2.9c0-1.8-1.2-2.4-2.7-3l-2.2-1c-1.3-0.6-3-1.5-3-3.8
				c0-2.2,1.9-3.8,4.5-3.8c1.8,0,3.3,0.8,4.2,1.8l-0.7,0.8c-0.9-0.9-2.1-1.5-3.5-1.5c-1.9,0-3.2,1-3.2,2.6c0,1.7,1.5,2.3,2.6,2.8
				l2.2,1c1.7,0.8,3.2,1.7,3.2,4s-1.9,4.1-4.9,4.1C950.5,492.4,948.8,491.5,947.6,490z M960,477.5c0-0.6,0.5-1,1-1s1,0.4,1,1
				s-0.5,0.9-1,0.9C960.5,478.5,960,478.1,960,477.5z M960.4,481h1.2v11h-1.2V481z M965.6,481h1l0.1,1.7l0,0c1-1.1,2.2-2,3.5-2
				c1.8,0,2.6,0.9,3,2.2c1.2-1.3,2.4-2.2,3.7-2.2c2.2,0,3.3,1.4,3.3,4.2v7H979v-6.9c0-2.3-0.8-3.3-2.4-3.3c-1,0-2,0.7-3.2,2v8.2
				h-1.2v-6.9c0-2.3-0.7-3.3-2.4-3.3c-1,0-2,0.7-3.2,2v8.2h-1.2V481H965.6z M983.2,486.5c0-3.7,2.3-5.8,5-5.8s5,2.1,5,5.8
				c0,3.6-2.3,5.7-5,5.7S983.2,490.2,983.2,486.5z M991.9,486.5c0-2.8-1.6-4.7-3.7-4.7c-2.1,0-3.7,1.9-3.7,4.7s1.6,4.7,3.7,4.7
				C990.3,491.2,991.9,489.4,991.9,486.5z M996.5,481h1l0.1,1.7l0,0c1.1-1.1,2.2-2,3.8-2c2.3,0,3.3,1.4,3.3,4.2v7h-1.2v-6.9
				c0-2.3-0.7-3.3-2.4-3.3c-1.3,0-2.2,0.7-3.5,2v8.2h-1.2V481H996.5z M1013.6,477h1.2v14h6.8v1.1h-8.1L1013.6,477L1013.6,477z
				 M1023.9,477.5c0-0.6,0.5-1,1-1s1,0.4,1,1s-0.5,0.9-1,0.9C1024.3,478.5,1023.9,478.1,1023.9,477.5z M1024.3,481h1.2v11h-1.2V481z
				"/>
		</g>
		<g>
			<path d="M1033.9,484.8h7v8.6h-1v-1h-5v1.2h-0.9L1033.9,484.8L1033.9,484.8z M1034.8,485.8v5.7h5v-5.7H1034.8z M1047.7,482.2
				h-10.8v-6.5h10.8V482.2z M1046.7,476.8h-8.8v4.6h8.8V476.8z M1050.9,484.8v8.7h-1v-1h-5.5v1.2h-1v-8.8h7.5V484.8z M1049.9,491.5
				v-5.7h-5.5v5.7H1049.9z M1055.6,483.2c0,0.6,0,1.1,0,1.7h4v8.6h-0.9V486h-3.1c-0.1,2.6-0.4,5.4-1.4,7.7c-0.2-0.1-0.6-0.3-0.9-0.4
				c1.2-2.9,1.4-6.9,1.4-10v-8h0.9v5.5h2.2v-5.9h0.9v5.9h1.8v0.9h-5L1055.6,483.2L1055.6,483.2z M1072.2,489.1h-4.1v4.4h-0.9v-4.4
				h-6.6v-0.9h6.6v-3.5h0.9v3.5h4.1V489.1z M1065.8,484.8c-0.7,1.2-1.9,2.3-3.7,3.4c-0.2-0.2-0.5-0.5-0.7-0.6
				c1.5-0.8,2.6-1.8,3.3-2.7h-3v-7.7h3.2c0.3-0.7,0.6-1.5,0.7-2.2l1.1,0.2c-0.2,0.7-0.5,1.4-0.8,2h5.4v7.7L1065.8,484.8
				L1065.8,484.8z M1062.6,480.5h3.5c0-0.2,0-0.5,0-0.7v-1.9h-3.6L1062.6,480.5L1062.6,480.5z M1065.3,483.9
				c0.5-0.9,0.7-1.8,0.8-2.6h-3.5v2.6H1065.3z M1070.2,481.4h-3.2c-0.1,0.8-0.3,1.7-0.7,2.6h3.9L1070.2,481.4L1070.2,481.4z
				 M1070.2,478h-3.2v1.9c0,0.2,0,0.4,0,0.7h3.2V478z"/>
		</g>
		<g>
			<path d="M954.3,504c-0.7,1.5-1.5,2.9-2.5,4.3v10h-1v-8.8c-0.8,0.9-1.7,1.8-2.7,2.5c-0.1-0.2-0.4-0.6-0.6-0.8
				c2.5-1.8,4.4-4.4,5.7-7.2h-5.3v-1h5.7c0.5-1.1,0.9-2.2,1.2-3.4l1,0.3c-0.3,1.1-0.7,2.1-1.1,3.1h11v1H954.3z M965.8,516.8v0.9
				h-12.5v-0.9h5.7v-6.5h-4.9v-0.9h4.9v-4.3h1v4.3h5v0.9h-5v6.5H965.8z M985.5,503.4v9.3h-1v-1.3h-6.7v6.9h-1v-6.9h-6.7v1.4h-1v-9.4
				h7.6v-3.7h1v3.7H985.5z M976.9,510.4v-6.1h-6.7v6.1H976.9z M984.5,510.4v-6.1h-6.7v6.1H984.5z M1006.4,500.6v17.7h-1v-1.1h-14.8
				v1.1h-1v-17.7H1006.4z M1005.4,516.3v-14.8h-14.8v14.8H1005.4z M1003.9,513.1v0.9h-11.6v-0.9h5.2V509h-4.2v-0.9h4.2v-3.5h-4.8
				v-0.9h10.8v0.9h-5.1v3.5h4.5v0.9h-4.5v4.1H1003.9z M1000.7,509.6c0.9,0.7,1.9,1.8,2.3,2.4l-0.7,0.5c-0.5-0.7-1.4-1.8-2.3-2.5
				L1000.7,509.6z M1027.8,509.4h-4.8v9h-1v-9h-6.4c-0.2,3.3-1.3,6.6-5.2,9c-0.2-0.2-0.5-0.6-0.7-0.7c3.7-2.3,4.7-5.3,4.9-8.3h-5
				v-0.9h5.1c0-0.4,0-0.7,0-1.1v-5.3h-4.3v-0.9h16.8v0.9h-4.1v6.4h4.8L1027.8,509.4L1027.8,509.4z M1021.9,508.4V502h-6.3v5.3
				c0,0.4,0,0.7,0,1.1H1021.9z M1033.2,508c0,3.1-0.5,7.4-2.6,10.4c-0.2-0.2-0.6-0.6-0.8-0.7c2.2-3,2.5-7.2,2.5-10.2v-4.8h14.3v5.3
				L1033.2,508L1033.2,508z M1033.2,503.5v3.4h12.4v-3.4H1033.2z M1046.8,510.5v7.7h-1v-1.4h-10.4v1.5h-1v-7.7h12.4V510.5z
				 M1045.8,515.8v-4.3h-10.4v4.3H1045.8z M1039,499.5c0.6,0.8,1.2,2,1.5,2.7l-0.9,0.4c-0.3-0.7-0.9-1.9-1.4-2.7L1039,499.5z
				 M1057.2,510.5c0,0.2,0,0.6,0,0.8c-5.2,1.1-5.8,1.3-6.2,1.5c0-0.2-0.2-0.7-0.3-1c0.4-0.1,0.9-0.6,1.5-1.4
				c0.4-0.5,1.4-1.7,2.4-3.2c-2.9,0.4-3.4,0.5-3.6,0.7c-0.1-0.2-0.2-0.7-0.3-1c0.3-0.1,0.7-0.6,1.1-1.3c0.5-0.7,2-3.4,2.8-6l0.9,0.5
				c-0.9,2.3-2.2,4.7-3.5,6.6l3.1-0.4c0.5-0.7,0.9-1.5,1.4-2.3l0.9,0.5c-1.4,2.5-3.1,4.9-4.8,6.9L1057.2,510.5z M1057.6,515
				c-2.4,0.7-4.8,1.3-6.7,1.8l-0.2-1c1.7-0.4,4.2-1,6.8-1.7L1057.6,515z M1068.9,510c-1.1,1.7-2.6,3.2-4.3,4.5
				c0.8,1.8,1.7,2.7,2.9,2.7c0.6,0,0.9-0.5,1-2.4c0.2,0.2,0.5,0.4,0.8,0.5c-0.2,2.2-0.6,2.8-1.9,2.8c-1.5,0-2.7-1.1-3.5-3.1
				c-1.7,1.1-3.6,2.1-5.7,2.8c-0.1-0.2-0.4-0.6-0.6-0.8c2.1-0.7,4.2-1.6,6-2.9c-0.5-1.4-0.8-3.1-1.1-5l-4.1,0.8l-0.2-0.9l4.1-0.8
				c-0.1-1-0.2-2.1-0.3-3.2l-3.3,0.5l-0.2-0.9l3.4-0.5c-0.1-1.5-0.1-3-0.1-4.6h1c0,1.6,0,3,0.1,4.4l5.2-0.8l0.2,0.9l-5.4,0.8
				c0.1,1.1,0.2,2.2,0.3,3.2l5.5-1l0.2,0.9l-5.6,1.1c0.2,1.8,0.6,3.4,1,4.6c1.5-1.2,2.9-2.6,3.8-4L1068.9,510z M1067.2,502.5
				c-0.7-0.6-2.1-1.4-3.2-1.9l0.6-0.6c1.1,0.4,2.5,1.2,3.2,1.7L1067.2,502.5z M1089.5,516.3v1h-18.3v-1h7.9V500h1v6.6h7.9v1h-7.9
				v8.8H1089.5z M1102.2,508c-0.2,0.2-0.4,0.3-0.7,0.5c2.2,1.2,6.2,2.4,9,2.9c-0.2,0.2-0.5,0.6-0.6,0.8c-2.8-0.6-6.8-2-9.1-3.3
				c-2.4,1.4-5.6,2.7-8.6,3.4c-0.1-0.2-0.4-0.5-0.6-0.7c3.5-0.8,7.6-2.3,9.8-4.1L1102.2,508z M1093.4,506.2h-0.9v-3.5h8v-1.4h-6.9
				v-0.8h14.9v0.8h-7v1.4h8.1v3.5h-0.9v-2.7h-7.2v3.2h-1v-3.2h-7L1093.4,506.2L1093.4,506.2z M1094.1,507h5v0.8h-5V507z M1107,512.3
				l0.7,0.4c-1.2,1.3-3.4,2.7-5.2,3.6c1,0.4,1.9,0.8,2.5,1.2l-0.5,0.8c-1.7-1-5-2.3-7.7-3.1l0.5-0.7c1.3,0.4,2.8,0.8,4.1,1.4
				c1.4-0.6,3.3-1.7,4.5-2.7h-11.7v-0.8h12.6L1107,512.3z M1099.1,505v0.7h-4.6V505H1099.1z M1101.6,512.2c-0.4-0.5-1.1-1.3-1.8-1.8
				l0.7-0.5c0.7,0.5,1.5,1.2,1.8,1.8L1101.6,512.2z M1107.4,505v0.7h-4.7V505H1107.4z M1102.6,507h5.3v0.8h-5.3V507z M1129.6,509.6
				v0.8H1116v0.9h-1v-7.5c-0.7,0.9-1.4,1.7-2.2,2.4c-0.1-0.1-0.5-0.5-0.7-0.7c1.8-1.5,3.4-3.7,4.4-6l1,0.3c-0.3,0.7-0.7,1.4-1.1,2.1
				h5.8c-0.3-0.7-0.7-1.5-1.2-2.1l0.9-0.3c0.5,0.7,1,1.7,1.3,2.4h6v0.8h-6.3v1.7h5.4v0.8h-5.4v1.7h5.5v0.8h-5.5v1.9L1129.6,509.6
				L1129.6,509.6z M1115,512.2h13.4v6h-1v-1H1116v1.1h-1V512.2z M1121.8,502.9h-5.9v1.7h5.9V502.9z M1121.8,505.4h-5.9v1.7h5.9
				V505.4z M1116,509.6h5.9v-1.9h-5.9V509.6z M1116,513.1v3.2h11.4v-3.2H1116z M1151.1,516.1v1h-17.9v-1h6v-16.3h1v16.3h3.9v-16.3h1
				v16.3H1151.1z M1136.8,511.8c-0.5-1.7-1.8-4.7-3-6.9l0.9-0.3c1.2,2.2,2.5,5.1,3.1,6.8L1136.8,511.8z M1150.6,505
				c-1,2.2-2.5,5-3.7,6.9l-0.8-0.4c1.2-1.9,2.7-4.8,3.6-6.9L1150.6,505z M1169.7,502.1c-1.2,1.9-3.2,3.3-5.6,4.4
				c2.3,0.8,5,1.3,8,1.5c-0.2,0.2-0.5,0.6-0.6,0.9c-3.2-0.3-6.1-0.9-8.5-1.9c-2.8,1.2-6.1,1.8-9.1,2.2c-0.1-0.3-0.2-0.7-0.4-0.9
				c2.8-0.3,5.8-0.8,8.4-1.8c-1.5-0.8-2.7-1.7-3.6-2.9c-0.9,0.8-1.9,1.6-3.1,2.2c-0.2-0.2-0.5-0.5-0.7-0.7c2.9-1.6,5-3.9,6.1-5.7
				l1.1,0.2c-0.4,0.7-0.9,1.4-1.5,2h8.7l0.2-0.1L1169.7,502.1z M1170,511.5c-0.5,3.9-0.9,5.4-1.5,6c-0.4,0.3-0.7,0.4-1.4,0.5
				c-0.6,0-1.7,0-2.9-0.1c0-0.3-0.2-0.6-0.3-0.9c1.3,0.1,2.5,0.1,2.9,0.1s0.7,0,0.8-0.2c0.5-0.4,0.9-1.8,1.3-5h-6.7
				c-1.3,3.6-3.9,5.3-8.1,6.2c-0.1-0.2-0.3-0.7-0.5-0.9c4-0.7,6.4-2.2,7.6-5.3h-6.1v-0.9h6.4c0.2-0.7,0.3-1.4,0.4-2.2l1,0.1
				c-0.1,0.8-0.2,1.5-0.4,2.1h7.5L1170,511.5z M1159.3,502.6c-0.1,0.1-0.3,0.3-0.4,0.4c0.9,1.3,2.3,2.3,4,3c2.1-0.9,3.9-2,5.2-3.5
				h-8.8V502.6z"/>
		</g>
		<g>
			<path d="M948.2,439.4v-2.2c1.9-1.5,3.8-2.3,5.9-2.3c2.1,0,3.8,0.7,5.3,2.1c1.4,1.4,2.2,3.1,2.2,5.1c0,4-3.1,9.6-9.3,16.6h11.8
				v1.7h-16c7.8-7.5,11.7-13.6,11.7-18.3c0-1.6-0.5-2.9-1.6-3.9c-1.1-1.1-2.4-1.6-4-1.6c-1.1,0-2,0.2-2.9,0.7
				C950.3,437.8,949.3,438.5,948.2,439.4z"/>
			<path d="M974.3,434.9c2.3,0,4.2,1.1,5.7,3.4c1.6,2.3,2.3,5.5,2.3,9.7c0,3.9-0.8,7-2.3,9.3s-3.4,3.5-5.7,3.5
				c-2.4,0-4.4-1.2-5.9-3.4c-1.5-2.3-2.3-5.3-2.3-9.1c0-4.7,0.8-8.1,2.5-10.2C970.4,436,972.2,434.9,974.3,434.9z M974.3,459
				c1.9,0,3.4-1.1,4.5-3.2c1.2-2.1,1.7-4.8,1.7-8.1c0-3.2-0.6-5.8-1.7-8c-1.1-2.1-2.6-3.2-4.5-3.2c-1.8,0-3.3,1-4.4,3.1
				c-1.2,2.1-1.7,4.8-1.7,8.1c0,3.3,0.6,6,1.7,8.1S972.5,459,974.3,459z"/>
			<path d="M993.8,435.2v25.3h-1.9v-25.3H993.8z"/>
			<path d="M1014.9,434.9l1.1,1.3c-5.4,3.8-8.5,8-9.4,12.6c1.8-1.3,3.6-2,5.6-2s3.7,0.7,5.1,2c1.3,1.3,2,3,2,4.9
				c0,2.1-0.7,3.8-2,5.1c-1.4,1.3-3.1,2-5.2,2c-2.3,0-4.2-0.8-5.6-2.4c-1.4-1.6-2.1-3.8-2.1-6.5
				C1004.4,445.8,1007.9,440,1014.9,434.9z M1006.3,451c0,0.4-0.1,0.9-0.1,1.3c0,2.1,0.5,3.7,1.6,4.9c1.1,1.2,2.5,1.9,4.2,1.9
				c1.5,0,2.8-0.5,3.9-1.5c1-1,1.6-2.2,1.6-3.6c0-1.5-0.5-2.8-1.6-3.8c-1-1-2.3-1.5-3.9-1.5C1010,448.5,1008.1,449.4,1006.3,451z"/>
		</g>
	</g>
				<g>
		<path class="st1" d="M875.4,475.8c-4.6,0-8.3,3.7-8.3,8.3c0,4.6,3.7,8.3,8.3,8.3s8.3-3.7,8.3-8.3S880,475.8,875.4,475.8z
			 M887.3,482h-4.2v4.2h4.2V482z M895.6,482h-4.2v4.2h4.2V482z M903.9,482h-4.2v4.2h4.2V482z M912.2,482H908v4.2h4.2V482z
			 M920.5,482h-4.2v4.2h4.2V482z M928.8,482h-4.2v4.2h4.2V482z"/>
					<path class="st2" d="M875.4,493.9c-5.4,0-9.8-4.4-9.8-9.8s4.4-9.8,9.8-9.8c4.2,0,7.7,2.6,9.2,6.2h2.7c0.8,0,1.5,0.7,1.5,1.5v4.2
			c0,0.8-0.7,1.5-1.5,1.5h-2.7C883.1,491.2,879.6,493.9,875.4,493.9z M875.4,477.2c-3.7,0-6.8,3-6.8,6.8c0,3.7,3,6.8,6.8,6.8
			c2.8,0,5.2-1.7,6.3-4.1c-0.1-0.2-0.1-0.4-0.1-0.6v-4.2c0-0.2,0-0.4,0.1-0.6C880.7,479,878.2,477.2,875.4,477.2z M885.3,484.5h0.5
			v-1.1h-0.5c0,0.2,0,0.4,0,0.6S885.3,484.5,885.3,484.5z M928.8,487.6h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.1
			c0.8,0,1.5,0.7,1.5,1.5v4.2C930.3,487,929.6,487.6,928.8,487.6z M926.2,484.5h1.1v-1.1h-1.1V484.5z M920.5,487.6h-4.2
			c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C922,487,921.3,487.6,920.5,487.6z
			 M917.9,484.5h1.1v-1.1h-1.1V484.5z M912.2,487.6H908c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2
			c0.8,0,1.5,0.7,1.5,1.5v4.2C913.7,487,913,487.6,912.2,487.6z M909.5,484.5h1.1v-1.1h-1.1V484.5z M903.9,487.6h-4.2
			c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C905.4,487,904.7,487.6,903.9,487.6z
			 M901.2,484.5h1.1v-1.1h-1.1V484.5z M895.6,487.6h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.1
			c0.8,0,1.5,0.7,1.5,1.5v4.2C897.1,487,896.4,487.6,895.6,487.6z M892.9,484.5h1.1v-1.1h-1.1V484.5z"/>
	</g>
</g>
			<g class="a10 ani">
	<g>
		<g>
			<path d="M1306.5,266.4c-1.1,1.9-2.9,3.4-5,4.6c2.4,1.2,5.2,1.9,8.4,2.2c-0.2,0.2-0.5,0.6-0.6,0.9c-3.4-0.4-6.4-1.3-8.9-2.6
				c-2.7,1.3-5.8,2.2-8.8,2.7c-0.1-0.3-0.3-0.7-0.4-0.9c2.8-0.4,5.7-1.1,8.2-2.3c-1.5-0.9-2.8-2.1-3.7-3.5c-1.1,0.8-2.3,1.6-3.7,2.3
				c-0.2-0.2-0.5-0.5-0.7-0.7c3-1.4,5.3-3.3,6.6-4.9h-6.6v-0.9h8.6v-2.2h-6.4v-0.8h6.4v-2h-7.6v-1h7.6v-1.7h1v1.7h7.8v0.9h-7.8v2
				h6.7v0.8h-6.7v2.2h8.7v0.9h-10.3c-0.5,0.6-1.1,1.3-1.8,1.9h8.1l0.2-0.1L1306.5,266.4z M1296.6,266.9c0.9,1.4,2.3,2.6,4,3.6
				c1.8-1,3.4-2.1,4.5-3.6H1296.6z M1312,273.9c1-0.8,1.9-2.2,2.4-3.5l0.9,0.2c-0.6,1.3-1.5,2.8-2.5,3.7L1312,273.9z M1318.5,256.5
				c1.1,1,2.4,2.5,2.9,3.5l-0.8,0.5c-0.2-0.3-0.4-0.7-0.7-1.1c-6.3,0.5-7,0.6-7.4,0.8c0-0.2-0.2-0.7-0.3-0.9c0.3,0,0.6-0.3,1-0.6
				c0.4-0.4,1.7-1.8,2.6-3.2l0.9,0.4c-0.9,1.2-1.9,2.4-2.9,3.3l5.5-0.4c-0.5-0.6-1.1-1.2-1.6-1.7L1318.5,256.5z M1320.1,268.1
				c0,0.6-0.1,0.9-0.6,1c-0.5,0.2-1.4,0.2-2.8,0.2c-0.1-0.3-0.2-0.6-0.4-0.8c1.3,0,2.2,0,2.5,0s0.4-0.1,0.4-0.4v-1.7h-4.9v3.1h-0.9
				v-8.6h6.8L1320.1,268.1L1320.1,268.1z M1314.2,261.8v1.6h4.9v-1.6H1314.2z M1319.2,265.6V264h-4.9v1.6H1319.2z M1318.8,270.8
				c0.3,1.1,0.5,2.4,0.5,3.2l-0.9,0.1c0-0.8-0.2-2.2-0.4-3.3H1318.8z M1323.2,270.6c0.5,1,1,2.4,1.2,3.2l-0.9,0.2
				c-0.2-0.8-0.7-2.2-1.2-3.3L1323.2,270.6z M1324.4,262.2c-1.6,0-2.1-0.3-2.1-1.5v-5.2h0.9v2.6c1.8-0.5,3.8-1.1,5-1.6l0.7,0.7
				c-1.5,0.6-3.7,1.3-5.7,1.7v1.8c0,0.5,0.2,0.6,1.2,0.6h3.7c0.8,0,0.9-0.3,1-2c0.2,0.2,0.6,0.3,0.9,0.4c-0.1,2-0.4,2.5-1.8,2.5
				H1324.4z M1328.3,268.5c0.8,0,0.9-0.2,1-2c0.2,0.2,0.6,0.3,0.9,0.4c-0.1,2-0.5,2.5-1.8,2.5h-3.9c-1.7,0-2.1-0.3-2.1-1.5v-5.3h0.9
				v2.5c1.8-0.5,3.9-1.1,5-1.7l0.7,0.7c-1.4,0.7-3.8,1.4-5.7,1.9v1.9c0,0.5,0.2,0.6,1.2,0.6H1328.3L1328.3,268.5z M1327.5,270.4
				c1,1,2.2,2.5,2.7,3.4l-0.9,0.4c-0.5-0.9-1.6-2.4-2.6-3.5L1327.5,270.4z M1335.3,267.9c-0.5,1.5-1.3,3-2.1,4
				c-0.2-0.1-0.6-0.4-0.8-0.5c0.9-1,1.6-2.3,2-3.7L1335.3,267.9z M1337.7,266.8v5.7c0,0.6-0.1,0.8-0.5,1c-0.4,0.2-1,0.2-1.9,0.2
				c-0.1-0.2-0.2-0.6-0.4-0.9c0.8,0,1.4,0,1.6,0s0.3-0.1,0.3-0.3v-5.7h-4.3v-0.9h4.3v-2.5h-4.4v-0.9h5.8c0.4-1.1,1-2.6,1.2-3.6
				l0.9,0.2c-0.4,1.1-0.8,2.4-1.2,3.4h2.9v0.9h-4.3v2.5h4.1v0.9L1337.7,266.8L1337.7,266.8z M1341.7,258.6h-9v-0.9h4.4
				c-0.3-0.6-0.7-1.4-1.1-2l0.9-0.2c0.4,0.7,1,1.6,1.3,2.3h3.5L1341.7,258.6L1341.7,258.6z M1335.1,262.4c-0.1-0.9-0.5-2.2-0.9-3.2
				l0.8-0.2c0.5,1,0.8,2.3,0.9,3.2L1335.1,262.4z M1339.6,267.6c0.7,1.1,1.4,2.5,1.8,3.4l-0.8,0.4c-0.3-0.9-1.1-2.4-1.7-3.5
				L1339.6,267.6z M1350.9,263.4h-2.5V274h-1v-10.6h-3.8v1c0,2.9-0.3,6.8-2.2,9.6c-0.1-0.2-0.5-0.5-0.7-0.6c1.9-2.6,2.1-6.2,2.1-8.9
				v-6.9c2.3-0.4,5.1-0.9,6.5-1.5l0.9,0.7c-1.7,0.6-4.2,1.1-6.4,1.4v4.4h7.2L1350.9,263.4L1350.9,263.4z M1371.4,271.5v1h-18.3v-1
				h8.6v-12.6h-7.5v-1h16.3v1h-7.7v12.6H1371.4z M1391.6,258.1h-15v5c0,3.2-0.3,7.8-2.3,10.9c-0.2-0.2-0.6-0.5-0.9-0.6
				c2-3,2.1-7.3,2.1-10.4v-6h16v1.1H1391.6z M1400.5,265.6c-0.8,0.3-1.6,0.5-2.3,0.7v6.3c0,0.7-0.2,1-0.6,1.1
				c-0.5,0.2-1.2,0.2-2.6,0.2c-0.1-0.2-0.2-0.6-0.4-0.9c1.1,0,2,0,2.2,0c0.3,0,0.4-0.1,0.4-0.4v-6c-1.1,0.3-2.1,0.6-2.9,0.9l-0.4-1
				c0.9-0.2,2-0.6,3.3-0.9v-4.9h-3v-0.9h3v-4.3h1v4.3h2.8v0.9h-2.8v4.6l2.2-0.7L1400.5,265.6z M1411.1,264.9
				c-0.9,2.4-2.4,4.4-4.3,5.8c1.6,1.2,3.6,2,5.9,2.5c-0.2,0.2-0.5,0.6-0.6,0.9c-2.3-0.6-4.3-1.5-6-2.8c-1.9,1.3-4.1,2.2-6.3,2.8
				c-0.1-0.3-0.3-0.7-0.5-0.9c2.1-0.5,4.2-1.3,6.1-2.6c-1.6-1.4-2.8-3.1-3.7-5.2h-0.7v-0.9h9.4l0.2-0.1L1411.1,264.9z M1403.9,258.6
				c0,1.8-0.5,3.9-2.9,5.4c-0.1-0.2-0.4-0.6-0.6-0.7c2.2-1.4,2.6-3.2,2.6-4.7v-2.3h6.1v4.9c0,0.6,0.1,0.8,0.4,0.8h1.9
				c0.2,0,0.7,0,0.9-0.1c0,0.2,0.1,0.7,0.1,0.9c-0.2,0.1-0.7,0.1-1,0.1h-1.9c-1.1,0-1.3-0.4-1.3-1.7v-4h-4.2L1403.9,258.6
				L1403.9,258.6z M1402.5,265.6c0.8,1.8,2,3.3,3.5,4.6c1.6-1.2,2.9-2.7,3.7-4.6H1402.5z M1432.7,264.2h-15.2v1.8
				c0,2.4-0.3,5.8-2.1,8.2c-0.2-0.2-0.6-0.5-0.8-0.6c1.6-2.3,1.9-5.4,1.9-7.6v-2.8h9.8c0.6-1,1.4-2.6,1.8-3.6l1,0.4
				c-0.5,1.1-1.2,2.3-1.9,3.3h5.5L1432.7,264.2L1432.7,264.2z M1432.1,259.1h-16v-0.9h8.1c-0.3-0.7-0.9-1.6-1.5-2.4l0.9-0.3
				c0.7,0.8,1.3,1.8,1.6,2.5l-0.4,0.2h7.2v0.9H1432.1z M1421.1,262.9c-0.3-0.8-1.1-2.1-1.8-3l0.8-0.3c0.7,0.9,1.5,2.2,1.9,3
				L1421.1,262.9z M1436.7,273.8c1.6-0.7,2.5-1.8,2.6-3.4c-0.1,0-0.3,0.1-0.4,0.1c-0.7,0-1.3-0.4-1.3-1.3c0-0.8,0.6-1.3,1.3-1.3
				c1,0,1.5,0.8,1.5,2.1c0,2.2-1.3,3.7-3.3,4.5L1436.7,273.8z"/>
		</g>
		<g>
			<path d="M1300.1,294.2c0,0,0,0.3,0,0.4c-0.2,2.4-0.5,3.4-0.8,3.7c-0.3,0.3-0.6,0.4-1,0.4s-1.3,0-2.2-0.1c0-0.2-0.1-0.6-0.2-0.8
				c0.9,0.1,1.8,0.1,2.1,0.1c0.3,0,0.5,0,0.6-0.1c0.2-0.2,0.4-1,0.6-2.8h-3.3c-0.6,1.9-1.7,3.1-4,3.9c-0.1-0.2-0.4-0.5-0.6-0.7
				c2.1-0.7,3.1-1.7,3.7-3.2h-3v-0.8h3.2c0.1-0.5,0.2-0.9,0.2-1.5h0.9c-0.1,0.5-0.1,1-0.2,1.5H1300.1z M1309.4,281.8v0.8h-8.5v1.5
				h7.1v0.8h-15.1V284h7v-1.5h-8.3v-0.8h8.3v-1.5h1v1.5H1309.4z M1304.6,290.1c-0.3,0.5-0.7,1.1-1,1.5h5.6v0.8h-17.6v-0.8h5.7
				c-0.2-0.5-0.6-1.2-1.1-1.6l0.6-0.2h-3v-3.6h13.4v3.6h-3.5L1304.6,290.1z M1294.8,289h11.5v-2h-11.5V289z M1297.2,289.9
				c0.5,0.5,0.9,1.1,1.1,1.5l-0.8,0.3h5.1c0.4-0.6,0.8-1.3,1.1-1.8H1297.2z M1301.5,293.8h6.9v5.1h-0.9v-0.7h-5v0.8h-0.9
				L1301.5,293.8L1301.5,293.8z M1302.4,294.5v2.8h5v-2.8H1302.4z M1318.3,293c-1.3,2-3.6,4.3-5.7,5.7c-0.2-0.2-0.5-0.6-0.8-0.7
				c2-1.4,4.3-3.5,5.4-5.4L1318.3,293z M1330.1,290.2v1h-18.2v-1H1330.1z M1313.1,282.2c1.4,1.8,2.7,4.3,3.3,5.9l-0.9,0.4
				c-0.6-1.6-1.9-4.1-3.2-6L1313.1,282.2z M1319.2,280.6c1.1,2,2.1,4.5,2.4,6.2l-1,0.3c-0.3-1.7-1.3-4.3-2.3-6.2L1319.2,280.6z
				 M1324.5,292.6c1.9,1.7,4.3,4,5.6,5.5l-0.8,0.5c-1.2-1.4-3.6-3.9-5.6-5.6L1324.5,292.6z M1329.7,281.5c-1.3,2.6-3.3,5.9-4.8,8
				l-0.9-0.4c1.5-2.1,3.6-5.5,4.7-8L1329.7,281.5z M1335.4,285.6v1.6c0,3.4-0.3,8.3-2.4,11.6c-0.1-0.2-0.6-0.4-0.8-0.5
				c2.1-3.3,2.3-7.8,2.3-11.1v-6h15.1v4.3h-14.2V285.6z M1335.4,282.1v2.6h13.1v-2.6H1335.4z M1349.5,293.4
				c-1.1,0.8-2.5,1.7-3.6,2.3c1.4,1.1,3.2,1.9,5.2,2.4c-0.2,0.2-0.5,0.6-0.6,0.8c-3.8-0.9-6.6-3.2-8-6.4h-3.3v4.8l5-1.2
				c0,0.3,0,0.7,0,0.9c-5.6,1.4-6.1,1.6-6.5,1.9c-0.1-0.2-0.3-0.7-0.5-0.9c0.4-0.2,1-0.6,1-1.4v-4.1h-2.6v-0.9h4v-2.6h-3.4V288h3.4
				v-2h0.9v2h4.8v-2h0.9v2h3.8v0.9h-3.8v2.6h4.6v0.9h-7.5c0.5,1,1.1,1.9,1.9,2.7c1.1-0.6,2.6-1.6,3.5-2.3L1349.5,293.4z
				 M1340.5,291.6h4.8V289h-4.8V291.6z M1371.5,282.5h-15.8v5.6c0,3.2-0.2,7.6-2.1,10.6c-0.2-0.2-0.6-0.5-0.8-0.6
				c1.7-2.9,1.9-7,1.9-10v-6.5h16.8V282.5z M1357,286.2h14v0.9h-6v10.3c0,0.8-0.2,1.1-0.8,1.3c-0.6,0.2-1.8,0.2-3.8,0.2
				c-0.1-0.3-0.2-0.7-0.4-1c1.6,0,3,0,3.4,0s0.5-0.1,0.5-0.5v-10.3h-7v-0.9H1357z M1391.1,286.6c-0.9,3.7-2.7,6.4-5,8.4
				c1.7,1.3,3.7,2.2,6.1,2.8c-0.2,0.2-0.5,0.6-0.7,0.9c-2.5-0.7-4.5-1.7-6.2-3c-2,1.5-4.2,2.5-6.6,3.1c-0.1-0.3-0.4-0.7-0.6-0.9
				c2.3-0.6,4.5-1.5,6.4-2.9c-2.5-2.2-4.1-5.2-5.3-8.7c-0.2,3.8-1.1,8.2-5.1,12.2c-0.1-0.2-0.5-0.6-0.7-0.8
				c4.6-4.5,4.9-9.6,4.9-13.4v-1.9h-3.8v-1h12.5c-0.4,1.6-0.9,3.5-1.3,5h4.6l0.2-0.1L1391.1,286.6z M1379.3,283.4
				c1.1,4.6,3,8.4,6.1,11.1c2-1.7,3.6-4,4.5-7.1h-5.5c0.4-1.3,0.9-3.3,1.4-5h-6.4L1379.3,283.4L1379.3,283.4z M1394.2,281.5h7.1v0.9
				h-3.3c-0.4,1.9-0.8,3.7-1.4,5.4h4.3v8.5h-4.3v1.7h-0.9v-8.1c-0.4,0.7-0.8,1.4-1.2,2.1c-0.1-0.2-0.4-0.7-0.6-0.9
				c1.5-2.1,2.5-5.2,3.1-8.6h-2.8L1394.2,281.5L1394.2,281.5z M1396.6,288.6v6.7h3.4v-6.7H1396.6z M1412.7,289.8h-2.4v9.1h-0.9v-9.1
				h-4c-0.1,3.2-0.5,6.6-2.9,9.2c-0.2-0.2-0.6-0.5-0.8-0.6c2.3-2.4,2.8-5.7,2.8-8.6h-2.5v-0.9h2.5v-6.4h-1.9v-0.9h9.8v0.9h-2v6.4
				h2.4L1412.7,289.8L1412.7,289.8z M1409.3,288.9v-6.4h-4v6.4H1409.3z M1430.6,288.9c-0.8,2.6-2.3,4.7-4.1,6.3
				c1.9,1.4,4.2,2.5,6.8,3c-0.2,0.2-0.5,0.6-0.6,0.9c-2.7-0.6-5-1.7-7-3.2c-1.9,1.5-4.2,2.5-6.6,3.2c-0.1-0.2-0.3-0.6-0.5-0.8
				c2.2-0.6,4.4-1.6,6.3-3c-1.5-1.3-2.7-2.9-3.6-4.8c-1.4,2.8-3.4,5.1-6.2,6.9c-0.1-0.2-0.5-0.5-0.7-0.7c3.8-2.5,6.2-6,7.5-10.5h-3
				c-1.4,0-2,0.1-2.2,0.3c-0.1-0.2-0.2-0.8-0.4-1c0.3-0.1,0.5-0.4,0.7-0.8s1-2.1,1.4-3.7l1.1,0.2c-0.4,1.4-1,2.9-1.5,4h4.2
				c0.4-1.5,0.7-3.2,0.9-4.9l1.1,0.2c-0.2,1.7-0.5,3.2-0.9,4.7h9.3v1h-9.6c-0.2,0.9-0.5,1.7-0.8,2.5h7.5l0.2-0.1L1430.6,288.9z
				 M1422,289.5c0.9,1.9,2.1,3.6,3.7,5c1.5-1.3,2.7-3,3.5-5H1422z M1430.3,284.2c-0.6-0.8-1.8-2.1-2.7-3.1l0.8-0.5
				c0.9,0.9,2.1,2.2,2.8,3L1430.3,284.2z M1452.7,284v9.3h-1V292h-6.7v6.9h-1V292h-6.7v1.4h-1V284h7.6v-3.7h1v3.7H1452.7z M1444,291
				v-6.1h-6.7v6.1H1444z M1451.7,291v-6.1h-6.7v6.1H1451.7z M1458.9,287.9c-0.4,2.2-1.1,5.7-2,7.8l-0.9-0.4c1-2.1,1.7-5.3,2-7.6
				L1458.9,287.9z M1462,285.9v10.6c0,0.9,0.3,1.2,1.5,1.2h4.6c1.4,0,1.6-0.8,1.8-4.5c0.3,0.2,0.7,0.4,0.9,0.5c-0.2,3.9-0.5,5-2.7,5
				h-4.6c-2,0-2.5-0.4-2.5-2.1v-10.5h1V285.9z M1462.7,281.1c1.9,1.4,4.3,3.4,5.5,4.7l-0.7,0.7c-1.2-1.3-3.5-3.4-5.5-4.8
				L1462.7,281.1z M1471.7,287.1c1.2,2.5,2.4,5.7,2.9,7.8l-1,0.3c-0.4-2.1-1.6-5.4-2.8-7.8L1471.7,287.1z M1493.6,287.1
				c-0.9,2.7-2.1,5-3.7,7c0.9,2.3,2,3.6,3.3,3.6c0.7,0,0.9-1.1,1.1-3.9c0.2,0.2,0.6,0.4,0.9,0.5c-0.2,3.3-0.6,4.4-2,4.4
				c-1.6,0-2.9-1.4-3.9-3.8c-1.4,1.5-2.9,2.8-4.8,3.8c-0.1-0.2-0.5-0.6-0.7-0.8c2-1.1,3.7-2.4,5.1-4.1c-0.8-2.4-1.3-5.5-1.6-9h-7.8
				v3h5.4c0,0,0,0.4,0,0.5c-0.1,4.8-0.2,6.5-0.6,7c-0.3,0.3-0.6,0.4-1.1,0.5c-0.5,0-1.5,0-2.5,0c0-0.3-0.1-0.7-0.3-0.9
				c1.1,0.1,2.1,0.1,2.4,0.1s0.5,0,0.7-0.2c0.3-0.3,0.4-1.8,0.5-6h-4.4v0.8c0,2.8-0.3,6.7-2.2,9.4c-0.2-0.2-0.6-0.5-0.8-0.6
				c1.8-2.6,2-6.1,2-8.7v-5.6h8.8c-0.1-1.2-0.1-2.5-0.1-3.7h1c0,1.3,0,2.5,0.1,3.7h6.8v1h-6.7c0.2,3.2,0.7,5.9,1.3,8
				c1.3-1.8,2.3-3.8,3.1-6.1L1493.6,287.1z M1493.2,283.6c-0.8-0.7-2.5-1.8-3.9-2.5l0.6-0.6c1.4,0.7,3,1.7,3.9,2.4L1493.2,283.6z
				 M1515.4,297v1h-18.1v-1h10c1.2-2.7,2.6-7.3,3.3-10.4l1.1,0.2c-0.9,3.2-2.2,7.5-3.4,10.2L1515.4,297L1515.4,297z M1514.6,285.1
				h-16.5v-1h16.5V285.1z M1503.3,295.9c-0.4-2.5-1.3-6.2-2.1-9l1-0.2c0.9,2.9,1.8,6.6,2.1,9L1503.3,295.9z M1506.1,283.8
				c-0.2-0.9-0.6-2.3-1-3.3l0.9-0.3c0.4,1.1,0.9,2.4,1.1,3.3L1506.1,283.8z"/>
		</g>
		<g>
			<path d="M1291.8,220.9v-2.2c1.9-1.5,3.8-2.3,5.9-2.3s3.8,0.7,5.3,2.1c1.4,1.4,2.2,3.1,2.2,5.1c0,4-3.1,9.6-9.3,16.6h11.8v1.7h-16
				c7.8-7.5,11.7-13.6,11.7-18.3c0-1.6-0.5-2.9-1.6-3.9c-1.1-1.1-2.4-1.6-4-1.6c-1.1,0-2,0.2-2.9,0.7S1292.9,220.1,1291.8,220.9z"/>
			<path d="M1317.9,216.4c2.3,0,4.2,1.1,5.7,3.4c1.6,2.3,2.3,5.5,2.3,9.7c0,3.9-0.8,7-2.3,9.3s-3.4,3.5-5.7,3.5
				c-2.4,0-4.4-1.2-5.9-3.4c-1.5-2.3-2.3-5.3-2.3-9.1c0-4.7,0.8-8.1,2.5-10.2C1314,217.6,1315.8,216.4,1317.9,216.4z M1317.9,240.6
				c1.9,0,3.4-1.1,4.5-3.2c1.2-2.1,1.7-4.8,1.7-8.1c0-3.2-0.6-5.8-1.7-8c-1.1-2.1-2.6-3.2-4.5-3.2c-1.8,0-3.3,1-4.4,3.1
				c-1.2,2.1-1.7,4.8-1.7,8.1s0.6,6,1.7,8.1C1314.6,239.6,1316.1,240.6,1317.9,240.6z"/>
			<path d="M1337.4,216.8v25.3h-1.9v-25.3H1337.4z"/>
			<path d="M1351.1,242.4l-1-1.4c5.6-4,8.7-8.2,9.5-12.5c-2,1.3-3.8,1.9-5.6,1.9c-2,0-3.7-0.7-5-2s-2-3-2-4.9c0-2.1,0.7-3.7,2-5.1
				s3-2,5.1-2c2.4,0,4.3,0.8,5.7,2.4c1.4,1.6,2.1,3.7,2.1,6.5C1361.8,231.6,1358.2,237.2,1351.1,242.4z M1359.9,226.2
				c0-0.4,0.1-0.8,0.1-1.1c0-2.2-0.5-3.9-1.5-5.1s-2.4-1.8-4.2-1.8c-1.5,0-2.8,0.5-3.8,1.5s-1.5,2.2-1.5,3.7s0.5,2.7,1.5,3.8
				c1,1,2.2,1.5,3.7,1.5C1356.2,228.6,1358.1,227.9,1359.9,226.2z"/>
		</g>
	</g>
				<g>
		<path class="st1" d="M1224.5,255.4c-4.6,0-8.3,3.7-8.3,8.3s3.7,8.3,8.3,8.3c4.6,0,8.3-3.7,8.3-8.3S1229.1,255.4,1224.5,255.4z
			 M1236.3,261.8h-4.2v4.2h4.2V261.8z M1244.6,261.8h-4.2v4.2h4.2V261.8z M1252.9,261.8h-4.2v4.2h4.2V261.8z M1261.2,261.8h-4.2v4.2
			h4.2V261.8z M1269.5,261.8h-4.2v4.2h4.2V261.8z M1277.8,261.8h-4.2v4.2h4.2V261.8z"/>
					<path class="st2" d="M1224.5,273.6c-5.4,0-9.8-4.4-9.8-9.8c0-5.4,4.4-9.8,9.8-9.8c4.1,0,7.7,2.6,9.2,6.2h2.7
			c0.8,0,1.5,0.7,1.5,1.5v4.2c0,0.8-0.7,1.5-1.5,1.5h-2.7C1232.2,271,1228.6,273.6,1224.5,273.6z M1224.5,257c-3.7,0-6.8,3-6.8,6.8
			c0,3.8,3,6.8,6.8,6.8c2.8,0,5.2-1.7,6.3-4.1c-0.1-0.2-0.1-0.4-0.1-0.6v-4.2c0-0.2,0-0.4,0.1-0.6
			C1229.7,258.8,1227.3,257,1224.5,257z M1234.3,264.4h0.5v-1.1h-0.5c0,0.2,0,0.4,0,0.6C1234.3,263.9,1234.3,264.1,1234.3,264.4z
			 M1277.8,267.4h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2
			C1279.4,266.8,1278.7,267.4,1277.8,267.4z M1275.2,264.4h1.1v-1.1h-1.1V264.4z M1269.5,267.4h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2
			c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C1271,266.8,1270.4,267.4,1269.5,267.4z M1266.9,264.4h1.1v-1.1h-1.1V264.4z
			 M1261.2,267.4h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2
			C1262.7,266.8,1262.1,267.4,1261.2,267.4z M1258.6,264.4h1.1v-1.1h-1.1V264.4z M1252.9,267.4h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2
			c0-0.8,0.7-1.5,1.5-1.5h4.1c0.8,0,1.5,0.7,1.5,1.5v4.2C1254.4,266.8,1253.7,267.4,1252.9,267.4z M1250.3,264.4h1.1v-1.1h-1.1
			V264.4z M1244.6,267.4h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.1c0.8,0,1.5,0.7,1.5,1.5v4.2
			C1246.1,266.8,1245.4,267.4,1244.6,267.4z M1242,264.4h1.1v-1.1h-1.1V264.4z"/>
	</g>
</g>
			<g>
	<path class="st3" d="M1224.5,392.6c-4.6,0-8.3,3.7-8.3,8.3s3.7,8.3,8.3,8.3c4.6,0,8.3-3.7,8.3-8.3S1229.1,392.6,1224.5,392.6z
		 M1236.3,398.9h-4.2v4.2h4.2V398.9z M1244.6,398.9h-4.2v4.2h4.2V398.9z M1252.9,398.9h-4.2v4.2h4.2V398.9z M1261.2,398.9h-4.2v4.2
		h4.2V398.9z M1269.5,398.9h-4.2v4.2h4.2V398.9z M1277.8,398.9h-4.2v4.2h4.2V398.9z"/>
				<path class="st3" d="M1224.5,410.8c-5.4,0-9.8-4.4-9.8-9.8s4.4-9.8,9.8-9.8c4.1,0,7.7,2.6,9.2,6.2h2.7c0.8,0,1.5,0.7,1.5,1.5v4.2
		c0,0.8-0.7,1.5-1.5,1.5h-2.7C1232.2,408.1,1228.6,410.8,1224.5,410.8z M1224.5,394.1c-3.7,0-6.8,3-6.8,6.8c0,3.7,3,6.8,6.8,6.8
		c2.8,0,5.2-1.7,6.3-4.1c-0.1-0.2-0.1-0.4-0.1-0.6v-4.2c0-0.2,0-0.4,0.1-0.6C1229.7,395.9,1227.3,394.1,1224.5,394.1z M1234.3,401.5
		h0.5v-1.1h-0.5c0,0.2,0,0.4,0,0.6C1234.3,401.1,1234.3,401.2,1234.3,401.5z M1277.8,404.5h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2
		c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C1279.4,403.9,1278.7,404.5,1277.8,404.5z M1275.2,401.5h1.1v-1.1h-1.1V401.5
		z M1269.5,404.5h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2
		C1271,403.9,1270.4,404.5,1269.5,404.5z M1266.9,401.5h1.1v-1.1h-1.1V401.5z M1261.2,404.5h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2
		c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C1262.7,403.9,1262.1,404.5,1261.2,404.5z M1258.6,401.5h1.1v-1.1h-1.1V401.5
		z M1252.9,404.5h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.1c0.8,0,1.5,0.7,1.5,1.5v4.2
		C1254.4,403.9,1253.7,404.5,1252.9,404.5z M1250.3,401.5h1.1v-1.1h-1.1V401.5z M1244.6,404.5h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2
		c0-0.8,0.7-1.5,1.5-1.5h4.1c0.8,0,1.5,0.7,1.5,1.5v4.2C1246.1,403.9,1245.4,404.5,1244.6,404.5z M1242,401.5h1.1v-1.1h-1.1V401.5z"
				/>
</g>
			<g class="a13 ani">
	<g>
		<g>
			<path d="M1653.3,318.2h-8.4v7.6c0,0.9-0.3,1.2-0.9,1.4s-1.9,0.2-4,0.2c-0.1-0.3-0.3-0.7-0.4-1c1.8,0,3.3,0,3.8,0s0.6-0.1,0.6-0.6
		v-7.6h-8.8v-1h8.8v-5.8h-7.3v-1h15.3v1h-7v5.8h8.4L1653.3,318.2L1653.3,318.2z"/>
			<path d="M1641.7,294.8l-2.3,0.8v7.3h-1v-6.9l-3.2,1.1l-0.2-1c0.9-0.2,2.1-0.6,3.5-1.1v-5.4h-1.8c-0.2,1.4-0.6,2.7-0.9,3.8
				c-0.2-0.1-0.6-0.4-0.8-0.5c0.7-1.8,1.1-4.5,1.3-7l0.9,0.2c-0.1,0.9-0.2,1.8-0.3,2.6h1.6v-4.4h1v4.3h2.2v1h-2.2v5.1l2.3-0.7
				L1641.7,294.8z M1650.7,291.6v2.8h2.6v0.9h-2.6v6.1c0,0.7-0.2,1-0.7,1.2c-0.6,0.1-1.6,0.2-3.2,0.2c0-0.3-0.2-0.7-0.3-1
				c1.4,0,2.5,0,2.9,0c0.3,0,0.4-0.1,0.4-0.4v-6.1h-7.8v-0.9h7.8v-2.8h-8v-0.9h5.4v-3.1h-4.2v-0.9h4.2v-2.5h1v2.5h4.3v0.9h-4.3v3.1
				h5.3v0.9L1650.7,291.6L1650.7,291.6z M1644.1,296.4c1.1,1,2.2,2.4,2.7,3.4l-0.8,0.5c-0.5-1-1.6-2.4-2.7-3.4L1644.1,296.4z
				 M1673.3,287.5v4.3h-0.9v-3.5h-7.2v5.6h-1v-5.6h-7v3.5h-0.9v-4.3h8v-1.7h-6.9v-0.9h14.9v0.9h-7v1.7H1673.3z M1657.9,292.4h5v0.8
				h-5V292.4z M1657.9,294.8h13.7v8h-1V302h-11.7v0.9h-1V294.8z M1662.9,290v0.8h-4.6V290H1662.9z M1658.9,295.6v2.3h5.3v-2.3
				H1658.9z M1664.2,301.2v-2.4h-5.3v2.4H1664.2z M1670.6,295.6h-5.4v2.3h5.4V295.6z M1670.6,301.2v-2.4h-5.4v2.4H1670.6z
				 M1671.1,290v0.8h-4.7V290H1671.1z M1666.4,292.4h5.2v0.8h-5.2V292.4z M1680.1,299.2c0.5,0.2,0.9,0.7,1.8,1.2
				c1.4,0.9,3.1,1,5.4,1c2.5,0,5.4-0.1,7.5-0.3c-0.1,0.3-0.2,0.7-0.3,1c-1.3,0.1-5,0.2-7.3,0.2c-2.6,0-4.3-0.2-5.7-1.2
				c-0.8-0.5-1.5-1.2-2-1.2c-0.7,0-1.8,1.1-2.9,2.6l-0.6-0.8c1.1-1.3,2.2-2.4,3.1-2.6v-6.4h-3.1v-0.9h4L1680.1,299.2L1680.1,299.2z
				 M1680.1,289.1c-0.7-0.9-2.2-2.5-3.4-3.5l0.7-0.5c1.2,1,2.7,2.5,3.5,3.4L1680.1,289.1z M1685.1,286.6c1,0.4,2.1,0.8,3.1,1.3
				c1.3-0.5,2.7-1.3,3.7-2.1h-9.5v-0.9h10.5h0.2l0.6,0.5c-1.2,1.1-2.9,2.2-4.5,3c0.7,0.4,1.4,0.7,1.9,0.9h2.7v9.4
				c0,0.6-0.1,0.9-0.6,1.1s-1.3,0.2-2.8,0.2c-0.1-0.3-0.2-0.6-0.3-0.9c1.2,0,2.1,0,2.4,0s0.4-0.1,0.4-0.4v-2.4h-4.3v3.5h-0.9v-3.5
				h-4.1v3.6h-0.9v-10.6h6.6c-1.4-0.7-3.1-1.5-4.7-2.1L1685.1,286.6z M1683.5,290.1v2.2h4.1v-2.2H1683.5z M1687.6,295.5v-2.3h-4.1
				v2.3H1687.6z M1688.5,290.1v2.2h4.3v-2.2H1688.5z M1692.8,295.5v-2.3h-4.3v2.3H1692.8z M1706.8,284.4c-0.1,0.2-0.2,0.4-0.4,0.5
				c2.6,3.2,5.7,5.5,9.1,7.4c-0.2,0.2-0.6,0.5-0.7,0.8c-3.3-2-6.3-4.3-9-7.5c-2.2,3-5.6,5.7-8.9,7.4c-0.1-0.2-0.4-0.6-0.7-0.8
				c3.8-1.8,7.6-5,9.6-8.3L1706.8,284.4z M1706.4,301.4h8.3v0.9h-17.5v-0.9h8.2v-3.9h-5.6v-0.9h5.6v-3.7h-5.7V292h12.5v0.9h-5.8v3.7
				h5.9v0.9h-5.9V301.4z M1723.9,298.5c-2.3,0.8-4.7,1.5-6.5,2.1l-0.3-1c0.8-0.2,1.8-0.5,2.9-0.9v-6.1h-2.5v-0.9h2.5v-5h-2.7v-0.9
				h6.2v0.9h-2.6v5h2.2v0.9h-2.2v5.8l2.8-0.9L1723.9,298.5z M1735.4,290.8c-1.1,1.5-2.5,3.5-3.7,4.7c1,2.1,2.3,3.8,4.4,5.2
				c-0.2,0.2-0.5,0.5-0.7,0.7c-2.8-2-4.3-4.3-5.3-7.6v7.6c0,0.8-0.2,1.1-0.7,1.3c-0.5,0.2-1.4,0.2-3.1,0.2c-0.1-0.3-0.2-0.7-0.4-0.9
				c1.3,0,2.4,0,2.7,0c0.3,0,0.5-0.1,0.5-0.5v-5.8c-1.9,1.9-3.8,3.8-5.3,5.2l-0.7-0.8c1.5-1.3,3.8-3.5,5.9-5.5V289h-5.2v-0.9h5.2
				v-3.8h1v3.7h5.6v0.9h-5.6v0.8c0.3,2,0.6,3.6,1.2,5c1.1-1.3,2.4-3.1,3.2-4.4L1735.4,290.8z M1725.2,290.4c1,1.2,2,2.9,2.5,3.9
				l-0.8,0.4c-0.4-1.1-1.4-2.7-2.4-4L1725.2,290.4z M1733.9,287.4c-0.5-0.7-1.5-1.6-2.5-2.3l0.6-0.5c0.9,0.6,2,1.6,2.5,2.2
				L1733.9,287.4z M1746.2,293.9c-0.6-0.5-2.5-1.8-3.5-2.5c-0.7,1.2-1.9,2.5-4.2,3.5c-0.1-0.2-0.4-0.5-0.6-0.7
				c2.9-1.2,4-2.7,4.4-4.1h-4.3v-0.9h4.4c0-0.3,0-0.6,0-0.9v-1.4h-2.2c-0.4,0.8-0.9,1.4-1.4,2c-0.2-0.1-0.6-0.4-0.8-0.5
				c1-1.1,1.9-2.6,2.4-4.2l0.9,0.2c-0.2,0.5-0.4,1.1-0.6,1.6h5.9v0.9h-3.3v1.4c0,0.3,0,0.6,0,0.9h3.9v0.9h-4
				c-0.1,0.2-0.1,0.4-0.2,0.6c0.9,0.5,3.3,2,3.9,2.4L1746.2,293.9z M1741,294.5h12.2v8.3h-1v-0.7H1742v0.8h-1V294.5z M1742,295.4
				v2.4h10.2v-2.4H1742z M1752.2,301.1v-2.5H1742v2.5H1752.2z M1755,286v6.7h-6.9V286H1755z M1754,286.9h-4.9v4.9h4.9V286.9z
				 M1762.3,299.6c0.5,0.1,0.9,0.5,1.8,1c1.3,0.7,3,0.8,5.2,0.8c2.5,0,5.8-0.1,7.9-0.4c-0.1,0.3-0.3,0.8-0.3,1.1
				c-1.8,0.1-5.5,0.2-7.6,0.2c-2.3,0-4.1-0.2-5.4-0.9c-0.8-0.5-1.4-1-1.8-1c-0.7,0-1.8,0.9-2.9,2.1l-0.7-0.9c1-0.9,2-1.7,2.9-2v-6.8
				h-2.9V292h3.9L1762.3,299.6L1762.3,299.6z M1762.2,289c-0.6-0.9-2-2.3-3.1-3.3l0.7-0.5c1.2,1,2.5,2.3,3.2,3.2L1762.2,289z
				 M1776.8,292h-13.2v-0.9h6.2v-3.2h-3.6c-0.5,0.9-1.1,1.7-1.6,2.4c-0.2-0.1-0.6-0.4-0.8-0.5c1.2-1.3,2.3-3.3,2.9-5.2l0.9,0.2
				c-0.3,0.7-0.6,1.5-0.9,2.2h3.1v-2.7h1v2.7h5.1v0.9h-5.1v3.2h6V292z M1765.4,299.5v-5.7h9.7v5.7H1765.4z M1766.3,298.6h7.8v-3.9
				h-7.8V298.6z M1779.1,285.4h7.1v0.9h-3.3c-0.4,1.9-0.8,3.7-1.4,5.4h4.3v8.5h-4.3v1.7h-0.9v-8.1c-0.4,0.7-0.8,1.4-1.2,2.1
				c-0.1-0.2-0.4-0.7-0.6-0.9c1.5-2.1,2.5-5.2,3.1-8.6h-2.8L1779.1,285.4L1779.1,285.4z M1781.5,292.6v6.7h3.4v-6.7H1781.5z
				 M1797.6,293.8h-2.4v9.1h-0.9v-9.1h-4c-0.1,3.2-0.5,6.6-2.9,9.2c-0.2-0.2-0.6-0.5-0.8-0.6c2.3-2.4,2.8-5.7,2.8-8.6h-2.5v-0.9h2.5
				v-6.4h-1.9v-0.9h9.8v0.9h-2v6.4h2.4L1797.6,293.8L1797.6,293.8z M1794.2,292.8v-6.4h-4v6.4H1794.2z M1815.4,292.8
				c-0.8,2.6-2.3,4.7-4.1,6.3c1.9,1.4,4.2,2.5,6.8,3c-0.2,0.2-0.5,0.6-0.6,0.9c-2.7-0.6-5-1.7-7-3.2c-1.9,1.5-4.2,2.5-6.6,3.2
				c-0.1-0.2-0.3-0.6-0.5-0.8c2.2-0.6,4.4-1.6,6.3-3c-1.5-1.3-2.7-2.9-3.6-4.8c-1.4,2.8-3.4,5.1-6.2,6.9c-0.1-0.2-0.5-0.5-0.7-0.7
				c3.8-2.5,6.2-6,7.5-10.5h-3c-1.4,0-2,0.1-2.2,0.3c-0.1-0.2-0.2-0.8-0.4-1c0.3-0.1,0.5-0.4,0.7-0.8s1-2.1,1.4-3.7l1.1,0.2
				c-0.4,1.4-1,2.9-1.5,4h4.2c0.4-1.5,0.7-3.2,0.9-4.9l1.1,0.2c-0.2,1.7-0.5,3.2-0.9,4.7h9.3v1h-9.6c-0.2,0.9-0.5,1.7-0.8,2.5h7.5
				l0.2-0.1L1815.4,292.8z M1806.9,293.5c0.9,1.9,2.1,3.6,3.7,5c1.5-1.3,2.7-3,3.5-5H1806.9z M1815.2,288.2
				c-0.6-0.8-1.8-2.1-2.7-3.1l0.8-0.5c0.9,0.9,2.1,2.2,2.8,3L1815.2,288.2z M1820.2,301.2c0.9-1,1.7-2.8,2.1-4.3l0.9,0.2
				c-0.4,1.6-1.2,3.4-2.1,4.6L1820.2,301.2z M1835.8,294.5h-12.6v-6.1h7.8c0.9-1.2,1.9-2.9,2.5-4.2l1,0.4c-0.7,1.3-1.5,2.7-2.4,3.8
				h3.6L1835.8,294.5L1835.8,294.5z M1834.7,289.4h-10.5v4.2h10.5V289.4z M1826.9,288.2c-0.4-0.9-1.3-2.5-2.2-3.5l0.8-0.4
				c0.9,1.1,1.9,2.6,2.2,3.5L1826.9,288.2z M1832.7,301.8c1.1,0,1.2-0.3,1.3-2.2c0.2,0.1,0.6,0.3,0.9,0.4c-0.2,2.2-0.5,2.8-2.2,2.8
				h-5c-2.1,0-2.6-0.3-2.6-1.6v-4.5h1v4.5c0,0.6,0.2,0.7,1.6,0.7L1832.7,301.8L1832.7,301.8z M1828.2,295c1.4,1,3.1,2.4,3.9,3.4
				l-0.7,0.7c-0.8-1-2.5-2.6-3.9-3.5L1828.2,295z M1835.7,296.5c1.2,1.4,2.5,3.2,2.9,4.4l-0.8,0.5c-0.5-1.2-1.7-3.2-2.9-4.5
				L1835.7,296.5z M1850.1,288.1c-0.5,1.3-1.1,2.9-1.7,4.1h3.2v0.9h-10.7v-0.9h6.5c0.6-1.2,1.3-3.1,1.7-4.3L1850.1,288.1z
				 M1851.1,287.6h-9.5v-0.9h4.5c-0.2-0.7-0.6-1.6-1-2.3l0.9-0.2c0.4,0.8,0.9,1.9,1.2,2.6h4L1851.1,287.6L1851.1,287.6z
				 M1842.3,295.4h8.3v7.2h-1v-0.8h-6.3v1h-0.9L1842.3,295.4L1842.3,295.4z M1844.3,292c-0.2-1.1-0.8-2.6-1.4-3.8l0.9-0.2
				c0.7,1.2,1.2,2.7,1.4,3.8L1844.3,292z M1843.2,296.2v4.5h6.3v-4.5H1843.2z M1859,285.8c-0.7,1.8-1.8,4.2-2.7,6.2
				c2,2,2.5,3.6,2.5,5.1c0,1.1-0.2,2-0.9,2.4c-0.3,0.2-0.7,0.4-1.2,0.4c-0.5,0.1-1.3,0-1.9,0c0-0.3-0.1-0.7-0.3-1
				c0.7,0.1,1.4,0.1,1.8,0.1s0.7-0.1,0.9-0.2c0.4-0.3,0.6-1,0.6-1.8c0-1.4-0.6-2.9-2.6-4.9c0.9-1.9,1.8-4.1,2.4-5.8h-3.9v16.6h-0.9
				v-17.5h5.3l0.2-0.1L1859,285.8z"/>
		</g>
		<g>
			<path d="M1656.3,325h3.4v-12.2h-2.6V312c1.2-0.2,2.1-0.5,2.9-0.9h1v14h3.1v1.1h-7.7V325H1656.3z M1666.3,318.5
				c0-5.2,1.7-7.7,4.4-7.7c2.7,0,4.4,2.5,4.4,7.7c0,5.3-1.7,7.8-4.4,7.8C1668,326.4,1666.3,323.8,1666.3,318.5z M1674,318.5
				c0-4.5-1.3-6.7-3.2-6.7c-2,0-3.2,2.2-3.2,6.7c0,4.6,1.3,6.8,3.2,6.8C1672.7,325.4,1674,323,1674,318.5z"/>
		</g>
		<g>
			<path d="M1692.7,325.9c0,0.9-0.3,1.3-0.9,1.4c-0.7,0.2-2,0.2-4.3,0.2c-0.1-0.3-0.2-0.7-0.4-1c1.9,0,3.5,0,4,0s0.6-0.2,0.6-0.6
				v-4.8h-10.6c-0.5,2.4-1.5,4.8-3.6,6.6c-0.1-0.2-0.5-0.6-0.7-0.7c3.4-3.1,3.8-7.4,3.8-10.8v-6.1h12.1V325.9z M1691.7,320v-4.1
				h-10.1v0.1c0,1.2-0.1,2.6-0.3,3.9h10.4V320z M1681.6,311v4h10.1v-4H1681.6z M1704.4,313.2c-0.7,1.5-1.5,2.9-2.5,4.3v10h-1v-8.8
				c-0.8,0.9-1.7,1.8-2.7,2.5c-0.1-0.2-0.4-0.6-0.6-0.8c2.5-1.8,4.4-4.4,5.7-7.2h-5.3v-1h5.7c0.5-1.1,0.9-2.2,1.2-3.4l1,0.3
				c-0.3,1.1-0.7,2.1-1.1,3.1h11v1H1704.4z M1715.9,326.1v0.9h-12.5v-0.9h5.7v-6.5h-4.9v-0.9h4.9v-4.3h1v4.3h5v0.9h-5v6.5H1715.9z
				 M1727.1,322.9c0,0,0,0.3,0,0.4c-0.2,2.4-0.5,3.4-0.8,3.7c-0.3,0.3-0.6,0.4-1,0.4s-1.3,0-2.2-0.1c0-0.2-0.1-0.6-0.2-0.8
				c0.9,0.1,1.8,0.1,2.1,0.1c0.3,0,0.5,0,0.6-0.1c0.2-0.2,0.4-1,0.6-2.8h-3.3c-0.6,1.9-1.7,3.1-4,3.9c-0.1-0.2-0.4-0.5-0.6-0.7
				c2.1-0.7,3.1-1.7,3.7-3.2h-3v-0.8h3.2c0.1-0.5,0.2-0.9,0.2-1.5h0.9c-0.1,0.5-0.1,1-0.2,1.5H1727.1z M1736.5,310.5v0.8h-8.5v1.5
				h7.1v0.8H1720v-0.8h7v-1.5h-8.3v-0.8h8.3V309h1v1.5H1736.5z M1731.7,318.8c-0.3,0.5-0.7,1.1-1,1.5h5.6v0.8h-17.6v-0.8h5.7
				c-0.2-0.5-0.6-1.2-1.1-1.6l0.6-0.2h-3v-3.6h13.4v3.6h-3.5L1731.7,318.8z M1721.9,317.8h11.5v-2h-11.5V317.8z M1724.3,318.5
				c0.5,0.5,0.9,1.1,1.1,1.5l-0.8,0.3h5.1c0.4-0.6,0.8-1.3,1.1-1.8H1724.3z M1728.6,322.4h6.9v5.1h-0.9v-0.7h-5v0.8h-0.9
				L1728.6,322.4L1728.6,322.4z M1729.5,323.1v2.8h5v-2.8H1729.5z M1745.4,321.6c-1.3,2-3.6,4.3-5.7,5.7c-0.2-0.2-0.5-0.6-0.8-0.7
				c2-1.4,4.3-3.5,5.4-5.4L1745.4,321.6z M1757.2,319v1H1739v-1H1757.2z M1740.1,310.9c1.4,1.8,2.7,4.3,3.3,5.9l-0.9,0.4
				c-0.6-1.6-1.9-4.1-3.2-6L1740.1,310.9z M1746.3,309.4c1.1,2,2.1,4.5,2.4,6.2l-1,0.3c-0.3-1.7-1.3-4.3-2.3-6.2L1746.3,309.4z
				 M1751.5,321.4c1.9,1.7,4.3,4,5.6,5.5l-0.8,0.5c-1.2-1.4-3.6-3.9-5.6-5.6L1751.5,321.4z M1756.8,310.2c-1.3,2.6-3.3,5.9-4.8,8
				l-0.9-0.4c1.5-2.1,3.6-5.5,4.7-8L1756.8,310.2z M1770.5,314.2c1.9,1.9,4.9,3.7,7.6,4.5c-0.2,0.2-0.5,0.6-0.7,0.8
				c-2.8-1-6.2-3.1-8.1-5.3h-0.2v4.3h-1v-4.3h-0.2c-1.9,2.4-5.3,4.5-8.2,5.6c-0.1-0.3-0.4-0.6-0.6-0.8c2.7-0.9,5.8-2.8,7.7-4.8h-7
				v-0.9h8.4v-2.5c-2.3,0.2-4.8,0.4-7,0.5c0-0.2-0.1-0.6-0.2-0.8c4.8-0.2,10.7-0.8,13.8-1.5l0.8,0.8c-1.7,0.4-3.9,0.7-6.3,1v2.6h8.4
				v0.9h-7.2V314.2z M1775.9,322c-0.3,3.1-0.6,4.3-1.2,4.8c-0.3,0.3-0.7,0.4-1.3,0.4c-0.5,0-1.7,0-2.9-0.1c0-0.3-0.1-0.7-0.3-0.9
				c1.3,0.1,2.5,0.1,2.9,0.1s0.6,0,0.8-0.2c0.4-0.3,0.6-1.3,0.9-3.8h-4.7c0.3-0.7,0.6-1.6,0.9-2.5h-4.4c-0.6,3.5-1.9,6.2-6.1,7.6
				c-0.1-0.2-0.4-0.6-0.6-0.8c4-1.2,5.2-3.8,5.7-6.8h-3.3V319h10c-0.3,0.8-0.6,1.7-0.8,2.5h4.5L1775.9,322z M1780.5,314.6
				c1.2,0.6,2.7,1.4,3.5,2l-0.6,0.8c-0.8-0.6-2.3-1.5-3.5-2.1L1780.5,314.6z M1783.3,320.1l0.8,0.6c-0.8,2.1-1.9,4.7-2.9,6.5
				l-0.9-0.5C1781.3,325.1,1782.5,322.5,1783.3,320.1z M1781.5,309.1c1.1,0.6,2.6,1.5,3.3,2.2l-0.6,0.8c-0.7-0.7-2.1-1.6-3.3-2.3
				L1781.5,309.1z M1786.9,314.9c-0.3,1.7-0.8,3.9-1.7,5.1l-0.8-0.4c0.9-1.2,1.4-3.3,1.7-4.9L1786.9,314.9z M1788.6,309.4v7.3
				c0,4-0.4,7.9-3.2,10.9c-0.2-0.2-0.5-0.5-0.8-0.6c2.7-2.9,3-6.5,3-10.3v-7.3H1788.6z M1789.9,314.9c0.6,1.4,1.2,3.3,1.3,4.5
				l-0.8,0.3c-0.2-1.2-0.7-3.1-1.3-4.6L1789.9,314.9z M1793,309.5v17.6h-0.9v-17.6H1793z M1794.1,314.5c0.9,1.5,1.9,3.5,2.2,4.8
				l-0.8,0.4c-0.4-1.3-1.3-3.4-2.2-4.9L1794.1,314.5z M1797.6,309.4v18.2h-1v-18.2H1797.6z M1810.9,323.2c1.4,2.2,4.4,3.1,8.5,3.4
				c-0.2,0.2-0.5,0.6-0.6,0.9c-4.3-0.4-7.5-1.6-8.9-4.3l0,0c-1.2,2.5-3.6,3.7-9.1,4.3c-0.1-0.2-0.3-0.6-0.4-0.8
				c5-0.5,7.3-1.5,8.4-3.5h-8.2v-0.9h8.6c0.2-0.5,0.3-1,0.4-1.6h-6.6v-7h4.8v-1.6h-6.2v-0.9h5.4c-0.5-0.6-1.2-1.4-1.8-2l0.8-0.3
				c0.7,0.6,1.5,1.5,1.9,2.1l-0.6,0.3h4.3c0.8-0.7,1.7-1.7,2.2-2.3l0.9,0.4c-0.6,0.6-1.3,1.4-2,2h5.5v0.9h-6.2v1.6h4.9v7h-6.4
				c-0.1,0.6-0.2,1.1-0.4,1.6h9v0.9h-8.2V323.2z M1803.9,314.5v3.3h12.1v-1c-0.1,0-0.2,0-0.4,0h-2.8c-1.3,0-1.6-0.2-1.6-1.1v-1.2
				h-2.6c-0.2,1.2-0.9,2.3-3.6,3.1c-0.1-0.2-0.4-0.5-0.6-0.6c2.4-0.6,3.2-1.5,3.3-2.5L1803.9,314.5L1803.9,314.5z M1803.9,320h12.1
				v-1.4h-12.1V320z M1808.6,313.8h2.6v-1.6h-2.6V313.8z M1812,314.5v1.2c0,0.4,0.1,0.4,0.8,0.4h2.6c0.3,0,0.5,0,0.5-0.1v-1.6h-3.9
				V314.5z M1835,319.8c1.1,1.6,3,3,4.9,3.7c-0.2,0.2-0.5,0.5-0.7,0.8c-2-0.8-4.1-2.6-5.3-4.4h-6.9c-1.2,2-3.4,3.8-5.3,4.7
				c-0.2-0.2-0.5-0.6-0.7-0.8c1.8-0.7,3.7-2.3,4.9-4h-4.7v-0.9h4.2V312h-3.3v-0.9h3.3v-2.2h1v2.2h8.1v-2.2h1v2.2h3.3v0.9h-3.3v6.9
				h4.1v0.9L1835,319.8L1835,319.8z M1830.9,326.1h7.3v0.9h-15.5v-0.9h7.2v-2.7h-4.6v-0.9h4.6v-2h1v2h4.7v0.9h-4.7V326.1z
				 M1826.5,312v1.7h8.1V312H1826.5z M1826.5,316.2h8.1v-1.8h-8.1V316.2z M1826.5,318.9h8.1v-1.8h-8.1V318.9z"/>
		</g>
		<g>
			<path d="M1635.5,248.6v-2.2c1.9-1.5,3.8-2.3,5.9-2.3s3.8,0.7,5.3,2.1c1.4,1.4,2.2,3.1,2.2,5.1c0,4-3.1,9.6-9.3,16.6h11.8v1.7h-16
				c7.8-7.5,11.7-13.6,11.7-18.3c0-1.6-0.5-2.9-1.6-3.9c-1.1-1.1-2.4-1.6-4-1.6c-1.1,0-2,0.2-2.9,0.7S1636.6,247.6,1635.5,248.6z"/>
			<path d="M1661.6,244.1c2.3,0,4.2,1.1,5.7,3.4c1.6,2.3,2.3,5.5,2.3,9.7c0,3.9-0.8,7-2.3,9.3c-1.5,2.3-3.4,3.5-5.7,3.5
				c-2.4,0-4.4-1.2-5.9-3.4c-1.5-2.3-2.3-5.3-2.3-9.1c0-4.7,0.8-8.1,2.5-10.2C1657.7,245.1,1659.5,244.1,1661.6,244.1z
				 M1661.6,268.2c1.9,0,3.4-1.1,4.5-3.2c1.2-2.1,1.7-4.8,1.7-8.1c0-3.2-0.6-5.8-1.7-8c-1.1-2.1-2.6-3.2-4.5-3.2
				c-1.8,0-3.3,1-4.4,3.1c-1.2,2.1-1.7,4.8-1.7,8.1c0,3.3,0.6,6,1.7,8.1C1658.3,267.2,1659.8,268.2,1661.6,268.2z"/>
			<path d="M1672.6,248.6v-2.2c1.9-1.5,3.8-2.3,5.9-2.3s3.8,0.7,5.3,2.1c1.4,1.4,2.2,3.1,2.2,5.1c0,4-3.1,9.6-9.3,16.6h11.8v1.7h-16
				c7.8-7.5,11.7-13.6,11.7-18.3c0-1.6-0.5-2.9-1.6-3.9c-1.1-1.1-2.4-1.6-4-1.6c-1.1,0-2,0.2-2.9,0.7S1673.7,247.6,1672.6,248.6z"/>
			<path d="M1691.1,248.6v-2.2c1.9-1.5,3.8-2.3,5.9-2.3s3.8,0.7,5.3,2.1c1.4,1.4,2.2,3.1,2.2,5.1c0,4-3.1,9.6-9.3,16.6h11.8v1.7h-16
				c7.8-7.5,11.7-13.6,11.7-18.3c0-1.6-0.5-2.9-1.6-3.9c-1.1-1.1-2.4-1.6-4-1.6c-1.1,0-2,0.2-2.9,0.7S1692.2,247.6,1691.1,248.6z"/>
		</g>
	</g>
				<g>
		<path class="st1" d="M1556.9,270.1c-4.6,0-8.3,3.7-8.3,8.3s3.7,8.3,8.3,8.3c4.6,0,8.3-3.7,8.3-8.3
			C1565.2,273.9,1561.5,270.1,1556.9,270.1z M1568.7,276.4h-4.2v4.2h4.2V276.4z M1577,276.4h-4.2v4.2h4.2V276.4z M1585.3,276.4h-4.2
			v4.2h4.2V276.4z M1593.6,276.4h-4.2v4.2h4.2V276.4z M1601.9,276.4h-4.2v4.2h4.2V276.4z M1610.2,276.4h-4.2v4.2h4.2V276.4z"/>
					<path class="st2" d="M1556.9,288.2c-5.4,0-9.8-4.4-9.8-9.8s4.4-9.8,9.8-9.8c4.1,0,7.7,2.6,9.2,6.2h2.7c0.8,0,1.5,0.7,1.5,1.5v4.2
			c0,0.8-0.7,1.5-1.5,1.5h-2.7C1564.6,285.6,1561,288.2,1556.9,288.2z M1556.9,271.6c-3.7,0-6.8,3-6.8,6.8c0,3.7,3.1,6.8,6.8,6.8
			c2.8,0,5.2-1.7,6.3-4.1c-0.1-0.2-0.1-0.4-0.1-0.6v-4.2c0-0.2,0-0.4,0.1-0.6C1562.1,273.4,1559.7,271.6,1556.9,271.6z M1566.7,279
			h0.5v-1.1h-0.5c0,0.2,0,0.4,0,0.6C1566.7,278.6,1566.7,278.9,1566.7,279z M1610.2,282h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2
			c0-0.8,0.7-1.5,1.5-1.5h4.1c0.8,0,1.5,0.7,1.5,1.5v4.2C1611.8,281.4,1611.1,282,1610.2,282z M1607.6,279h1.1v-1.1h-1.1V279z
			 M1601.9,282h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2
			C1603.4,281.4,1602.8,282,1601.9,282z M1599.3,279h1.1v-1.1h-1.1V279z M1593.6,282h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2
			c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C1595.1,281.4,1594.5,282,1593.6,282z M1591,279h1.1v-1.1h-1.1V279z
			 M1585.3,282h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2
			C1586.8,281.4,1586.2,282,1585.3,282z M1582.7,279h1.1v-1.1h-1.1V279z M1577,282h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2
			c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C1578.5,281.4,1577.8,282,1577,282z M1574.4,279h1.1v-1.1h-1.1V279z"/>
	</g>
</g>
			<g class="a12 ani">
	<g>
		<g>
			<path d="M1634.1,158.9h1.3l6.1,10.3l1.7,3h0.1c-0.1-1.5-0.2-3-0.2-4.5v-8.9h1.2v15h-1.3l-6.1-10.3l-1.7-3h-0.1
				c0.1,1.4,0.2,2.8,0.2,4.3v9h-1.2V158.9z M1648.5,158.9h1.2v15h-1.2V158.9z M1653.1,171.9l0.8-0.9c1.1,1.2,2.6,2,4.3,2
				c2.2,0,3.6-1.2,3.6-2.9c0-1.8-1.2-2.4-2.7-3l-2.2-1c-1.3-0.6-3-1.5-3-3.8c0-2.2,1.9-3.8,4.5-3.8c1.8,0,3.3,0.8,4.2,1.8l-0.7,0.8
				c-0.9-0.9-2.1-1.5-3.5-1.5c-1.9,0-3.2,1-3.2,2.6c0,1.7,1.5,2.3,2.6,2.8l2.2,1c1.7,0.8,3.2,1.7,3.2,4s-1.9,4.1-4.9,4.1
				C1656,174.1,1654.2,173.2,1653.1,171.9z M1664.9,171.9l0.8-0.9c1.1,1.2,2.6,2,4.3,2c2.2,0,3.6-1.2,3.6-2.9c0-1.8-1.2-2.4-2.7-3
				l-2.2-1c-1.3-0.6-3-1.5-3-3.8c0-2.2,1.9-3.8,4.5-3.8c1.8,0,3.3,0.8,4.2,1.8l-0.7,0.8c-0.9-0.9-2.1-1.5-3.5-1.5
				c-1.9,0-3.2,1-3.2,2.6c0,1.7,1.5,2.3,2.6,2.8l2.2,1c1.7,0.8,3.2,1.7,3.2,4s-1.9,4.1-4.9,4.1
				C1667.8,174.1,1666.1,173.2,1664.9,171.9z"/>
		</g>
		<g>
			<path d="M1682.7,157.1h1v18.1h-1v-4.9c-2,0.8-4,1.7-5.6,2.4l-0.5-0.9c1.5-0.5,3.8-1.5,6.1-2.4v-6.3h-5.5v-1h5.5V157.1z
				 M1693.4,173.9c1.1,0,1.2-0.9,1.3-4.4c0.3,0.2,0.7,0.4,0.9,0.5c-0.1,3.6-0.4,4.9-2.2,4.9h-3.6c-1.6,0-2.2-0.5-2.2-2.3v-15.5h1
				v7.3c2.1-1.3,4.3-2.8,5.6-4.1l0.8,0.8c-1.7,1.4-4.2,2.9-6.4,4.2v7.2c0,1.1,0.2,1.3,1.2,1.3h3.6V173.9z M1706.8,174.6h-8.8v-16.3
				h8.8v0.9h-7.8v14.4h7.9L1706.8,174.6L1706.8,174.6z M1705.5,171.8c-0.5-1.2-1.3-2.7-2.2-4.2c-1,1.9-2.2,3.6-3.4,4.9
				c-0.2-0.2-0.6-0.5-0.8-0.6c1.4-1.4,2.6-3.2,3.6-5.3c-1.1-1.7-2.3-3.5-3.5-5l0.8-0.4c1.1,1.4,2.2,2.9,3.2,4.5
				c0.8-1.7,1.5-3.5,2.1-5.3l0.9,0.2c-0.7,2.1-1.5,4.1-2.4,6c1.1,1.7,2.1,3.4,2.6,4.7L1705.5,171.8z M1709,161.1
				c-0.5,1.6-1.2,3.1-1.9,4.2c-0.2-0.1-0.6-0.4-0.9-0.5c1.4-2,2.3-5,2.8-8.2l1,0.1c-0.2,1.2-0.4,2.3-0.7,3.3h5.9h0.2l0.6,0.2
				c-0.3,1.7-0.9,3.8-1.4,5l-0.8-0.2c0.4-1,0.8-2.6,1.1-4L1709,161.1L1709,161.1z M1711.4,163.9c0,0.6,0,1.2,0,1.8
				c0.7,4.3,2,6.7,4.6,8.9c-0.2,0.2-0.5,0.5-0.7,0.8c-2.2-1.9-3.4-4-4.2-7c-0.4,2.4-1.4,4.9-3.5,7.1c-0.2-0.2-0.5-0.5-0.7-0.7
				c3.4-3.5,3.6-7.9,3.6-10.9v-1.3h0.9L1711.4,163.9L1711.4,163.9z M1724.5,157.1c-0.1,0.3-0.3,0.6-0.4,0.9c1.8,1.8,4,4.2,5,5.7
				l-0.7,0.6c-1-1.4-2.9-3.7-4.7-5.5c-1.3,2.3-3.2,4.5-5.3,6.2c-0.2-0.2-0.5-0.5-0.8-0.6c2.7-2,4.8-4.9,6-7.5L1724.5,157.1z
				 M1726.3,174.2c1,0,1.2-0.5,1.2-3.1c0.3,0.2,0.6,0.3,0.9,0.4c-0.1,2.8-0.5,3.6-2.1,3.6h-4.1c-1.8,0-2.3-0.3-2.3-1.8v-9h7.1
				c0,0,0,0.3,0,0.5c-0.2,3.6-0.5,5-0.9,5.5c-0.3,0.3-0.6,0.4-1.1,0.4c-0.4,0-1.2,0-1.9,0c0-0.3-0.1-0.6-0.3-0.9
				c0.8,0.1,1.6,0.1,1.9,0.1s0.5,0,0.6-0.2c0.3-0.3,0.5-1.5,0.7-4.4h-5.2v8.1c0,0.7,0.2,0.9,1.3,0.9h4.2V174.2z M1731.4,170.4h-0.9
				v-11.3h0.9V170.4z M1735.5,156.9v16.8c0,0.8-0.3,1.1-0.8,1.3c-0.6,0.2-1.6,0.2-3.5,0.2c-0.1-0.2-0.2-0.7-0.4-0.9
				c1.5,0,2.8,0,3.2,0c0.4,0,0.6-0.1,0.6-0.5v-16.8h0.9V156.9z M1741.4,169.1c-0.5,1.5-1.3,3-2.1,4c-0.2-0.1-0.6-0.4-0.8-0.5
				c0.9-1,1.6-2.3,2-3.7L1741.4,169.1z M1743.8,167.9v5.7c0,0.6-0.1,0.8-0.5,1s-1,0.2-1.9,0.2c-0.1-0.2-0.2-0.6-0.4-0.9
				c0.8,0,1.4,0,1.6,0s0.3-0.1,0.3-0.3v-5.7h-4.3v-0.9h4.3v-2.5h-4.4v-0.9h5.8c0.4-1.1,1-2.6,1.2-3.6l0.9,0.2
				c-0.4,1.1-0.8,2.4-1.2,3.4h2.9v0.9h-4.3v2.5h4.1v0.9L1743.8,167.9L1743.8,167.9z M1747.8,159.9h-9V159h4.4
				c-0.3-0.6-0.7-1.4-1.1-2l0.9-0.2c0.4,0.7,1,1.6,1.3,2.3h3.5L1747.8,159.9L1747.8,159.9z M1741.2,163.6c-0.1-0.9-0.5-2.2-0.9-3.2
				l0.8-0.2c0.5,1,0.8,2.3,0.9,3.2L1741.2,163.6z M1745.7,168.9c0.7,1.1,1.4,2.5,1.8,3.4l-0.8,0.4c-0.3-0.9-1.1-2.4-1.7-3.5
				L1745.7,168.9z M1757,164.6h-2.5v10.6h-1v-10.6h-3.8v1c0,2.9-0.3,6.8-2.2,9.6c-0.1-0.2-0.5-0.5-0.7-0.6c1.9-2.6,2.1-6.2,2.1-8.9
				v-6.9c2.3-0.4,5.1-0.9,6.5-1.5l0.9,0.7c-1.7,0.6-4.2,1.1-6.4,1.4v4.4h7.2L1757,164.6L1757,164.6z M1777.4,159.2h-2.6v14.5
				c0,0.9-0.2,1.3-0.9,1.5c-0.7,0.2-2.1,0.2-4.1,0.2c-0.1-0.3-0.3-0.8-0.4-1.1c1.8,0.1,3.4,0,3.9,0c0.4,0,0.6-0.2,0.6-0.6v-14.5
				h-14.5v-1h18.2v1H1777.4z M1762.5,170.1v1.7h-1v-9.2h8.2v7.5H1762.5z M1762.5,163.6v5.6h6.3v-5.6H1762.5z M1783.3,161.1h2.4v0.9
				h-2.4v4.6l2.3-0.8l0.1,0.9c-0.8,0.3-1.6,0.6-2.4,0.9v6.4c0,0.7-0.2,0.9-0.6,1.1c-0.4,0.1-1.1,0.2-2.5,0.2c0-0.2-0.2-0.6-0.3-0.9
				c1,0,1.8,0,2.1,0c0.3,0,0.4-0.1,0.4-0.4v-6.1c-1,0.4-2,0.7-2.8,1l-0.3-1c0.8-0.2,1.9-0.6,3.1-1v-5h-2.8v-0.9h2.8v-4.3h0.9
				L1783.3,161.1L1783.3,161.1z M1795.4,164.6v2.7h2.7v0.9h-2.7v5.8c0,0.8-0.1,1.1-0.7,1.2c-0.5,0.2-1.5,0.2-3,0.2
				c0-0.3-0.2-0.7-0.3-1c1.3,0.1,2.3,0,2.7,0c0.3,0,0.4-0.1,0.4-0.4v-5.8h-8.1v-0.9h8.1v-2.7h-8.4v-0.9h5.6v-3.1h-4.5v-0.9h4.5v-2.8
				h1v2.8h4.5v0.9h-4.5v3.1h5.6v0.9H1795.4z M1788.8,168.9c0.9,1.1,1.9,2.6,2.4,3.6l-0.8,0.5c-0.4-1-1.4-2.5-2.3-3.6L1788.8,168.9z
				 M1804.6,163.6c0.5-0.8,0.9-1.6,1.3-2.4l0.8,0.5c-1.3,2.4-2.9,4.9-4.5,6.8l4.2-1c0,0.2,0,0.6,0.1,0.8c-4.9,1.3-5.5,1.5-5.9,1.8
				c-0.1-0.2-0.2-0.7-0.3-0.9c0.4-0.1,0.8-0.6,1.4-1.4c0.4-0.4,1.3-1.7,2.3-3.2c-2.8,0.4-3.3,0.5-3.5,0.6c-0.1-0.2-0.2-0.7-0.3-0.9
				c0.3-0.1,0.7-0.6,1.1-1.3c0.5-0.7,2-3.5,2.9-6l0.9,0.5c-1,2.3-2.2,4.8-3.5,6.6L1804.6,163.6z M1800.2,172.9
				c1.5-0.5,3.9-1.4,6.2-2.2l0.1,0.8c-2.1,0.8-4.4,1.6-6,2.2L1800.2,172.9z M1813.3,169.9c-0.7,2-2.3,4-6,5.5
				c-0.1-0.2-0.4-0.6-0.6-0.7c3.3-1.4,4.8-3.1,5.5-4.8h-5.2V169h5.4c0.2-0.9,0.3-1.8,0.3-2.6v-2.6h1v2.6c0,0.8,0,1.7-0.2,2.6h5v0.9
				H1813.3z M1815.9,165.4c0.4-0.7,0.8-1.6,1.1-2.6h-9.6v-0.9h4.7v-2.2h-3.9v-0.9h3.9v-2.1h1v2.1h4.2v0.9h-4.2v2.2h4.4h0.2l0.6,0.2
				c-0.5,1.3-1,2.7-1.5,3.6L1815.9,165.4z M1808.2,165.8c1,0.5,2.1,1.4,2.6,2l-0.5,0.6c-0.6-0.6-1.7-1.5-2.6-2L1808.2,165.8z
				 M1811.7,166.4c-0.5-0.6-1.6-1.5-2.6-2.1l0.6-0.5c1,0.5,2.1,1.4,2.6,2L1811.7,166.4z M1814.1,170.9c1.7,1.1,3.7,2.7,4.7,3.8
				l-0.6,0.7c-1-1.1-3-2.8-4.7-3.9L1814.1,170.9z M1838.2,160.4v9.3h-1v-1.3h-6.7v6.9h-1v-6.9h-6.7v1.4h-1v-9.4h7.6v-3.7h1v3.7
				H1838.2z M1829.5,167.6v-6.1h-6.7v6.1H1829.5z M1837.2,167.6v-6.1h-6.7v6.1H1837.2z M1844.4,164.4c-0.4,2.2-1.1,5.7-2,7.8
				l-0.9-0.4c1-2.1,1.7-5.3,2-7.6L1844.4,164.4z M1847.5,162.4V173c0,0.9,0.3,1.2,1.5,1.2h4.6c1.4,0,1.6-0.8,1.8-4.5
				c0.3,0.2,0.7,0.4,0.9,0.5c-0.2,3.9-0.5,5-2.7,5h-4.6c-2,0-2.5-0.4-2.5-2.1v-10.5h1V162.4z M1848.3,157.6c1.9,1.4,4.3,3.4,5.5,4.7
				l-0.7,0.7c-1.2-1.3-3.5-3.4-5.5-4.8L1848.3,157.6z M1857.2,163.6c1.2,2.5,2.4,5.7,2.9,7.8l-1,0.3c-0.4-2.1-1.6-5.4-2.8-7.8
				L1857.2,163.6z"/>
		</g>
		<g>
			<path d="M1639.6,193.9c-2.4,0.8-4.8,1.6-6.7,2.3l-0.3-1c0.8-0.3,1.9-0.6,3.1-1V185h-2.7v-0.9h6.3v0.9h-2.6v8.9l2.8-0.9
				L1639.6,193.9z M1644.9,188.1h1v4.4c0,2.6-0.7,5.7-6.5,7.5c-0.1-0.2-0.4-0.6-0.6-0.8c5.6-1.6,6.1-4.4,6.1-6.7V188.1z
				 M1651.5,182.4v0.9h-5.5c-0.3,0.9-0.7,1.8-1,2.5h4.9v9.6h-1v-8.7h-7.4v8.7h-1v-9.6h3.5c0.3-0.7,0.6-1.6,0.8-2.5h-5.2v-0.9H1651.5
				z M1646.8,195.9c1.7,1.1,3.8,2.5,4.8,3.5l-0.7,0.8c-1-1-3-2.6-4.7-3.6L1646.8,195.9z M1669.5,182.8v17.2h-1v-1.5H1657v1.5h-1
				v-17.2H1669.5z M1657,183.8v3.9h11.5v-3.9H1657z M1657,188.6v4h11.5v-4H1657z M1668.5,197.6v-4H1657v4H1668.5z M1692.6,198.1v1
				h-18.3v-1h3v-10h1v10h5.1V184h-8.2v-1h16.7v1h-7.5v6.1h6.8v1h-6.8v7.1h8.2V198.1z M1706.8,186.4c0.5,7.6,2.4,12.7,4.8,12.7
				c0.6,0,0.9-1.1,1-4c0.2,0.2,0.6,0.4,0.9,0.5c-0.2,3.4-0.6,4.5-2,4.5c-3.2,0-5.1-5.8-5.7-13.7h-10.9v-1h10.8
				c-0.1-1.3-0.1-2.6-0.1-4h1c0,1.4,0,2.7,0.1,4h6.4v1H1706.8z M1700.6,197.2c1.5-0.4,3.2-0.7,4.7-1.1l0.1,0.9
				c-3.6,0.9-7.4,1.8-10.1,2.4l-0.3-1c1.2-0.3,2.8-0.6,4.6-1v-6.6h-4v-1h9.2v1h-4.2L1700.6,197.2L1700.6,197.2z M1711.4,184.9
				c-0.6-0.8-2-1.9-3.1-2.7l0.7-0.6c1.1,0.7,2.5,1.9,3.2,2.6L1711.4,184.9z M1718.6,189.8c0,3.1-0.5,7.4-2.6,10.4
				c-0.2-0.2-0.6-0.6-0.8-0.7c2.2-3,2.5-7.2,2.5-10.2v-4.8h14.3v5.3H1718.6z M1718.6,185.4v3.4h12.4v-3.4H1718.6z M1732.2,192.4v7.7
				h-1v-1.4h-10.4v1.5h-1v-7.7h12.4V192.4z M1731.2,197.6v-4.3h-10.4v4.3H1731.2z M1724.4,181.4c0.6,0.8,1.2,2,1.5,2.7l-0.9,0.4
				c-0.3-0.7-0.9-1.9-1.4-2.7L1724.4,181.4z M1744.3,197.4c-0.1-0.5-0.3-1-0.5-1.6c-6,1.2-6.7,1.4-7.1,1.7l0,0
				c-0.1-0.2-0.2-0.7-0.4-1c0.3-0.1,0.6-0.7,0.9-1.5c0.3-0.7,1.3-3.3,1.8-5.9h-3v-0.9h9v0.9h-4.9c-0.6,2.4-1.4,5-2.3,7l5.7-1.1
				c-0.4-1.2-0.9-2.5-1.4-3.5l0.8-0.2c0.8,1.9,1.8,4.4,2.2,5.9L1744.3,197.4z M1744.7,184.1h-7.9v-0.9h7.9V184.1z M1754.2,186.9
				c-0.3,8.6-0.6,11.4-1.3,12.3c-0.4,0.5-0.7,0.6-1.4,0.6c-0.6,0-1.8,0-2.9-0.1c0-0.3-0.1-0.7-0.3-1c1.3,0.1,2.5,0.1,2.9,0.1
				s0.6,0,0.8-0.3c0.6-0.6,0.9-3.4,1.2-11.3h-3.7c-0.3,5-1.2,9.9-4.3,12.8c-0.1-0.2-0.5-0.5-0.8-0.7c3-2.6,3.9-7.3,4.1-12.1h-3.3v-1
				h3.3c0.1-1.5,0.1-3,0.1-4.5h1c0,1.5,0,3-0.1,4.5h4.6v0.7H1754.2z"/>
		</g>
		<g>
			<path d="M1633.6,121.2V119c1.9-1.5,3.8-2.3,5.9-2.3s3.8,0.7,5.3,2.1c1.4,1.4,2.2,3.1,2.2,5.1c0,4-3.1,9.6-9.3,16.6h11.8v1.7h-16
				c7.8-7.5,11.7-13.6,11.7-18.3c0-1.6-0.5-2.9-1.6-3.9c-1.1-1.1-2.4-1.6-4-1.6c-1.1,0-2,0.2-2.9,0.7S1634.7,120.2,1633.6,121.2z"/>
			<path d="M1659.7,116.7c2.3,0,4.2,1.1,5.7,3.4c1.6,2.3,2.3,5.5,2.3,9.7c0,3.9-0.8,7-2.3,9.3s-3.4,3.5-5.7,3.5
				c-2.4,0-4.4-1.2-5.9-3.4c-1.5-2.3-2.3-5.3-2.3-9.1c0-4.7,0.8-8.1,2.5-10.2C1655.7,117.8,1657.6,116.7,1659.7,116.7z
				 M1659.7,140.8c1.9,0,3.4-1.1,4.5-3.2c1.2-2.1,1.7-4.8,1.7-8.1c0-3.2-0.6-5.8-1.7-8c-1.1-2.1-2.6-3.2-4.5-3.2
				c-1.8,0-3.3,1-4.4,3.1c-1.2,2.1-1.7,4.8-1.7,8.1c0,3.3,0.6,6,1.7,8.1C1656.4,139.8,1657.9,140.8,1659.7,140.8z"/>
			<path d="M1670.7,121.2V119c1.9-1.5,3.8-2.3,5.9-2.3s3.8,0.7,5.3,2.1c1.4,1.4,2.2,3.1,2.2,5.1c0,4-3.1,9.6-9.3,16.6h11.8v1.7h-16
				c7.8-7.5,11.7-13.6,11.7-18.3c0-1.6-0.5-2.9-1.6-3.9c-1.1-1.1-2.4-1.6-4-1.6c-1.1,0-2,0.2-2.9,0.7S1671.7,120.2,1670.7,121.2z"/>
			<path d="M1697.7,116.9v25.3h-1.9v-25.3H1697.7z"/>
		</g>
	</g>
				<g>
		<path class="st1" d="M1556.9,152.1c-4.6,0-8.3,3.7-8.3,8.3s3.7,8.3,8.3,8.3c4.6,0,8.3-3.7,8.3-8.3
			C1565.2,155.9,1561.5,152.1,1556.9,152.1z M1568.7,158.4h-4.2v4.2h4.2V158.4z M1577,158.4h-4.2v4.2h4.2V158.4z M1585.3,158.4h-4.2
			v4.2h4.2V158.4z M1593.6,158.4h-4.2v4.2h4.2V158.4z M1601.9,158.4h-4.2v4.2h4.2V158.4z M1610.2,158.4h-4.2v4.2h4.2V158.4z"/>
					<path class="st2" d="M1556.9,170.4c-5.4,0-9.8-4.4-9.8-9.8c0-5.4,4.4-9.8,9.8-9.8c4.1,0,7.7,2.6,9.2,6.2h2.7
			c0.8,0,1.5,0.7,1.5,1.5v4.2c0,0.8-0.7,1.5-1.5,1.5h-2.7C1564.6,167.8,1561,170.4,1556.9,170.4z M1556.9,153.6
			c-3.7,0-6.8,3-6.8,6.8c0,3.7,3.1,6.8,6.8,6.8c2.8,0,5.2-1.7,6.3-4.1c-0.1-0.2-0.1-0.4-0.1-0.6v-4.2c0-0.2,0-0.4,0.1-0.6
			C1562.1,155.4,1559.7,153.6,1556.9,153.6z M1566.7,161.1h0.5v-1.1h-0.5c0,0.2,0,0.4,0,0.6C1566.7,160.6,1566.7,160.9,1566.7,161.1
			z M1610.2,164.1h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.1c0.8,0,1.5,0.7,1.5,1.5v4.2
			C1611.8,163.4,1611.1,164.1,1610.2,164.1z M1607.6,161.1h1.1v-1.1h-1.1V161.1z M1601.9,164.1h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2
			c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C1603.4,163.4,1602.8,164.1,1601.9,164.1z M1599.3,161.1h1.1v-1.1h-1.1
			V161.1z M1593.6,164.1h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2
			C1595.1,163.4,1594.5,164.1,1593.6,164.1z M1591,161.1h1.1v-1.1h-1.1V161.1z M1585.3,164.1h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2
			c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C1586.8,163.4,1586.2,164.1,1585.3,164.1z M1582.7,161.1h1.1v-1.1h-1.1
			V161.1z M1577,164.1h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2
			C1578.5,163.4,1577.8,164.1,1577,164.1z M1574.4,161.1h1.1v-1.1h-1.1V161.1z"/>
	</g>
</g>
			<g class="a14 ani">
	<g>
		<g>
			<path d="M1673,466.8l-2.3,0.8v7.3h-1v-6.9l-3.2,1.1l-0.2-1c0.9-0.2,2.1-0.6,3.5-1.1v-5.4h-1.8c-0.2,1.4-0.6,2.7-0.9,3.8
				c-0.2-0.1-0.6-0.4-0.8-0.5c0.7-1.8,1.1-4.5,1.3-7l0.9,0.2c-0.1,0.9-0.2,1.8-0.3,2.6h1.6v-4.3h1v4.3h2.2v1h-2.2v5.1l2.3-0.7
				L1673,466.8z M1682,463.5v2.8h2.6v0.9h-2.6v6.1c0,0.7-0.2,1-0.7,1.2c-0.6,0.1-1.6,0.2-3.2,0.2c0-0.3-0.2-0.7-0.3-1
				c1.4,0,2.5,0,2.9,0c0.3,0,0.4-0.1,0.4-0.4v-6.1h-7.8v-0.9h7.8v-2.8h-8v-0.9h5.4v-3.1h-4.2v-0.9h4.2v-2.5h1v2.5h4.3v0.9h-4.3v3.1
				h5.3v0.9L1682,463.5L1682,463.5z M1675.3,468.4c1.1,1,2.2,2.4,2.7,3.4l-0.8,0.5c-0.5-1-1.6-2.4-2.7-3.4L1675.3,468.4z
				 M1704.5,459.4v4.3h-0.9v-3.4h-7.2v5.6h-1v-5.6h-7v3.5h-0.9v-4.3h8v-1.7h-6.9v-0.9h14.9v0.9h-7v1.7h8V459.4z M1689.2,464.2h5v0.8
				h-5V464.2z M1689.2,466.8h13.7v8h-1V474h-11.7v0.9h-1V466.8z M1694.2,461.9v0.8h-4.6v-0.8H1694.2z M1690.2,467.5v2.3h5.3v-2.3
				H1690.2z M1695.5,473.1v-2.4h-5.3v2.4H1695.5z M1701.9,467.5h-5.4v2.3h5.4V467.5z M1701.9,473.1v-2.4h-5.4v2.4H1701.9z
				 M1702.4,461.9v0.8h-4.7v-0.8H1702.4z M1697.7,464.2h5.2v0.8h-5.2V464.2z M1711.4,471.1c0.5,0.2,0.9,0.7,1.8,1.2
				c1.4,0.9,3.1,1,5.4,1c2.5,0,5.4-0.1,7.5-0.3c-0.1,0.3-0.2,0.7-0.3,1c-1.3,0.1-5,0.2-7.3,0.2c-2.6,0-4.3-0.2-5.7-1.2
				c-0.8-0.5-1.5-1.2-2-1.2c-0.7,0-1.8,1.1-2.9,2.6l-0.6-0.8c1.1-1.3,2.2-2.4,3.1-2.6v-6.4h-3.1v-0.9h4L1711.4,471.1L1711.4,471.1z
				 M1711.3,461c-0.7-0.9-2.2-2.5-3.4-3.5l0.7-0.5c1.2,1,2.7,2.5,3.5,3.4L1711.3,461z M1716.4,458.6c1,0.4,2.1,0.8,3.1,1.3
				c1.3-0.5,2.7-1.3,3.7-2.1h-9.5v-0.9h10.5h0.2l0.6,0.5c-1.2,1.1-2.9,2.2-4.5,3c0.7,0.4,1.4,0.7,1.9,0.9h2.7v9.4
				c0,0.6-0.1,0.9-0.6,1.1s-1.3,0.2-2.8,0.2c-0.1-0.3-0.2-0.6-0.3-0.9c1.2,0,2.1,0,2.4,0s0.4-0.1,0.4-0.4v-2.4h-4.3v3.5h-0.9v-3.5
				h-4.1v3.6h-0.9v-10.7h6.6c-1.4-0.7-3.1-1.5-4.7-2.1L1716.4,458.6z M1714.8,462.1v2.2h4.1v-2.2H1714.8z M1718.9,467.5v-2.3h-4.1
				v2.3H1718.9z M1719.8,462.1v2.2h4.3v-2.2H1719.8z M1724.1,467.5v-2.3h-4.3v2.3H1724.1z M1738.1,456.2c-0.1,0.2-0.2,0.4-0.4,0.5
				c2.6,3.2,5.7,5.5,9.1,7.4c-0.2,0.2-0.6,0.5-0.7,0.8c-3.3-2-6.3-4.3-9-7.5c-2.2,3-5.6,5.7-8.9,7.4c-0.1-0.2-0.4-0.6-0.7-0.8
				c3.8-1.8,7.6-5,9.6-8.3L1738.1,456.2z M1737.7,473.2h8.3v0.9h-17.5v-0.9h8.2v-3.9h-5.6v-0.9h5.6v-3.7h-5.7v-0.9h12.5v0.9h-5.8
				v3.7h5.9v0.9h-5.9V473.2z M1755.1,470.5c-2.3,0.8-4.7,1.5-6.5,2.1l-0.3-1c0.8-0.2,1.8-0.5,2.9-0.9v-6.1h-2.5v-0.9h2.5v-5h-2.7
				v-0.9h6.2v0.9h-2.6v5h2.2v0.9h-2.2v5.8l2.8-0.9L1755.1,470.5z M1766.7,462.6c-1.1,1.5-2.5,3.5-3.7,4.7c1,2.1,2.3,3.8,4.4,5.2
				c-0.2,0.2-0.5,0.5-0.7,0.7c-2.8-2-4.3-4.3-5.3-7.6v7.6c0,0.8-0.2,1.1-0.7,1.3c-0.5,0.2-1.4,0.2-3.1,0.2c-0.1-0.3-0.2-0.7-0.4-0.9
				c1.3,0,2.4,0,2.7,0c0.3,0,0.5-0.1,0.5-0.5v-5.8c-1.9,1.9-3.8,3.8-5.3,5.2l-0.7-0.8c1.5-1.3,3.8-3.5,5.9-5.5v-5.6h-5.2V460h5.2
				v-3.7h1v3.7h5.6v0.9h-5.6v0.8c0.3,2,0.6,3.6,1.2,5c1.1-1.3,2.4-3.1,3.2-4.4L1766.7,462.6z M1756.5,462.4c1,1.2,2,2.9,2.5,3.9
				l-0.8,0.4c-0.4-1.1-1.4-2.7-2.4-4L1756.5,462.4z M1765.1,459.2c-0.5-0.7-1.5-1.6-2.5-2.3l0.6-0.5c0.9,0.6,2,1.6,2.5,2.2
				L1765.1,459.2z M1777.5,465.8c-0.6-0.5-2.5-1.8-3.5-2.5c-0.7,1.2-1.9,2.5-4.2,3.5c-0.1-0.2-0.4-0.5-0.6-0.7
				c2.9-1.2,4-2.7,4.4-4.1h-4.3V461h4.4c0-0.3,0-0.6,0-0.9v-1.4h-2.2c-0.4,0.8-0.9,1.4-1.4,2c-0.2-0.1-0.6-0.4-0.8-0.5
				c1-1.1,1.9-2.6,2.4-4.2l0.9,0.2c-0.2,0.5-0.4,1.1-0.6,1.6h5.9v0.9h-3.3v1.4c0,0.3,0,0.6,0,0.9h3.9v0.9h-4
				c-0.1,0.2-0.1,0.4-0.2,0.6c0.9,0.5,3.3,2,3.9,2.4L1777.5,465.8z M1772.3,466.5h12.2v8.3h-1V474h-10.2v0.8h-1V466.5z
				 M1773.3,467.4v2.4h10.2v-2.4H1773.3z M1783.5,473.1v-2.5h-10.2v2.5H1783.5z M1786.3,458v6.7h-6.9V458H1786.3z M1785.3,458.9
				h-4.9v4.9h4.9V458.9z M1793.6,471.5c0.5,0.1,0.9,0.5,1.8,1c1.3,0.7,3,0.8,5.2,0.8c2.5,0,5.8-0.1,7.9-0.4
				c-0.1,0.3-0.3,0.8-0.3,1.1c-1.8,0.1-5.5,0.2-7.6,0.2c-2.3,0-4.1-0.2-5.4-0.9c-0.8-0.5-1.4-1-1.8-1c-0.7,0-1.8,0.9-2.9,2.1
				l-0.7-0.9c1-0.9,2-1.7,2.9-2v-6.8h-2.9v-0.9h3.9L1793.6,471.5L1793.6,471.5z M1793.5,460.9c-0.6-0.9-2-2.3-3.1-3.3l0.7-0.5
				c1.2,1,2.5,2.3,3.2,3.2L1793.5,460.9z M1808.1,463.9h-13.2V463h6.2v-3.2h-3.6c-0.5,0.9-1.1,1.7-1.6,2.4c-0.2-0.1-0.6-0.4-0.8-0.5
				c1.2-1.3,2.3-3.3,2.9-5.2l0.9,0.2c-0.3,0.7-0.6,1.5-0.9,2.2h3.1v-2.7h1v2.7h5.1v0.9h-5.1v3.2h6V463.9z M1796.6,471.5v-5.7h9.7
				v5.7H1796.6z M1797.6,470.5h7.8v-3.9h-7.8V470.5z M1810.4,457.4h7.1v0.9h-3.3c-0.4,1.9-0.8,3.7-1.4,5.4h4.3v8.5h-4.3v1.7h-0.9
				v-8.1c-0.4,0.7-0.8,1.4-1.2,2.1c-0.1-0.2-0.4-0.7-0.6-0.9c1.5-2.1,2.5-5.2,3.1-8.6h-2.8L1810.4,457.4L1810.4,457.4z
				 M1812.8,464.5v6.7h3.4v-6.7H1812.8z M1828.9,465.6h-2.4v9.1h-0.9v-9.1h-4c-0.1,3.2-0.5,6.6-2.9,9.2c-0.2-0.2-0.6-0.5-0.8-0.6
				c2.3-2.4,2.8-5.7,2.8-8.6h-2.5v-0.9h2.5v-6.5h-1.9v-0.9h9.8v0.9h-2v6.4h2.4L1828.9,465.6L1828.9,465.6z M1825.5,464.8v-6.5h-4
				v6.4h4V464.8z M1846.7,464.8c-0.8,2.6-2.3,4.7-4.1,6.3c1.9,1.4,4.2,2.5,6.8,3c-0.2,0.2-0.5,0.6-0.6,0.9c-2.7-0.6-5-1.7-7-3.2
				c-1.9,1.5-4.2,2.5-6.6,3.2c-0.1-0.2-0.3-0.6-0.5-0.8c2.2-0.6,4.4-1.6,6.3-3c-1.5-1.3-2.7-2.9-3.6-4.8c-1.4,2.8-3.4,5.1-6.2,6.9
				c-0.1-0.2-0.5-0.5-0.7-0.7c3.8-2.5,6.2-6,7.5-10.5h-3c-1.4,0-2,0.1-2.2,0.3c-0.1-0.2-0.2-0.8-0.4-1c0.3-0.1,0.5-0.4,0.7-0.8
				s1-2.1,1.4-3.7l1.1,0.2c-0.4,1.4-1,2.9-1.5,4h4.2c0.4-1.5,0.7-3.2,0.9-4.9l1.1,0.2c-0.2,1.7-0.5,3.2-0.9,4.7h9.3v1h-9.6
				c-0.2,0.9-0.5,1.7-0.8,2.5h7.5l0.2-0.1L1846.7,464.8z M1838.2,465.5c0.9,1.9,2.1,3.6,3.7,5c1.5-1.3,2.7-3,3.5-5H1838.2z
				 M1846.5,460.1c-0.6-0.8-1.8-2.1-2.7-3.1l0.8-0.5c0.9,0.9,2.1,2.2,2.8,3L1846.5,460.1z M1851.5,473.1c0.9-1,1.7-2.8,2.1-4.3
				l0.9,0.2c-0.4,1.6-1.2,3.4-2.1,4.6L1851.5,473.1z M1867,466.5h-12.5v-6.1h7.8c0.9-1.2,1.9-2.9,2.5-4.2l1,0.4
				c-0.7,1.3-1.5,2.7-2.4,3.8h3.6V466.5z M1866,461.4h-10.5v4.2h10.5V461.4z M1858.2,460.2c-0.4-0.9-1.3-2.5-2.2-3.5l0.8-0.4
				c0.9,1.1,1.9,2.6,2.2,3.5L1858.2,460.2z M1864,473.6c1.1,0,1.2-0.3,1.3-2.2c0.2,0.1,0.6,0.3,0.9,0.4c-0.2,2.2-0.5,2.8-2.2,2.8h-5
				c-2.1,0-2.6-0.3-2.6-1.6v-4.5h1v4.5c0,0.6,0.2,0.7,1.6,0.7L1864,473.6L1864,473.6z M1859.5,467c1.4,1,3.1,2.4,3.9,3.4l-0.7,0.7
				c-0.8-1-2.5-2.6-3.9-3.5L1859.5,467z M1866.9,468.5c1.2,1.4,2.5,3.2,2.9,4.4l-0.8,0.5c-0.5-1.2-1.7-3.2-2.9-4.5L1866.9,468.5z
				 M1881.3,460.1c-0.5,1.3-1.1,2.9-1.7,4.1h3.2v0.9h-10.7v-0.9h6.5c0.6-1.2,1.3-3.1,1.7-4.3L1881.3,460.1z M1882.4,459.5h-9.5v-0.9
				h4.5c-0.2-0.7-0.6-1.6-1-2.3l0.9-0.2c0.4,0.8,0.9,1.9,1.2,2.6h4L1882.4,459.5L1882.4,459.5z M1873.5,467.2h8.3v7.2h-1v-0.8h-6.3
				v1h-0.9L1873.5,467.2L1873.5,467.2z M1875.6,464c-0.2-1.1-0.8-2.6-1.4-3.8l0.9-0.2c0.7,1.2,1.2,2.7,1.4,3.8L1875.6,464z
				 M1874.5,468.1v4.5h6.3v-4.5H1874.5z M1890.3,457.8c-0.7,1.8-1.8,4.2-2.7,6.2c2,2,2.5,3.6,2.5,5.1c0,1.1-0.2,2-0.9,2.4
				c-0.3,0.2-0.7,0.4-1.2,0.4c-0.5,0.1-1.3,0-1.9,0c0-0.3-0.1-0.7-0.3-1c0.7,0.1,1.4,0.1,1.8,0.1s0.7-0.1,0.9-0.2
				c0.4-0.3,0.6-1,0.6-1.8c0-1.4-0.6-2.9-2.6-4.9c0.9-1.9,1.8-4.1,2.4-5.8h-3.9v16.6h-0.9v-17.6h5.3l0.2-0.1L1890.3,457.8z"/>
		</g>
		<g>
			<path d="M1684.8,489.4v1.1h-18.7v-1.1H1684.8z M1696.7,494.5h-10.1v-0.9h2.1v-8.9h-1.8v-0.9h1.8v-2.7h0.9v2.7h4.4v-2.7h0.9v2.7
				h1.6v0.9h-1.6v8.9h1.7L1696.7,494.5L1696.7,494.5z M1690.6,495.2c-0.7,1.6-1.9,3.2-3,4.2c-0.2-0.1-0.6-0.5-0.8-0.6
				c1.2-1,2.3-2.4,2.9-3.9L1690.6,495.2z M1689.7,484.6v2.2h4.4v-2.2H1689.7z M1689.7,490.1h4.4v-2.5h-4.4V490.1z M1689.7,493.5h4.4
				V491h-4.4V493.5z M1693.4,495c0.8,0.9,1.7,2.3,2.1,3.1l-0.8,0.5c-0.4-0.8-1.3-2.2-2.1-3.2L1693.4,495z M1704.7,498
				c0,0.7-0.2,1.1-0.7,1.2c-0.5,0.2-1.4,0.2-2.9,0.2c0-0.3-0.2-0.7-0.4-1c1.2,0,2.3,0,2.6,0c0.3,0,0.4-0.1,0.4-0.5v-5.5h-5
				c-0.2,2.5-0.7,5.2-2,7.2c-0.2-0.2-0.6-0.5-0.8-0.6c1.8-2.8,2-6.7,2-9.7v-7.4h6.8V498z M1703.7,491.5v-3.9h-4.9v1.7
				c0,0.7,0,1.4-0.1,2.2L1703.7,491.5L1703.7,491.5z M1698.8,482.9v3.8h4.9v-3.8H1698.8z M1714,493.2c-2.4,0.8-4.8,1.6-6.7,2.3
				l-0.3-1c0.8-0.3,1.9-0.6,3.1-1v-9.2h-2.7v-0.9h6.3v0.9h-2.6v8.9l2.8-0.9L1714,493.2z M1719.2,487.5h1v4.4c0,2.6-0.7,5.7-6.5,7.5
				c-0.1-0.2-0.4-0.6-0.6-0.8c5.6-1.6,6.1-4.4,6.1-6.7V487.5z M1725.9,481.9v0.9h-5.5c-0.3,0.9-0.7,1.8-1,2.5h4.9v9.6h-1v-8.7h-7.4
				v8.7h-1v-9.6h3.5c0.3-0.7,0.6-1.6,0.8-2.5h-5.2v-0.9H1725.9z M1721.1,495.2c1.7,1.1,3.8,2.5,4.8,3.5l-0.7,0.8c-1-1-3-2.6-4.7-3.6
				L1721.1,495.2z M1743.9,482.2v17.2h-1V498h-11.5v1.5h-1v-17.2H1743.9z M1731.4,483.1v3.9h11.5v-3.9H1731.4z M1731.4,488v4h11.5
				v-4H1731.4z M1742.9,497v-4h-11.5v4H1742.9z"/>
		</g>
		<g>
			<path d="M1766.9,490.1h-8.4v7.6c0,0.9-0.3,1.2-0.9,1.4s-1.9,0.2-4,0.2c-0.1-0.3-0.3-0.7-0.4-1c1.8,0,3.3,0,3.8,0
				c0.4,0,0.6-0.1,0.6-0.6v-7.6h-8.8v-1h8.8v-5.8h-7.3v-1h15.3v1h-7v5.8h8.4L1766.9,490.1L1766.9,490.1z"/>
		</g>
		<g>
			<path d="M1768.6,496.4l0.7-0.8c0.9,0.9,2,1.8,3.9,1.8s3.5-1.6,3.5-4s-1.3-3.9-3.4-3.9c-1.1,0-1.8,0.4-2.7,0.9l-0.8-0.5l0.5-6.9
				h6.9v1.1h-5.8l-0.4,5c0.7-0.4,1.5-0.7,2.5-0.7c2.5,0,4.5,1.5,4.5,4.8s-2.3,5.1-4.7,5.1S1769.6,497.2,1768.6,496.4z"/>
		</g>
		<g>
			<path d="M1795.5,497.8c0,0.9-0.3,1.3-0.9,1.4c-0.7,0.2-2,0.2-4.3,0.2c-0.1-0.3-0.2-0.7-0.4-1c1.9,0,3.5,0,4,0s0.6-0.2,0.6-0.6
				V493h-10.6c-0.5,2.4-1.5,4.8-3.6,6.6c-0.1-0.2-0.5-0.6-0.7-0.7c3.4-3.1,3.8-7.4,3.8-10.8V482h12.1V497.8z M1794.5,492v-4.1h-10.1
				v0.1c0,1.2-0.1,2.6-0.3,3.9h10.4V492z M1784.4,483v4h10.1v-4H1784.4z"/>
		</g>
		<g>
			<path d="M1806.8,491c-0.8,0.3-1.6,0.5-2.3,0.7v6.3c0,0.7-0.2,1-0.6,1.1c-0.5,0.2-1.2,0.2-2.6,0.2c-0.1-0.2-0.2-0.6-0.4-0.9
				c1.1,0,2,0,2.2,0c0.3,0,0.4-0.1,0.4-0.4v-6c-1.1,0.3-2.1,0.6-2.9,0.9l-0.4-1c0.9-0.2,2-0.6,3.3-0.9v-4.9h-3v-0.9h3v-4.3h1v4.3
				h2.8v0.9h-2.8v4.6l2.2-0.7L1806.8,491z M1817.4,490.2c-0.9,2.4-2.4,4.4-4.3,5.8c1.6,1.2,3.6,2,5.9,2.5c-0.2,0.2-0.5,0.6-0.6,0.9
				c-2.3-0.6-4.3-1.5-6-2.8c-1.9,1.3-4.1,2.2-6.3,2.8c-0.1-0.3-0.3-0.7-0.5-0.9c2.1-0.5,4.2-1.3,6.1-2.6c-1.6-1.4-2.8-3.1-3.7-5.2
				h-0.7v-0.9h9.4l0.2-0.1L1817.4,490.2z M1810.3,484c0,1.8-0.5,3.9-2.9,5.4c-0.1-0.2-0.4-0.6-0.6-0.7c2.2-1.4,2.6-3.2,2.6-4.7v-2.3
				h6.1v4.9c0,0.6,0.1,0.8,0.4,0.8h1.9c0.2,0,0.7,0,0.9-0.1c0,0.2,0.1,0.7,0.1,0.9c-0.2,0.1-0.7,0.1-1,0.1h-1.9
				c-1.1,0-1.3-0.4-1.3-1.7v-4h-4.2L1810.3,484L1810.3,484z M1808.8,491c0.8,1.8,2,3.3,3.5,4.6c1.6-1.2,2.9-2.7,3.7-4.6H1808.8z
				 M1839,489.5h-15.2v1.8c0,2.4-0.3,5.8-2.1,8.2c-0.2-0.2-0.6-0.5-0.8-0.6c1.6-2.3,1.9-5.4,1.9-7.6v-2.8h9.8c0.6-1,1.4-2.6,1.8-3.6
				l1,0.4c-0.5,1.1-1.2,2.3-1.9,3.3h5.5L1839,489.5L1839,489.5z M1838.4,484.5h-16v-0.9h8.1c-0.3-0.7-0.9-1.6-1.5-2.4l0.9-0.3
				c0.7,0.8,1.3,1.8,1.6,2.5l-0.4,0.2h7.2v0.9H1838.4z M1827.5,488.2c-0.3-0.8-1.1-2.1-1.8-3l0.8-0.3c0.7,0.9,1.5,2.2,1.9,3
				L1827.5,488.2z"/>
		</g>
		<g>
			<path d="M1666.8,420.6v-2.2c1.9-1.5,3.8-2.3,5.9-2.3s3.8,0.7,5.3,2.1c1.4,1.4,2.2,3.1,2.2,5.1c0,4-3.1,9.5-9.3,16.6h11.8v1.7h-16
				c7.8-7.5,11.7-13.6,11.7-18.3c0-1.6-0.5-2.9-1.6-3.9c-1.1-1.1-2.4-1.6-4-1.6c-1.1,0-2,0.2-2.9,0.7
				C1668.8,419,1667.9,419.6,1666.8,420.6z"/>
			<path d="M1692.9,416c2.3,0,4.2,1.1,5.7,3.4c1.6,2.3,2.3,5.5,2.3,9.7c0,3.9-0.8,7-2.3,9.3s-3.4,3.5-5.7,3.5
				c-2.4,0-4.4-1.2-5.9-3.4c-1.5-2.3-2.3-5.3-2.3-9.1c0-4.7,0.8-8.1,2.5-10.2C1688.9,417.1,1690.8,416,1692.9,416z M1692.8,440.2
				c1.9,0,3.4-1.1,4.5-3.2c1.2-2.1,1.7-4.8,1.7-8.1c0-3.2-0.6-5.8-1.7-8c-1.1-2.1-2.6-3.2-4.5-3.2c-1.8,0-3.3,1-4.4,3.1
				c-1.2,2.1-1.7,4.8-1.7,8.1c0,3.3,0.6,6,1.7,8.1C1689.6,439.2,1691,440.2,1692.8,440.2z"/>
			<path d="M1703.8,420.6v-2.2c1.9-1.5,3.8-2.3,5.9-2.3s3.8,0.7,5.3,2.1c1.4,1.4,2.2,3.1,2.2,5.1c0,4-3.1,9.5-9.3,16.6h11.8v1.7h-16
				c7.8-7.5,11.7-13.6,11.7-18.3c0-1.6-0.5-2.9-1.6-3.9c-1.1-1.1-2.4-1.6-4-1.6c-1.1,0-2,0.2-2.9,0.7
				C1705.9,419,1704.9,419.6,1703.8,420.6z"/>
			<path d="M1734.6,416v14.3h3.5v1.5h-3.5v9.8h-1.9v-9.8h-11.5v-0.6l12.7-15.2L1734.6,416L1734.6,416z M1732.8,430.5v-10.7
				l-8.9,10.7H1732.8z"/>
		</g>
	</g>
				<g>
		<path class="st1" d="M1653.1,371.9c0-4.6-3.7-8.3-8.3-8.3c-4.6,0-8.3,3.7-8.3,8.3c0,4.6,3.7,8.3,8.3,8.3
			S1653.1,376.5,1653.1,371.9z M1646.9,384.2V380h-4.2v4.2H1646.9z M1646.9,392.5v-4.2h-4.2v4.2H1646.9z M1646.9,401v-4.2h-4.2v4.2
			H1646.9z M1646.9,409.2V405h-4.2v4.2H1646.9z M1646.9,417.5v-4.2h-4.2v4.2H1646.9z M1646.9,425.9v-4.2h-4.2v4.2H1646.9z
			 M1646.9,434.1v-4.2h-4.2v4.2H1646.9z"/>
					<path class="st2" d="M1646.9,435.6h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2
			C1648.4,435,1647.7,435.6,1646.9,435.6z M1644.2,432.6h1.1v-1.1h-1.1V432.6z M1646.9,427.4h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2
			c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C1648.4,426.6,1647.7,427.4,1646.9,427.4z M1644.2,424.4h1.1v-1.1h-1.1
			V424.4z M1646.9,419h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2
			C1648.4,418.4,1647.7,419,1646.9,419z M1644.2,416h1.1v-1.1h-1.1V416z M1646.9,410.8h-4.2c-0.8,0-1.5-0.7-1.5-1.5V405
			c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C1648.4,410,1647.7,410.8,1646.9,410.8z M1644.2,407.6h1.1v-1.1h-1.1V407.6z
			 M1646.9,402.5h-4.2c-0.4,0-0.8-0.2-1.1-0.4c-0.3-0.3-0.4-0.7-0.4-1.1v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.1c0.8,0,1.5,0.7,1.5,1.5v4.2
			C1648.4,401.8,1647.7,402.5,1646.9,402.5z M1644.2,399.4h1.1v-1.1h-1.1V399.4z M1646.9,394.1h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2
			c0-0.8,0.7-1.5,1.5-1.5h4.1c0.8,0,1.5,0.7,1.5,1.5v4.2C1648.4,393.5,1647.7,394.1,1646.9,394.1z M1644.3,391h1.1v-1.1h-1.1V391z
			 M1646.9,385.9h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-3.3c-3.6-1.4-6.2-5-6.2-9.2c0-5.4,4.4-9.8,9.8-9.8s9.8,4.4,9.8,9.8
			c0,4.2-2.6,7.7-6.2,9.2v3.3C1648.4,385.1,1647.7,385.9,1646.9,385.9z M1644.3,382.8h1.1v-1.1c-0.4,0-0.7,0-1.1,0V382.8z
			 M1644.2,378.6h1.1c3.5-0.3,6.2-3.2,6.2-6.8c0-3.7-3-6.8-6.8-6.8s-6.8,3-6.8,6.8C1638,375.4,1640.8,378.4,1644.2,378.6z"/>
	</g>
</g>
			<g class="a6 ani">
	<g>
		<g>
			<path d="M352,297.8l-2.3,0.8v7.3h-1v-6.9l-3.2,1.1l-0.2-1c0.9-0.2,2.1-0.6,3.5-1.1v-5.4H347c-0.2,1.4-0.6,2.7-0.9,3.8
				c-0.2-0.1-0.6-0.4-0.8-0.5c0.7-1.8,1.1-4.5,1.3-7l0.9,0.2c-0.1,0.9-0.2,1.8-0.3,2.6h1.6v-4.3h1v4.3h2.2v1h-2.2v5.1l2.3-0.7
				L352,297.8z M361,294.6v2.8h2.6v0.9H361v6.1c0,0.7-0.2,1-0.7,1.2c-0.6,0.1-1.6,0.2-3.2,0.2c0-0.3-0.2-0.7-0.3-1
				c1.4,0,2.5,0,2.9,0c0.3,0,0.4-0.1,0.4-0.4v-6.1h-7.8v-0.9h7.8v-2.8h-8v-0.9h5.4v-3.1h-4.2v-0.9h4.2v-2.5h1v2.5h4.3v0.9h-4.3v3.1
				h5.3v0.9L361,294.6L361,294.6z M354.4,299.4c1.1,1,2.2,2.4,2.7,3.4l-0.8,0.5c-0.5-1-1.6-2.4-2.7-3.4L354.4,299.4z M383.6,290.5
				v4.3h-0.9v-3.5h-7.2v5.6h-1v-5.6h-7v3.5h-1v-4.3h8v-1.7h-6.9v-0.9h14.9v0.9h-7v1.7H383.6z M368.2,295.2h5v0.8h-5V295.2z
				 M368.2,297.8h13.7v8h-1V305h-11.7v0.9h-1V297.8z M373.2,292.9v0.8h-4.6v-0.8H373.2z M369.2,298.6v2.3h5.3v-2.3H369.2z
				 M374.5,304.1v-2.4h-5.3v2.4H374.5z M380.9,298.6h-5.4v2.3h5.4V298.6z M380.9,304.1v-2.4h-5.4v2.4H380.9z M381.4,292.9v0.8h-4.7
				v-0.8H381.4z M376.7,295.2h5.2v0.8h-5.2V295.2z M390.4,302.1c0.5,0.2,0.9,0.7,1.8,1.2c1.4,0.9,3.1,1,5.4,1c2.5,0,5.4-0.1,7.5-0.3
				c-0.1,0.3-0.2,0.7-0.3,1c-1.3,0.1-5,0.2-7.3,0.2c-2.6,0-4.3-0.2-5.7-1.2c-0.8-0.5-1.5-1.2-2-1.2c-0.7,0-1.8,1.1-2.9,2.6l-0.6-0.8
				c1.1-1.3,2.2-2.4,3.1-2.6v-6.4h-3.1v-0.9h4v7.4H390.4z M390.3,292c-0.7-0.9-2.2-2.5-3.4-3.5l0.7-0.5c1.2,1,2.7,2.5,3.5,3.4
				L390.3,292z M395.4,289.6c1,0.4,2.1,0.8,3.1,1.3c1.3-0.5,2.7-1.3,3.7-2.1h-9.5v-0.9h10.5h0.2l0.6,0.5c-1.2,1.1-2.9,2.2-4.5,3
				c0.7,0.4,1.4,0.7,1.9,0.9h2.7v9.4c0,0.6-0.1,0.9-0.6,1.1s-1.3,0.2-2.8,0.2c-0.1-0.3-0.2-0.6-0.3-0.9c1.2,0,2.1,0,2.4,0
				s0.4-0.1,0.4-0.4v-2.4h-4.3v3.5H398v-3.5h-4.1v3.6H393v-10.6h6.6c-1.4-0.7-3.1-1.5-4.7-2.1L395.4,289.6z M393.8,293.1v2.2h4.1
				v-2.2H393.8z M397.9,298.5v-2.3h-4.1v2.3H397.9z M398.8,293.1v2.2h4.3v-2.2H398.8z M403.1,298.5v-2.3h-4.3v2.3H403.1z
				 M415.8,301.1c0,0,0,0.3,0,0.4c-0.2,2.4-0.5,3.4-0.8,3.7c-0.3,0.3-0.6,0.4-1,0.4s-1.3,0-2.2-0.1c0-0.2-0.1-0.6-0.2-0.8
				c0.9,0.1,1.8,0.1,2.1,0.1c0.3,0,0.5,0,0.6-0.1c0.2-0.2,0.4-1,0.6-2.8h-3.4c-0.6,1.9-1.7,3.1-4,3.9c-0.1-0.2-0.4-0.5-0.6-0.7
				c2.1-0.7,3.1-1.7,3.7-3.2h-3v-0.8h3.2c0.1-0.5,0.2-0.9,0.2-1.5h0.9c-0.1,0.5-0.1,1-0.2,1.5H415.8z M425.1,288.8v0.8h-8.5v1.5h7.1
				v0.8h-15.1V291h7v-1.5h-8.3v-0.8h8.3v-1.5h1v1.5H425.1z M420.3,297c-0.3,0.5-0.7,1.1-1,1.5h5.6v0.8h-17.6v-0.8h5.7
				c-0.2-0.5-0.6-1.2-1.1-1.6l0.6-0.2h-3v-3.5h13.4v3.6h-3.4L420.3,297z M410.6,296h11.5v-2h-11.5V296z M413,296.8
				c0.5,0.5,0.9,1.1,1.1,1.5l-0.8,0.3h5.1c0.4-0.6,0.8-1.3,1.1-1.8H413z M417.3,300.6h6.9v5.1h-0.9V305h-5v0.8h-0.9v-5.2H417.3z
				 M418.2,301.5v2.8h5v-2.8H418.2z M445.9,298v0.9h-18.3V298h4.5c-0.3-0.6-0.8-1.5-1.3-2l0.8-0.3c0.6,0.6,1.2,1.5,1.5,2.1l-0.6,0.2
				h3.6v-2.5h-8v-0.8h8v-1.8h-6.2v-0.8h6.2v-1.8h-7.4v-0.8h4.3c-0.3-0.6-0.8-1.4-1.3-2l0.8-0.3c0.6,0.6,1.2,1.4,1.4,2l-0.7,0.3h6
				c0.5-0.6,1.1-1.7,1.4-2.4l1,0.3c-0.4,0.7-0.9,1.5-1.4,2h4.4v0.8H437v1.8h6.4v0.8H437v1.8h8.2v0.8H437v2.5h3.1
				c0.5-0.7,1-1.7,1.3-2.3l1,0.3c-0.4,0.7-0.9,1.4-1.3,2L445.9,298L445.9,298z M430.5,300.4h12.7v5.4h-1V305h-10.7v0.7h-1V300.4z
				 M431.5,301.1v3h10.8v-3H431.5z M454.4,297.2c-0.8,0.3-1.6,0.5-2.3,0.7v6.3c0,0.7-0.2,1-0.6,1.1c-0.5,0.2-1.2,0.2-2.6,0.2
				c-0.1-0.2-0.2-0.6-0.4-0.9c1.1,0,2,0,2.2,0c0.3,0,0.4-0.1,0.4-0.4v-6c-1.1,0.3-2.1,0.6-2.9,0.9l-0.4-1c0.9-0.2,2-0.6,3.3-0.9
				v-4.9h-3v-0.9h3v-4.3h1v4.3h2.8v0.9h-2.8v4.6l2.2-0.7L454.4,297.2z M465,296.6c-0.9,2.4-2.4,4.4-4.3,5.8c1.6,1.2,3.6,2,5.9,2.5
				c-0.2,0.2-0.5,0.6-0.6,0.9c-2.3-0.6-4.3-1.5-6-2.8c-1.9,1.3-4.1,2.2-6.3,2.8c-0.1-0.3-0.3-0.7-0.5-0.9c2.1-0.5,4.2-1.3,6.1-2.6
				c-1.6-1.4-2.8-3.1-3.7-5.2h-0.7v-0.9h9.4l0.2-0.1L465,296.6z M457.9,290.2c0,1.8-0.5,3.9-2.9,5.4c-0.1-0.2-0.4-0.6-0.6-0.7
				c2.2-1.4,2.6-3.2,2.6-4.7v-2.3h6.1v4.9c0,0.6,0.1,0.8,0.4,0.8h1.9c0.2,0,0.7,0,0.9-0.1c0,0.2,0.1,0.7,0.1,0.9
				c-0.2,0.1-0.7,0.1-1,0.1h-1.9c-1.1,0-1.3-0.4-1.3-1.7v-4H458v1.4H457.9z M456.5,297.2c0.8,1.8,2,3.3,3.5,4.6
				c1.6-1.2,2.9-2.7,3.7-4.6H456.5z M486.7,295.9h-15.2v1.8c0,2.4-0.3,5.8-2.1,8.2c-0.2-0.2-0.6-0.5-0.8-0.6
				c1.6-2.3,1.9-5.4,1.9-7.6v-2.8h9.8c0.6-1,1.4-2.6,1.8-3.6l1,0.4c-0.5,1.1-1.2,2.3-1.9,3.3h5.5L486.7,295.9L486.7,295.9z
				 M486.1,290.8h-16v-0.9h8.1c-0.3-0.7-0.9-1.6-1.5-2.4l0.9-0.3c0.7,0.8,1.3,1.8,1.6,2.5l-0.4,0.2h7.2L486.1,290.8L486.1,290.8z
				 M475.1,294.5c-0.3-0.8-1.1-2.1-1.8-3l0.8-0.3c0.7,0.9,1.5,2.2,1.9,3L475.1,294.5z"/>
		</g>
		<g>
			<path d="M337.8,323.6v15.7h-1v-1.1h-11.7v1.3h-1v-15.8h5.1c0.4-0.9,0.8-2.1,1-2.9l1.1,0.2c-0.3,0.9-0.7,1.9-1.1,2.7h7.6V323.6z
				 M325.1,324.5v3.6h11.7v-3.6H325.1z M325.1,329.1v3.5h11.7v-3.5H325.1z M336.8,337.2v-3.6h-11.7v3.6H336.8z M349.1,324.5
				c-0.4,1-0.9,1.9-1.5,2.8h10.2v10.6c0,0.7-0.2,1.1-0.7,1.2c-0.6,0.2-1.7,0.2-3.5,0.2c-0.1-0.3-0.2-0.7-0.4-1c1.5,0.1,2.8,0,3.2,0
				c0.4,0,0.5-0.1,0.5-0.5v-2.5h-9.4v4.2h-1v-10.6c-1.1,1.5-2.4,2.8-3.9,3.8c-0.1-0.2-0.4-0.6-0.6-0.8c2.6-1.8,4.6-4.5,6-7.4h-5.5
				v-0.9h6c0.4-0.9,0.7-1.8,1-2.8l1,0.2c-0.3,0.9-0.6,1.7-0.9,2.5h10.8v0.9L349.1,324.5L349.1,324.5z M356.8,328.2h-9.3v2.6h9.3
				V328.2z M356.8,334.4v-2.6h-9.3v2.6H356.8z M363.5,330.6h7v8.6h-1v-1h-5v1.2h-1V330.6z M364.5,331.5v5.7h5v-5.7H364.5z
				 M377.4,328.1h-10.8v-6.5h10.8V328.1z M376.4,322.6h-8.8v4.6h8.8V322.6z M380.5,330.6v8.7h-1v-1H374v1.2h-1v-8.8h7.5V330.6z
				 M379.6,337.2v-5.7h-5.5v5.7H379.6z M385.3,329.1c0,0.6,0,1.1,0,1.7h4v8.6h-0.9v-7.6h-3.1c-0.1,2.6-0.4,5.4-1.4,7.7
				c-0.2-0.1-0.6-0.3-0.9-0.4c1.2-2.9,1.4-6.9,1.4-10v-8h0.9v5.5h2.2v-5.9h0.9v5.9h1.8v0.9h-5v1.6H385.3z M401.8,335h-4.1v4.4h-0.9
				V335h-6.6v-0.9h6.6v-3.5h0.9v3.5h4.1V335z M395.5,330.5c-0.7,1.2-1.9,2.3-3.7,3.4c-0.2-0.2-0.5-0.5-0.7-0.6
				c1.5-0.8,2.6-1.8,3.3-2.7h-3v-7.7h3.2c0.3-0.7,0.6-1.5,0.7-2.2l1.1,0.2c-0.2,0.7-0.5,1.4-0.8,2h5.4v7.7L395.5,330.5L395.5,330.5z
				 M392.3,326.4h3.5c0-0.2,0-0.5,0-0.7v-1.9h-3.6v2.6H392.3z M394.9,329.8c0.5-0.9,0.7-1.8,0.8-2.6h-3.5v2.6H394.9z M399.9,327.1
				h-3.2c-0.1,0.8-0.3,1.7-0.7,2.6h3.9L399.9,327.1L399.9,327.1z M399.9,323.8h-3.2v1.9c0,0.2,0,0.4,0,0.7h3.2V323.8z"/>
		</g>
		<g>
			<path d="M408.5,336l0.8-0.9c1.1,1.2,2.6,2,4.3,2c2.2,0,3.6-1.2,3.6-2.9c0-1.8-1.2-2.4-2.7-3l-2.2-1c-1.3-0.6-3-1.5-3-3.8
				c0-2.2,1.9-3.8,4.5-3.8c1.8,0,3.3,0.8,4.2,1.8l-0.7,0.8c-0.9-0.9-2.1-1.5-3.5-1.5c-1.9,0-3.2,1-3.2,2.6c0,1.7,1.5,2.3,2.6,2.8
				l2.2,1c1.7,0.8,3.2,1.7,3.2,4s-1.9,4.1-4.9,4.1C411.4,338.1,409.7,337.2,408.5,336z M420.9,323.5c0-0.6,0.5-1,1-1s1,0.4,1,1
				s-0.5,0.9-1,0.9S420.9,324,420.9,323.5z M421.3,327h1.2v11h-1.2V327z M426.5,327h1l0.1,1.7l0,0c1-1.1,2.2-2,3.5-2
				c1.8,0,2.6,0.9,3,2.2c1.2-1.3,2.4-2.2,3.7-2.2c2.2,0,3.3,1.4,3.3,4.2v7h-1.2V331c0-2.3-0.8-3.3-2.4-3.3c-1,0-2,0.7-3.2,2v8.2
				h-1.2V331c0-2.3-0.7-3.3-2.4-3.3c-1,0-2,0.7-3.2,2v8.2h-1V327z M444.1,332.5c0-3.7,2.3-5.8,5-5.8s5,2.1,5,5.8
				c0,3.6-2.3,5.7-5,5.7S444.1,336,444.1,332.5z M452.8,332.5c0-2.8-1.6-4.7-3.7-4.7s-3.7,1.9-3.7,4.7c0,2.8,1.6,4.7,3.7,4.7
				S452.8,335.2,452.8,332.5z M457.4,327h1l0.1,1.7l0,0c1.1-1.1,2.2-2,3.8-2c2.3,0,3.3,1.4,3.3,4.2v7h-1.2V331
				c0-2.3-0.7-3.3-2.4-3.3c-1.3,0-2.2,0.7-3.5,2v8.2h-1.2V327H457.4z M474.5,322.9h1.2v14h6.8v1.1h-8V322.9z M484.8,323.5
				c0-0.6,0.5-1,1-1s1,0.4,1,1s-0.5,0.9-1,0.9C485.2,324.4,484.8,324,484.8,323.5z M485.2,327h1.2v11h-1.2V327z"/>
		</g>
		<g>
			<path d="M313.8,349.2c-0.2,0.8-0.5,1.6-0.7,2.3h6.7V364h-1v-1.3h-11.2v1.3h-1v-12.5h5.4c0.2-0.7,0.4-1.6,0.6-2.3H304v-0.9h11.5
				c0.7-0.8,1.6-2,2-2.9l1,0.4c-0.6,0.9-1.3,1.8-1.9,2.6h5.5v0.9h-8.3V349.2z M318.9,352.5h-11.2v2.5h11.2V352.5z M318.9,355.9
				h-11.2v2.6h11.2V355.9z M318.9,362v-2.7h-11.2v2.6h11.2V362z M308.8,345.5c0.7,0.7,1.5,1.8,1.9,2.5l-0.9,0.5
				c-0.4-0.7-1.2-1.8-1.9-2.5L308.8,345.5z M329.7,355.6c-1.3,2.1-2.9,4.5-4.2,6.2l-0.9-0.7c1.2-1.5,3-4,4.4-6.2L329.7,355.6z
				 M328.8,350.4c-0.8-0.8-2.5-2-3.9-2.8l0.6-0.7c1.4,0.7,3.1,1.9,3.9,2.7L328.8,350.4z M336.5,352.6c0,0.4,0,0.9,0,1.4
				c0.9,4.5,3,7.8,6.6,9.1c-0.2,0.2-0.5,0.6-0.7,0.8c-3.2-1.3-5.2-4-6.3-7.7c-0.6,2.7-2.3,5.6-7,7.9c-0.1-0.2-0.5-0.6-0.7-0.7
				c6.6-3.3,7-7.7,7-10.8v-1.3h1v1.3H336.5z M332.9,350.1c-0.6,1.7-1.3,3.2-2.1,4.4c-0.2-0.1-0.7-0.4-0.9-0.6
				c1.5-2.1,2.6-5.2,3.3-8.4l1,0.2c-0.2,1.2-0.6,2.4-0.9,3.5h8.3l0.2-0.1l0.7,0.4c-0.5,1.9-1.4,4-2.1,5.4l-0.8-0.4
				c0.6-1.1,1.3-2.8,1.7-4.3h-8.4V350.1z M351.9,349.8c-0.7,1.5-1.5,2.9-2.5,4.3v10h-1v-8.8c-0.8,0.9-1.7,1.8-2.7,2.5
				c-0.1-0.2-0.4-0.6-0.6-0.8c2.5-1.8,4.4-4.4,5.7-7.2h-5.3v-1h5.7c0.5-1.1,0.9-2.2,1.2-3.4l1,0.3c-0.3,1.1-0.7,2.1-1.1,3.1h11v1
				H351.9z M363.4,362.6v0.9h-12.5v-0.9h5.7v-6.4h-4.9v-1h4.9V351h1v4.3h5v0.9h-5v6.5H363.4z M376,358.2c1.5,2.7,4.4,4.2,8.3,4.8
				c-0.2,0.2-0.5,0.6-0.6,0.9c-4.1-0.7-7.2-2.6-8.7-5.7l0,0c-1,3-3.2,4.9-8.6,5.8c-0.1-0.2-0.4-0.7-0.5-0.9c5-0.8,7.1-2.3,8-4.9
				h-7.4v-0.9h7.6c0.1-0.6,0.3-1.2,0.4-1.9h-8.4v-0.9h8.5v-2.1H368v-0.9h6.6v-2.1H367v-0.9h4.6c-0.4-0.8-1.1-1.9-1.9-2.7l0.8-0.4
				c0.8,0.8,1.6,2,1.9,2.7l-0.7,0.4h5.9c0.7-0.9,1.5-2.2,2-3.1l1,0.4c-0.5,0.9-1.2,1.9-1.8,2.7h4.7v0.9h-8v2.1h6.8v0.9h-6.8v2.1h8.7
				v0.9h-8.7c-0.1,0.7-0.2,1.3-0.3,1.9h8.9v0.9L376,358.2L376,358.2z M404,346.5v17.7h-1v-1.1h-14.8v1.1h-1v-17.7H404z M403,362.1
				v-14.8h-14.8v14.8H403z M401.5,359v0.9h-11.6V359h5.2v-4.1h-4.2V354h4.2v-3.5h-4.8v-0.9h10.8v0.9H396v3.5h4.5v0.9H396v4.1H401.5z
				 M398.3,355.5c0.9,0.7,1.9,1.8,2.3,2.4l-0.7,0.5c-0.5-0.7-1.4-1.8-2.3-2.5L398.3,355.5z M425.1,347.8v0.9h-17.9v-0.9h8.7
				c-0.2-0.7-0.4-1.5-0.7-2.1l0.9-0.2c0.3,0.7,0.6,1.6,0.8,2.3L425.1,347.8L425.1,347.8z M424.3,362.9c0,0.6-0.1,0.8-0.5,0.9
				c-0.5,0.1-1.2,0.1-2.5,0.1c-0.1-0.2-0.2-0.6-0.4-0.8c0.9,0,1.8,0,2,0s0.3-0.1,0.3-0.3v-6.5h-14.3v7.9h-1v-8.8h16.3v7.5H424.3z
				 M422,350v4h-11.4v-4H422z M421,350.9h-9.5v2.3h9.4v-2.3H421z M420.3,361.6h-7.6v1.1h-0.9v-5.1h8.6v4H420.3z M412.7,358.5v2.4
				h6.7v-2.4H412.7z M427.5,363.8c1.1-1,2.2-2.6,2.9-4.2l0.9,0.2c-0.7,1.6-1.8,3.3-2.9,4.3L427.5,363.8z M443.5,358h-13.4v-6.2h6
				v-6.4h1v2.4h8v0.9h-8v3h6.4V358z M442.5,352.8H431v4.3h11.5V352.8z M434.7,360c0.3,1.3,0.5,2.9,0.5,3.8l-1,0.2
				c0-1-0.2-2.7-0.5-3.9L434.7,360z M438.9,359.8c0.6,1.2,1.3,2.9,1.5,3.9l-0.9,0.2c-0.2-1-0.8-2.7-1.5-3.9L438.9,359.8z
				 M443.1,359.5c1.1,1.3,2.2,3,2.8,4.1L445,364c-0.5-1.1-1.6-2.9-2.7-4.1L443.1,359.5z M460.7,353c1.5,1.8,3.9,3.4,6.1,4.3
				c-0.2,0.2-0.5,0.5-0.7,0.8c-2.3-1-5-2.9-6.5-5h-4.3c-1.7,2.3-3.9,4-6.4,5.3c-0.1-0.2-0.5-0.6-0.7-0.8c2.4-1,4.4-2.6,6-4.5h-5.8
				v-0.9h6.4c0.5-0.7,0.9-1.5,1.2-2.3c-4.1,0.2-4.7,0.3-5.1,0.4c0-0.2-0.2-0.7-0.3-1c0.4,0,0.9-0.2,1.4-0.6c0.6-0.4,2.7-1.7,4.2-3.2
				l0.9,0.5c-1.4,1.2-2.8,2.3-4.3,3.1l9.3-0.4c-0.9-0.7-1.9-1.4-2.8-2l0.7-0.6c1.9,1.1,4.2,2.8,5.3,4.1l-0.8,0.6
				c-0.4-0.4-0.8-0.9-1.4-1.4l-6.5,0.3l0.5,0.1c-0.3,0.8-0.7,1.5-1.1,2.2h10.5v0.9h-5.8V353z M464,359.5c-2.5,2.5-7.3,4-12.5,4.7
				c-0.1-0.3-0.3-0.6-0.5-0.9c5.1-0.6,9.8-2,12.1-4.3L464,359.5z M461.3,357.1c-2,1.6-5.4,2.9-8.5,3.6c-0.1-0.2-0.4-0.6-0.6-0.8
				c3-0.6,6.4-1.9,8.2-3.3L461.3,357.1z M459.4,354.8c-1.6,1.3-4.1,2.4-6.3,3.1c-0.2-0.2-0.5-0.5-0.7-0.7c2.1-0.6,4.7-1.6,6.1-2.8
				L459.4,354.8z M471.7,350.9v1.6c0,3.4-0.3,8.3-2.4,11.6c-0.1-0.2-0.6-0.4-0.8-0.5c2.1-3.3,2.3-7.8,2.3-11.1v-6h15.1v4.3h-14.2
				V350.9z M471.7,347.5v2.6h13.1v-2.6H471.7z M485.8,358.6c-1.1,0.8-2.5,1.7-3.6,2.3c1.4,1.1,3.2,1.9,5.2,2.4
				c-0.2,0.2-0.5,0.6-0.6,0.8c-3.8-0.9-6.6-3.2-8-6.4h-3.3v4.8l5-1.2c0,0.3,0,0.7,0,0.9c-5.6,1.4-6.1,1.6-6.5,1.9
				c-0.1-0.2-0.3-0.7-0.5-0.9c0.4-0.2,1-0.6,1-1.4v-4.1h-2.6v-0.9h4v-2.6h-3.4v-0.9h3.4v-2h0.9v2h4.8v-2h0.9v2h3.8v0.9h-3.8v2.6h4.6
				v0.9h-7.5c0.5,1,1.1,1.9,1.9,2.7c1.1-0.6,2.6-1.6,3.5-2.3L485.8,358.6z M476.9,356.9h4.8v-2.6h-4.8V356.9z"/>
		</g>
		<g>
			<path d="M415.8,252.6v-2.2c1.9-1.5,3.8-2.3,5.9-2.3s3.8,0.7,5.3,2.1c1.4,1.4,2.2,3.1,2.2,5.1c0,4-3.1,9.6-9.3,16.6h11.8v1.7h-16
				c7.8-7.5,11.7-13.6,11.7-18.3c0-1.6-0.5-2.9-1.6-3.9c-1.1-1.1-2.4-1.6-4-1.6c-1.1,0-2,0.2-2.9,0.7
				C417.9,250.9,416.9,251.6,415.8,252.6z"/>
			<path d="M441.9,248.1c2.3,0,4.2,1.1,5.7,3.4c1.6,2.3,2.3,5.5,2.3,9.7c0,3.9-0.8,7-2.3,9.3c-1.5,2.3-3.4,3.5-5.7,3.5
				c-2.4,0-4.4-1.2-5.9-3.4c-1.5-2.3-2.3-5.3-2.3-9.1c0-4.7,0.8-8.1,2.5-10.2C437.9,249.1,439.8,248.1,441.9,248.1z M441.8,272.2
				c1.9,0,3.4-1.1,4.5-3.2c1.2-2.1,1.7-4.8,1.7-8.1c0-3.2-0.6-5.8-1.7-8c-1.1-2.1-2.6-3.2-4.5-3.2c-1.8,0-3.3,1-4.4,3.1
				c-1.2,2.1-1.7,4.8-1.7,8.1c0,3.3,0.6,6,1.7,8.1C438.6,271.2,440.1,272.2,441.8,272.2z"/>
			<path d="M460.5,248.1c2.3,0,4.2,1.1,5.7,3.4c1.6,2.3,2.3,5.5,2.3,9.7c0,3.9-0.8,7-2.3,9.3c-1.5,2.3-3.4,3.5-5.7,3.5
				c-2.4,0-4.4-1.2-5.9-3.4c-1.5-2.3-2.3-5.3-2.3-9.1c0-4.7,0.8-8.1,2.5-10.2C456.5,249.1,458.3,248.1,460.5,248.1z M460.4,272.2
				c1.9,0,3.4-1.1,4.5-3.2c1.2-2.1,1.7-4.8,1.7-8.1c0-3.2-0.6-5.8-1.7-8c-1.1-2.1-2.6-3.2-4.5-3.2c-1.8,0-3.3,1-4.4,3.1
				c-1.2,2.1-1.7,4.8-1.7,8.1c0,3.3,0.6,6,1.7,8.1C457.1,271.2,458.6,272.2,460.4,272.2z"/>
			<path d="M484,248.4v1.8h-8.9v8c0.7-0.1,1.4-0.2,2-0.2c2.5,0,4.5,0.7,6.1,2.1c1.5,1.4,2.3,3.3,2.3,5.7c0,2.3-0.8,4.3-2.3,5.8
				c-1.6,1.6-3.5,2.3-5.8,2.3c-1.9,0-4-0.6-6.1-1.7v-2c2.4,1.4,4.4,2,6.1,2c1.8,0,3.3-0.6,4.5-1.8c1.2-1.2,1.8-2.7,1.8-4.5
				c0-2-0.6-3.5-1.9-4.6c-1.2-1.1-2.9-1.7-5-1.7c-1.1,0-2.3,0.2-3.5,0.5v-11.8H484V248.4z"/>
		</g>
	</g>
				<g>
		<path class="st1" d="M546.5,313.6c4.6,0,8.3,3.7,8.3,8.3s-3.7,8.3-8.3,8.3s-8.3-3.7-8.3-8.3S541.9,313.6,546.5,313.6z M534.7,320
			h4.2v4.2h-4.2V320z M526.4,320h4.2v4.2h-4.2V320z M518.1,320h4.2v4.2h-4.2V320z M509.8,320h4.2v4.2h-4.2V320z M501.5,320h4.2v4.2
			h-4.2V320z M493.2,320h4.2v4.2h-4.2V320z"/>
					<path class="st2" d="M546.5,331.9c-4.1,0-7.7-2.6-9.2-6.2h-2.7c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h2.7
			c1.4-3.6,5-6.2,9.2-6.2c5.4,0,9.8,4.4,9.8,9.8C556.4,327.5,552,331.9,546.5,331.9z M540.3,324.6c1,2.4,3.4,4.1,6.3,4.1
			c3.7,0,6.8-3,6.8-6.8s-3-6.8-6.8-6.8c-2.8,0-5.2,1.7-6.3,4.1c0.1,0.2,0.1,0.4,0.1,0.6v4.2C540.4,324.2,540.4,324.5,540.3,324.6z
			 M536.2,322.5h0.5c0-0.2,0-0.4,0-0.6s0-0.4,0-0.6h-0.5V322.5z M530.6,325.5h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2
			c0-0.8,0.7-1.5,1.5-1.5h4.1c0.8,0,1.5,0.7,1.5,1.5v4.2C532.1,324.9,531.4,325.5,530.6,325.5z M527.9,322.5h1.1v-1.1h-1.1V322.5z
			 M522.3,325.5h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.1c0.8,0,1.5,0.7,1.5,1.5v4.2
			C523.8,324.9,523.1,325.5,522.3,325.5z M519.6,322.5h1.1v-1.1h-1.1V322.5z M513.9,325.5h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2
			c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C515.5,324.9,514.8,325.5,513.9,325.5z M511.3,322.5h1.1v-1.1h-1.1V322.5z
			 M505.6,325.5h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2
			C507.2,324.9,506.5,325.5,505.6,325.5z M503,322.5h1.1v-1.1H503V322.5z M497.3,325.5h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2
			c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C498.9,324.9,498.2,325.5,497.3,325.5z M494.7,322.5h1.1v-1.1h-1.1V322.5z"
					/>
	</g>
</g>
			<g class="a11 ani">
	<g>
		<g>
			<path d="M980.4,135.6h-12.8v-0.9h12.8V135.6z M984.4,130.3c0,0,0,0.4,0,0.5c-0.6,5.9-1.2,8.2-2.1,9.1c-0.4,0.4-0.9,0.5-1.6,0.6
				c-0.7,0-2.1,0-3.6-0.1c0-0.3-0.1-0.7-0.4-0.9c1.6,0.1,3.1,0.1,3.7,0.1c0.5,0,0.8,0,1.1-0.2c0.8-0.7,1.3-2.9,1.9-8.1H970
				c0.6-2.2,1.5-6,2-8.7l1,0.1c-0.1,0.8-0.3,1.6-0.5,2.4h11.9v1h-12.1c-0.3,1.5-0.7,3-1,4.2H984.4z M998.2,134.9
				c1.5,2.7,4.4,4.2,8.3,4.8c-0.2,0.2-0.5,0.6-0.6,0.9c-4.1-0.7-7.2-2.6-8.7-5.7l0,0c-1,3-3.2,4.9-8.6,5.8c-0.1-0.2-0.4-0.7-0.5-0.9
				c5-0.8,7.1-2.3,8-4.9h-7.3v-0.9h7.6c0.1-0.6,0.3-1.2,0.4-1.9h-8.4v-0.9h8.5v-2.1h-6.6v-0.9h6.6v-2.1h-7.6v-0.9h4.6
				c-0.4-0.8-1.1-1.9-1.9-2.7l0.8-0.4c0.8,0.8,1.6,2,1.9,2.7l-0.7,0.4h5.9c0.7-0.9,1.5-2.2,2-3.1l1,0.4c-0.5,0.9-1.2,1.9-1.8,2.7
				h4.7v0.9h-7.7v2.1h6.8v0.9h-6.8v2.1h8.7v0.9h-8.7c-0.1,0.7-0.2,1.3-0.3,1.9h8.9v0.9C1006.7,134.9,998.2,134.9,998.2,134.9z
				 M1025,139.6c0.9,0,1.1-0.4,1.2-3.2c0.3,0.2,0.7,0.4,0.9,0.4c-0.1,3-0.5,3.7-2,3.7h-3.6c-1.6,0-2.1-0.3-2.1-1.6v-5.2h-3.5
				c-0.5,3.6-1.9,5.9-6.7,7c-0.1-0.3-0.4-0.7-0.6-0.9c4.5-0.9,5.8-3,6.2-6.2h-3.5v-5.8h5.9v-2.6h-8.3v-0.9h8.3V122h1v2.3h8.4v0.9
				h-8.4v2.7h6.1v5.8h-3.9v5.2c0,0.6,0.2,0.7,1.2,0.7C1021.6,139.6,1025,139.6,1025,139.6z M1012.3,132.8h11v-4h-11L1012.3,132.8
				L1012.3,132.8z M1045.4,130.1c-1,0.8-2.3,1.8-3.5,2.6c1,2.9,3.2,5.4,5.9,6.5c-0.2,0.2-0.5,0.5-0.7,0.8c-2.7-1.2-4.9-3.7-6.1-6.8
				c-0.4,0.3-0.8,0.5-1.2,0.7c0.8,2.7,0.3,5.4-0.9,6.2c-0.6,0.5-1.1,0.6-1.9,0.6c-0.4,0-1.1,0-1.8-0.1c0-0.3-0.1-0.7-0.3-0.9
				c0.7,0.1,1.5,0.1,1.9,0.1c0.6,0,1,0,1.4-0.4c0.8-0.5,1.2-2.3,0.9-4.4c-2.3,1.9-6,3.8-9.1,4.7c-0.1-0.3-0.4-0.6-0.5-0.9
				c3.3-0.8,7.4-2.8,9.4-4.8c-0.2-0.6-0.4-1.2-0.7-1.9c-2,1.4-5.3,3-7.8,3.8c-0.1-0.2-0.4-0.6-0.5-0.8c2.6-0.7,6.1-2.3,7.9-3.7
				c-0.3-0.5-0.7-1.1-1.2-1.5c-1.9,1.1-4.1,2-6.1,2.6c-0.1-0.2-0.4-0.6-0.6-0.8c2.7-0.7,5.7-1.9,7.7-3.4h-5.3v-0.9h12.1v0.9h-5.5
				c-0.5,0.4-1,0.8-1.5,1.2c1.1,1.1,1.8,2.3,2.3,3.5c1.6-1,3.7-2.5,4.9-3.6L1045.4,130.1z M1031,128.1h-1v-4h7.9
				c-0.2-0.6-0.6-1.2-0.9-1.8l1-0.3c0.4,0.6,0.9,1.4,1.1,2h7.8v4h-1v-3h-15L1031,128.1L1031,128.1z M1060.9,131.4v2.8h5.4v6.4h-1
				v-0.7h-9.7v0.8h-1v-6.5h5.2v-2.8h-7.2c-0.1,3.1-0.7,6.7-2.4,9.3c-0.2-0.2-0.6-0.4-0.8-0.5c2.1-3.3,2.3-7.7,2.3-11v-5.9h14.9v4.6
				h-5.8v2.7h7.1v0.9h-7V131.4z M1059.9,130.6v-2.7h-7.1v1.3c0,0.4,0,0.8,0,1.3L1059.9,130.6L1059.9,130.6z M1052.8,124.2v2.8h12.9
				v-2.8H1052.8z M1065.3,135.2h-9.7v3.9h9.7V135.2z M1073.9,127.8v12.9h-0.9v-12.9h-2.5v-0.9h2.5v-4.8h0.9v4.8h2.4v0.9H1073.9z
				 M1086.2,126.1c0,0,0,0.5,0,0.6c-0.2,9.4-0.5,12.4-1.2,13.3c-0.3,0.5-0.7,0.6-1.4,0.6c-0.6,0-1.8,0-2.8-0.1c0-0.3-0.1-0.7-0.3-1
				c1.3,0.1,2.5,0.1,2.9,0.1s0.6-0.1,0.8-0.3c0.6-0.7,0.8-3.7,1.1-12.3h-3.4c-0.1,4.3-1,9.6-6,13.8c-0.2-0.2-0.5-0.5-0.8-0.7
				c4.9-4,5.6-9,5.8-13.1h-4v-1h4v-0.5v-3.2h1v3.2v0.5L1086.2,126.1L1086.2,126.1z M1078.5,129.8c-0.5,2.2-1.2,4.4-2.2,5.8
				c-0.2-0.2-0.6-0.4-0.8-0.6c0.9-1.4,1.6-3.4,2-5.4L1078.5,129.8z M1087.6,129.6c0.6,1.8,1.2,4.2,1.4,5.6l-1,0.2
				c-0.2-1.4-0.8-3.9-1.3-5.7L1087.6,129.6z M1108.4,126.8c0,0,0,0.4,0,0.6c-0.5,8.7-0.9,11.7-1.9,12.7c-0.4,0.5-0.8,0.6-1.6,0.6
				c-0.7,0-2,0-3.3-0.1c0-0.3-0.1-0.7-0.4-1c1.5,0.1,2.8,0.1,3.4,0.1c0.4,0,0.7,0,0.9-0.3c0.8-0.8,1.3-3.8,1.7-11.7h-7.7
				c-0.3,4.3-1.6,9.3-7.7,13.1c-0.2-0.2-0.5-0.6-0.8-0.8c5.9-3.7,7.2-8.3,7.5-12.4h-6.9v-1h6.9c0-0.5,0-0.9,0-1.4v-3.2h1v3.2
				c0,0.5,0,0.9,0,1.4h8.9V126.8z M1119.1,131.9c-1.1,0.4-2.2,0.7-3.3,1.1v6.3c0,0.7-0.2,1-0.6,1.1c-0.5,0.2-1.2,0.2-2.6,0.2
				c0-0.2-0.2-0.6-0.3-0.9c1.1,0,2,0,2.2,0c0.3,0,0.4-0.1,0.4-0.4v-6c-1.2,0.4-2.2,0.7-3.2,1l-0.4-1c1-0.3,2.2-0.6,3.5-1v-4.9h-3.3
				v-0.9h3.3v-4.3h1v4.3h3.2v0.9h-3.2v4.6l3.2-1L1119.1,131.9z M1130.1,124.9h-3.9v14.2c0,0.8-0.2,1.2-0.9,1.4
				c-0.7,0.2-1.9,0.2-3.8,0.2c-0.1-0.3-0.3-0.8-0.4-1.1c1.6,0.1,3.1,0,3.6,0c0.4,0,0.5-0.1,0.5-0.5v-14.2h-6.2v-1h11.2L1130.1,124.9
				L1130.1,124.9z M1135.9,137.6c0.5,0.1,0.9,0.5,1.8,1c1.3,0.7,3,0.8,5.2,0.8c2.5,0,5.8-0.1,7.9-0.4c-0.1,0.3-0.3,0.8-0.3,1.1
				c-1.8,0.1-5.5,0.2-7.6,0.2c-2.3,0-4.1-0.2-5.4-0.9c-0.8-0.5-1.4-1-1.8-1c-0.7,0-1.8,0.9-2.9,2.1l-0.7-0.9c1-0.9,2-1.7,2.9-2v-6.8
				h-2.9v-0.9h3.9L1135.9,137.6L1135.9,137.6z M1135.9,126.8c-0.6-0.9-2-2.3-3.1-3.3l0.7-0.5c1.2,1,2.5,2.3,3.2,3.2L1135.9,126.8z
				 M1150.5,129.8h-13.2v-0.9h6.2v-3.2h-3.6c-0.5,0.9-1.1,1.7-1.6,2.4c-0.2-0.1-0.6-0.4-0.8-0.5c1.2-1.3,2.3-3.3,2.9-5.2l0.9,0.2
				c-0.3,0.7-0.6,1.5-0.9,2.2h3.1v-2.7h1v2.7h5.1v0.9h-5.1v3.2h6V129.8z M1139,137.4v-5.7h9.7v5.7H1139z M1140,136.6h7.8v-3.9h-7.8
				V136.6z"/>
		</g>
		<g>
			<path d="M939.2,148.9h1.3l6.1,10.3l1.7,3h0.1c-0.1-1.5-0.2-3-0.2-4.5v-8.9h1.2v15h-1.3l-6.1-10.3l-1.7-3h-0.1
				c0.1,1.4,0.2,2.8,0.2,4.3v9h-1.2V148.9z M953.6,148.9h8.3v1.1h-7.1v5.5h6v1.1h-6v6.4h7.3v1.1h-8.5V148.9z M964.3,162.1l0.8-0.9
				c1.1,1.2,2.6,2,4.3,2c2.2,0,3.6-1.2,3.6-2.9c0-1.8-1.2-2.4-2.7-3l-2.2-1c-1.3-0.6-3-1.5-3-3.8c0-2.2,1.9-3.8,4.5-3.8
				c1.8,0,3.3,0.8,4.2,1.8l-0.7,0.8c-0.9-0.9-2.1-1.5-3.5-1.5c-1.9,0-3.2,1-3.2,2.6c0,1.7,1.5,2.3,2.6,2.8l2.2,1
				c1.7,0.8,3.2,1.7,3.2,4s-1.9,4.1-4.9,4.1C967.2,164.2,965.5,163.4,964.3,162.1z M980.5,150.1h-4.7v-1.1h10.7v1.1h-4.7v14h-1.3
				V150.1z"/>
		</g>
		<g>
			<path d="M988.8,156.6h7v8.6h-1v-1h-5v1.2h-0.9L988.8,156.6L988.8,156.6z M989.8,157.6v5.7h5v-5.7H989.8z M1002.7,154.2h-10.8
				v-6.5h10.8V154.2z M1001.7,148.8h-8.8v4.6h8.8V148.8z M1005.8,156.6v8.7h-1v-1h-5.5v1.2h-1v-8.8L1005.8,156.6L1005.8,156.6z
				 M1004.8,163.4v-5.7h-5.5v5.7H1004.8z M1010.6,155.1c0,0.6,0,1.1,0,1.7h4v8.6h-0.9v-7.6h-3.1c-0.1,2.6-0.4,5.4-1.4,7.7
				c-0.2-0.1-0.6-0.3-0.9-0.4c1.2-2.9,1.4-6.9,1.4-10v-8h0.9v5.5h2.2v-5.9h0.9v5.9h1.8v0.9h-5L1010.6,155.1L1010.6,155.1z
				 M1027.1,161.1h-4.1v4.4h-0.9v-4.4h-6.6v-0.9h6.6v-3.5h0.9v3.5h4.1V161.1z M1020.8,156.6c-0.7,1.2-1.9,2.3-3.7,3.4
				c-0.2-0.2-0.5-0.5-0.7-0.6c1.5-0.8,2.6-1.8,3.3-2.7h-3V149h3.2c0.3-0.7,0.6-1.5,0.7-2.2l1.1,0.2c-0.2,0.7-0.5,1.4-0.8,2h5.4v7.7
				L1020.8,156.6L1020.8,156.6z M1017.5,152.4h3.5c0-0.2,0-0.5,0-0.7v-1.9h-3.6L1017.5,152.4L1017.5,152.4z M1020.2,155.9
				c0.5-0.9,0.7-1.8,0.8-2.6h-3.5v2.6H1020.2z M1025.2,153.2h-3.2c-0.1,0.8-0.3,1.7-0.7,2.6h3.9L1025.2,153.2L1025.2,153.2z
				 M1025.2,149.9h-3.2v1.9c0,0.2,0,0.4,0,0.7h3.2V149.9z M1030.5,165.1c1.6-0.7,2.5-1.8,2.6-3.4c-0.1,0-0.3,0.1-0.4,0.1
				c-0.7,0-1.3-0.4-1.3-1.3c0-0.8,0.6-1.3,1.3-1.3c1,0,1.5,0.8,1.5,2.1c0,2.2-1.3,3.7-3.3,4.5L1030.5,165.1z M1056.5,151.1
				c-0.7,1.5-1.5,2.9-2.5,4.3v10h-1v-8.8c-0.8,0.9-1.7,1.8-2.7,2.5c-0.1-0.2-0.4-0.6-0.6-0.8c2.5-1.8,4.4-4.4,5.7-7.2h-5.3v-1h5.7
				c0.5-1.1,0.9-2.2,1.2-3.4l1,0.3c-0.3,1.1-0.7,2.1-1.1,3.1h11v1H1056.5z M1067.9,164.1v0.9h-12.5v-0.9h5.7v-6.5h-4.9v-0.9h4.9
				v-4.3h1v4.3h5v0.9h-5v6.5H1067.9z M1087.7,150.6v9.3h-1v-1.3h-6.7v6.9h-1v-6.9h-6.7v1.4h-1v-9.4h7.6v-3.7h1v3.7H1087.7z
				 M1079,157.6v-6.1h-6.7v6.1H1079z M1086.7,157.6v-6.1h-6.7v6.1H1086.7z M1108.6,147.8v17.7h-1v-1.1h-14.8v1.1h-1v-17.7
				L1108.6,147.8z M1107.6,163.6v-14.8h-14.8v14.8H1107.6z M1106.1,160.4v0.9h-11.6v-0.9h5.2v-4.1h-4.2v-0.9h4.2v-3.5h-4.8V151h10.8
				v0.9h-5.1v3.5h4.5v0.9h-4.5v4.1H1106.1z M1102.9,156.9c0.9,0.7,1.9,1.8,2.3,2.4l-0.7,0.5c-0.5-0.7-1.4-1.8-2.3-2.5L1102.9,156.9z
				 M1126.9,149.6c-1.2,1.9-3.1,3.6-5.2,5c2.5,1.5,5.5,2.7,8.5,3.3c-0.2,0.2-0.5,0.6-0.6,0.9c-3-0.7-6.1-2-8.7-3.7
				c-2.9,1.8-6.3,3-9.2,3.8c-0.1-0.3-0.3-0.7-0.5-0.9c2.8-0.6,6-1.8,8.8-3.4c-1.5-1.1-2.8-2.2-3.9-3.5c-1.1,1.1-2.3,2-3.5,2.8
				c-0.1-0.2-0.5-0.5-0.8-0.7c2.6-1.5,5-3.8,6.5-6.4l0.9,0.4c-0.4,0.7-0.9,1.4-1.4,2.1h8.3h0.2L1126.9,149.6z M1114.7,158.4h11.9
				v7.2h-1v-1h-9.9v1.1h-1V158.4z M1115.7,159.2v4.3h9.9v-4.3H1115.7z M1116.7,150.4c1.1,1.3,2.5,2.5,4.1,3.6
				c1.8-1.1,3.3-2.5,4.5-3.9h-8.3L1116.7,150.4z M1142.3,153.9c1.5,4.9,4.3,8.9,8.4,10.6c-0.3,0.2-0.6,0.6-0.7,0.9
				c-4.1-2-7-6.1-8.6-11.3c-0.9,4.3-3,8.8-8.5,11.3c-0.2-0.3-0.5-0.6-0.7-0.8c5.4-2.3,7.5-6.7,8.3-10.8h-8v-1h8.1
				c0.4-2.3,0.4-4.5,0.4-6.1h1c0,1.6,0,3.8-0.4,6.1h8.8v1h-8.1V153.9z"/>
		</g>
		<g>
			<path d="M931.1,185.1c-2,0.8-4,1.6-5.6,2.2l-0.3-1c0.7-0.2,1.6-0.6,2.6-0.9v-7.8h-2.4v-0.9h2.4v-4.9h0.9v4.9h2.2v0.9h-2.2v7.5
				l2.2-0.8L931.1,185.1z M943.1,178.4c-0.7,2.7-1.7,5-3,7c0.6,2.3,1.3,3.7,2.2,3.7c0.5,0,0.7-1,0.8-3.6c0.2,0.2,0.6,0.4,0.8,0.5
				c-0.2,3-0.5,4-1.7,4s-2.1-1.3-2.8-3.6c-1.1,1.5-2.3,2.7-3.8,3.7c-0.1-0.2-0.5-0.5-0.7-0.7c1.7-1.1,3.1-2.5,4.2-4.1
				c-0.5-2.5-0.8-5.7-1-9.4h-5.3v3.1h4.1c0,0,0,0.3,0,0.5c-0.1,4.8-0.1,6.4-0.5,6.9c-0.2,0.3-0.5,0.4-1,0.5c-0.4,0-1.2,0-1.9,0
				c0-0.3-0.1-0.6-0.2-0.9c0.8,0.1,1.6,0.1,1.9,0.1s0.4,0,0.5-0.2c0.2-0.3,0.3-1.8,0.4-5.9h-3.2v1.2c0,2.8-0.4,6.6-2.5,9.3
				c-0.1-0.2-0.5-0.5-0.7-0.6c2.1-2.5,2.3-5.9,2.3-8.6v-6.1h6.2c0-1.1,0-2.2-0.1-3.4h1c0,1.2,0,2.3,0,3.4h4.6v0.9h-4.6
				c0.1,3.3,0.4,6.1,0.8,8.3c1-1.7,1.7-3.7,2.3-5.9L943.1,178.4z M942.4,174.6c-0.6-0.7-1.8-1.6-2.7-2.3l0.7-0.5
				c1,0.6,2.2,1.6,2.7,2.3L942.4,174.6z M955.5,175.6v3.1h6.7v7.4c0,0.7-0.2,1.1-0.7,1.2c-0.6,0.2-1.8,0.2-3.6,0.2
				c0-0.3-0.2-0.7-0.4-1c1.6,0.1,2.9,0.1,3.2,0c0.4,0,0.5-0.1,0.5-0.4v-6.4h-5.7v10.5h-1v-10.5h-5.4v8h-1v-8.9h6.4v-3.1h-8.6v-1h9.1
				c-0.3-0.8-0.9-2.1-1.5-3l0.9-0.3c0.6,0.9,1.3,2.2,1.6,3l-0.7,0.2h8.8v1H955.5z M973,185.9c0.1,0.3,0.2,0.6,0.3,0.8
				c-3.6,2.4-4,2.7-4.3,3.1c-0.1-0.2-0.4-0.6-0.6-0.8c0.3-0.2,1-0.9,1-1.8v-8.1h-3.2v-1h4.1v9.4L973,185.9z M971.1,175.8
				c-0.6-0.9-2-2.2-3-3.2l0.7-0.6c1.1,0.9,2.4,2.2,3.1,3L971.1,175.8z M976.6,174.6c0,1.9-0.7,4-3.6,5.5c-0.1-0.2-0.5-0.6-0.6-0.8
				c2.8-1.3,3.3-3.1,3.3-4.7v-2.3h6.1v4.9c0,0.6,0.1,0.7,0.4,0.7h1.6c0.3,0,0.6,0,0.9-0.1c0,0.2,0.1,0.7,0.1,0.9
				c-0.2,0.1-0.6,0.1-1,0.1h-1.7c-1.1,0-1.3-0.4-1.3-1.7v-4h-4.2V174.6z M983.7,180.9c-0.8,2.5-2.4,4.5-4.2,6
				c1.6,1.1,3.4,1.9,5.5,2.4c-0.2,0.2-0.5,0.6-0.6,0.9c-2.1-0.5-4.1-1.4-5.7-2.7c-1.7,1.2-3.5,2.1-5.5,2.6c-0.1-0.2-0.3-0.6-0.5-0.9
				c1.8-0.5,3.6-1.2,5.2-2.3c-1.7-1.5-2.9-3.3-3.8-5.4h-0.9v-0.9h9.6l0.2-0.1L983.7,180.9z M975.1,181.6c0.8,1.9,2,3.5,3.6,4.8
				c1.6-1.2,2.9-2.8,3.7-4.8H975.1z M1005.3,188.4v1h-18.1v-1h10c1.2-2.7,2.6-7.3,3.3-10.4l1.1,0.2c-0.9,3.2-2.2,7.5-3.4,10.2
				H1005.3z M1004.5,176.4H988v-1h16.5V176.4z M993.1,187.1c-0.4-2.5-1.3-6.2-2.1-9l1-0.2c0.9,2.9,1.8,6.6,2.1,9L993.1,187.1z
				 M996,175.1c-0.2-0.9-0.6-2.3-1-3.3l0.9-0.3c0.4,1.1,0.9,2.4,1.1,3.3L996,175.1z"/>
		</g>
		<g>
			<path d="M1007.1,187.1l0.7-0.8c0.9,0.9,2,1.8,3.9,1.8s3.5-1.6,3.5-4s-1.3-3.9-3.4-3.9c-1.1,0-1.8,0.4-2.7,0.9l-0.8-0.5l0.5-6.9
				h6.9v1.1h-5.8l-0.4,5c0.7-0.4,1.5-0.7,2.5-0.7c2.5,0,4.5,1.5,4.5,4.8s-2.3,5.1-4.7,5.1C1009.4,188.9,1008,187.9,1007.1,187.1z
				 M1018.4,181.1c0-5.2,1.7-7.7,4.4-7.7c2.7,0,4.4,2.5,4.4,7.7c0,5.3-1.7,7.8-4.4,7.8S1018.4,186.4,1018.4,181.1z M1026,181.1
				c0-4.5-1.3-6.7-3.2-6.7c-2,0-3.2,2.2-3.2,6.7c0,4.6,1.3,6.8,3.2,6.8S1026,185.6,1026,181.1z"/>
		</g>
		<g>
			<path d="M1039.3,171.8c-0.1,0.1-0.2,0.3-0.4,0.5c2.2,2.7,5.3,4.6,9.1,6.2c-0.2,0.2-0.5,0.6-0.7,0.8c-3.7-1.7-6.7-3.6-9-6.4
				c-2.4,2.6-5.8,5.1-8.9,6.6c-0.2-0.2-0.5-0.6-0.7-0.8c3.6-1.6,7.5-4.5,9.7-7.4L1039.3,171.8z M1035,184.8
				c-1.3,1.7-3.1,3.5-4.7,4.6c-0.2-0.2-0.6-0.5-0.8-0.6c1.7-1.1,3.5-2.7,4.6-4.3L1035,184.8z M1039,182.9v6c0,0.7-0.2,1-0.7,1.2
				c-0.6,0.2-1.5,0.2-3.2,0.2c-0.1-0.3-0.2-0.7-0.4-0.9c1.4,0,2.6,0,2.9,0c0.4,0,0.5-0.1,0.5-0.4v-6h-8v-0.9h8V179h-5v-0.9h10.8v0.9
				h-4.8v3.1h8v0.9h-8.1V182.9z M1042.4,184.4c1.6,1.3,3.6,3.1,4.6,4.3l-0.8,0.6c-0.9-1.2-2.9-3.1-4.5-4.4L1042.4,184.4z
				 M1065.9,179.6c-1,0.8-2.3,1.8-3.5,2.6c1,2.9,3.2,5.4,5.9,6.5c-0.2,0.2-0.5,0.5-0.7,0.8c-2.7-1.2-4.9-3.7-6.1-6.8
				c-0.4,0.3-0.8,0.5-1.2,0.7c0.8,2.7,0.3,5.4-0.9,6.2c-0.6,0.5-1.1,0.6-1.9,0.6c-0.4,0-1.1,0-1.8-0.1c0-0.3-0.1-0.7-0.3-0.9
				c0.7,0.1,1.5,0.1,1.9,0.1c0.6,0,1,0,1.4-0.4c0.8-0.5,1.2-2.3,0.9-4.4c-2.3,1.9-6,3.8-9.1,4.7c-0.1-0.3-0.4-0.6-0.5-0.9
				c3.3-0.8,7.4-2.8,9.4-4.8c-0.2-0.6-0.4-1.2-0.7-1.9c-2,1.4-5.3,3-7.8,3.8c-0.1-0.2-0.4-0.6-0.5-0.8c2.6-0.7,6.1-2.3,7.9-3.7
				c-0.3-0.5-0.7-1.1-1.2-1.5c-1.9,1.1-4.1,2-6.1,2.6c-0.1-0.2-0.4-0.6-0.6-0.8c2.7-0.7,5.7-1.9,7.7-3.4h-5.3v-0.9h12.1v0.9h-5.5
				c-0.5,0.4-1,0.8-1.5,1.2c1.1,1.1,1.8,2.3,2.3,3.5c1.6-1,3.7-2.5,4.9-3.6L1065.9,179.6z M1051.6,177.4h-1v-4h7.9
				c-0.2-0.6-0.6-1.2-0.9-1.8l1-0.3c0.4,0.6,0.9,1.4,1.1,2h7.8v4h-1v-3h-15L1051.6,177.4L1051.6,177.4z M1080.8,179.9
				c-0.2,0.2-0.4,0.3-0.7,0.5c2.2,1.2,6.2,2.4,9,2.9c-0.2,0.2-0.5,0.6-0.6,0.8c-2.8-0.6-6.8-2-9.1-3.3c-2.4,1.4-5.6,2.7-8.6,3.4
				c-0.1-0.2-0.4-0.5-0.6-0.7c3.5-0.8,7.6-2.3,9.8-4.1L1080.8,179.9z M1072,178.1h-0.9v-3.5h8v-1.4h-6.9v-0.8h14.9v0.8h-7v1.4h8.1
				v3.5h-0.9v-2.7h-7.2v3.2h-1v-3.2h-7L1072,178.1L1072,178.1z M1072.7,178.9h5v0.8h-5V178.9z M1085.6,184.2l0.7,0.4
				c-1.2,1.3-3.4,2.7-5.2,3.6c1,0.4,1.9,0.8,2.5,1.2l-0.5,0.8c-1.7-1-5-2.3-7.7-3.1l0.5-0.7c1.3,0.4,2.8,0.8,4.1,1.4
				c1.4-0.6,3.3-1.7,4.5-2.7h-11.7v-0.8h12.6L1085.6,184.2z M1077.8,176.9v0.7h-4.6v-0.7H1077.8z M1080.2,184.1
				c-0.4-0.5-1.1-1.3-1.8-1.8l0.7-0.5c0.7,0.5,1.5,1.2,1.8,1.8L1080.2,184.1z M1086,176.9v0.7h-4.7v-0.7H1086z M1081.3,178.9h5.3
				v0.8h-5.3V178.9z M1108.2,181.6v0.8h-13.6v0.9h-1v-7.5c-0.7,0.9-1.4,1.7-2.2,2.4c-0.1-0.1-0.5-0.5-0.7-0.7c1.8-1.5,3.4-3.7,4.4-6
				l1,0.3c-0.3,0.7-0.7,1.4-1.1,2.1h5.8c-0.3-0.7-0.7-1.5-1.2-2.1l0.9-0.3c0.5,0.7,1,1.7,1.3,2.4h6v0.8h-6.3v1.7h5.4v0.8h-5.4v1.7
				h5.5v0.8h-5.5v1.9L1108.2,181.6L1108.2,181.6z M1093.6,184.2h13.4v6h-1v-1.1h-11.4v1.1h-1V184.2z M1100.4,174.8h-5.9v1.7h5.9
				V174.8z M1100.4,177.2h-5.9v1.7h5.9V177.2z M1094.6,181.6h5.9v-1.9h-5.9V181.6z M1094.6,185.1v3.2h11.4v-3.2H1094.6z
				 M1112.5,175.4h1v14.8h-1V175.4z M1114,171.6c1.1,1.1,2.3,2.7,2.9,3.6l-0.8,0.6c-0.6-1-1.8-2.6-2.9-3.8L1114,171.6z
				 M1129.1,188.6c0,0.9-0.2,1.2-0.9,1.4c-0.7,0.2-1.9,0.2-3.9,0.2c0-0.3-0.2-0.7-0.4-1c1.7,0,3.2,0,3.6,0s0.6-0.1,0.6-0.6v-15.3
				h-10.3v-0.9h11.3L1129.1,188.6L1129.1,188.6z M1150.3,174.1v0.9h-15.5v4.5c0,3.1-0.3,7.5-2.1,10.6c-0.2-0.2-0.6-0.5-0.8-0.6
				c1.8-2.9,2-7,2-10v-5.4h8.3c-0.3-0.7-0.8-1.6-1.3-2.3l0.9-0.3c0.6,0.8,1.2,1.8,1.5,2.6H1150.3z M1142.7,178.6h6.9v0.9h-6.9v3.3
				h5.9v7h-1V189h-9.6v0.8h-1v-7.1h4.7v-7h1V178.6z M1147.6,183.9h-9.6v4.4h9.6V183.9z"/>
		</g>
		<g>
			<path d="M1102.4,92.3v-2.2c1.9-1.5,3.8-2.3,5.9-2.3s3.8,0.7,5.3,2.1c1.4,1.4,2.2,3.1,2.2,5.1c0,4-3.1,9.6-9.3,16.6h11.8v1.7h-16
				c7.8-7.5,11.7-13.6,11.7-18.3c0-1.6-0.5-2.9-1.6-3.9c-1.1-1.1-2.4-1.6-4-1.6c-1.1,0-2,0.2-2.9,0.7
				C1104.4,90.8,1103.4,91.4,1102.4,92.3z"/>
			<path d="M1128.5,87.8c2.3,0,4.2,1.1,5.7,3.4c1.6,2.3,2.3,5.5,2.3,9.7c0,3.9-0.8,7-2.3,9.3s-3.4,3.5-5.7,3.5
				c-2.4,0-4.4-1.2-5.9-3.4c-1.5-2.3-2.3-5.3-2.3-9.1c0-4.7,0.8-8.1,2.5-10.2C1124.5,88.9,1126.4,87.8,1128.5,87.8z M1128.4,111.9
				c1.9,0,3.4-1.1,4.5-3.2c1.2-2.1,1.7-4.8,1.7-8.1c0-3.2-0.6-5.8-1.7-8c-1.1-2.1-2.6-3.2-4.5-3.2c-1.8,0-3.3,1-4.4,3.1
				c-1.2,2.1-1.7,4.8-1.7,8.1c0,3.3,0.6,6,1.7,8.1C1125.1,110.9,1126.6,111.9,1128.4,111.9z"/>
			<path d="M1139.4,92.3v-2.2c1.9-1.5,3.8-2.3,5.9-2.3s3.8,0.7,5.3,2.1c1.4,1.4,2.2,3.1,2.2,5.1c0,4-3.1,9.6-9.3,16.6h11.8v1.7h-16
				c7.8-7.5,11.7-13.6,11.7-18.3c0-1.6-0.5-2.9-1.6-3.9c-1.1-1.1-2.4-1.6-4-1.6c-1.1,0-2,0.2-2.9,0.7
				C1141.5,90.8,1140.5,91.4,1139.4,92.3z"/>
			<path d="M1165.5,87.8c2.3,0,4.2,1.1,5.7,3.4c1.6,2.3,2.3,5.5,2.3,9.7c0,3.9-0.8,7-2.3,9.3s-3.4,3.5-5.7,3.5
				c-2.4,0-4.4-1.2-5.9-3.4c-1.5-2.3-2.3-5.3-2.3-9.1c0-4.7,0.8-8.1,2.5-10.2C1161.6,88.9,1163.4,87.8,1165.5,87.8z M1165.5,111.9
				c1.9,0,3.4-1.1,4.5-3.2c1.2-2.1,1.7-4.8,1.7-8.1c0-3.2-0.6-5.8-1.7-8c-1.1-2.1-2.6-3.2-4.5-3.2c-1.8,0-3.3,1-4.4,3.1
				c-1.2,2.1-1.7,4.8-1.7,8.1c0,3.3,0.6,6,1.7,8.1C1162.2,110.9,1163.7,111.9,1165.5,111.9z"/>
		</g>
	</g>
				<g>
		<path class="st1" d="M1223.8,143.3c4.6,0,8.3,3.7,8.3,8.3s-3.7,8.3-8.3,8.3c-4.6,0-8.3-3.7-8.3-8.3
			C1215.5,147.1,1219.2,143.3,1223.8,143.3z M1212,149.6h4.2v4.2h-4.2V149.6z M1203.7,149.6h4.2v4.2h-4.2V149.6z M1195.4,149.6h4.2
			v4.2h-4.2V149.6z M1187.1,149.6h4.2v4.2h-4.2V149.6z M1178.8,149.6h4.2v4.2h-4.2V149.6z M1170.4,149.6h4.2v4.2h-4.2V149.6z"/>
					<path class="st2" d="M1223.8,161.4c-4.1,0-7.7-2.6-9.2-6.2h-2.7c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h2.7
			c1.4-3.6,5-6.2,9.2-6.2c5.4,0,9.8,4.4,9.8,9.8C1233.6,157.1,1229.2,161.4,1223.8,161.4z M1217.6,154.2c1,2.4,3.4,4.1,6.3,4.1
			c3.7,0,6.8-3,6.8-6.8c0-3.7-3-6.8-6.8-6.8c-2.8,0-5.2,1.7-6.3,4.1c0.1,0.2,0.1,0.4,0.1,0.6v4.2
			C1217.7,153.9,1217.6,154.1,1217.6,154.2z M1213.5,152.1h0.5c0-0.2,0-0.4,0-0.6c0-0.2,0-0.4,0-0.6h-0.5V152.1z M1207.8,155.2h-4.2
			c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C1209.4,154.6,1208.7,155.2,1207.8,155.2z
			 M1205.2,152.1h1.1V151h-1.1V152.1z M1199.5,155.2h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2
			c0.8,0,1.5,0.7,1.5,1.5v4.2C1201.1,154.6,1200.4,155.2,1199.5,155.2z M1196.9,152.1h1.1V151h-1.1V152.1z M1191.2,155.2h-4.1
			c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.1c0.8,0,1.5,0.7,1.5,1.5v4.2C1192.7,154.6,1192.1,155.2,1191.2,155.2z
			 M1188.6,152.1h1.1V151h-1.1V152.1z M1182.9,155.2h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.1
			c0.8,0,1.5,0.7,1.5,1.5v4.2C1184.4,154.6,1183.8,155.2,1182.9,155.2z M1180.3,152.1h1.1V151h-1.1V152.1z M1174.6,155.2h-4.2
			c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C1176.1,154.6,1175.4,155.2,1174.6,155.2z
			 M1172,152.1h1.1V151h-1.1V152.1z"/>
	</g>
</g>
			<g>
	<path class="st4" d="M409.6,562.3c0,12.6-10.2,22.6-22.6,22.6c-12.6,0-22.6-10-22.6-22.6c0-12.6,10.2-22.6,22.6-22.6
		c7.3,0,13.6,3.5,17.8,8.7 M386.8,546.1v14.6 M388.1,564.1l7.5,7.6"/>
				<circle class="st4" cx="387" cy="562.3" r="1.8"/>
				<path class="st4" d="M401.9,548.8l3.6,0.7l0.2-3.6"/>
				<path class="st4" d="M425,519.2h4.7c5.3,0,9.6,4.4,9.6,9.6v63.7c0,5.5-4.4,9.6-9.6,9.6H344c-5.3,0-9.6-4.4-9.6-9.6v-63.7
		c0-5.3,4.4-9.6,9.6-9.6h6.7 M365,519.2h44.6"/>
				<path class="st4" d="M359.3,507.2h-2.2c-3.1,0-5.6,2.5-5.6,5.6v9.8c0,3.1,2.5,5.6,5.6,5.6h2.2c3.1,0,5.6-2.5,5.6-5.6v-9.8
		C365,509.7,362.4,507.2,359.3,507.2z M418.5,507.2h-2.2c-3.1,0-5.6,2.5-5.6,5.6v9.8c0,3.1,2.5,5.6,5.6,5.6h2.2
		c3.1,0,5.6-2.5,5.6-5.6v-9.8C424.1,509.7,421.6,507.2,418.5,507.2z"/>
</g>
			<g>
	<path class="st4" d="M760.5,286.1v-37.9c0-8.8-7-15.8-15.8-15.8h-75c-8.8,0-15.8,7-15.8,15.8v37.9H760.5L760.5,286.1z"/>
				<path class="st4" d="M654,261.6h50c1.8,0,3.3,1.3,3.3,2.6v19.1 M760.5,261.6h-50c-1.8,0-3.3,1.3-3.3,2.6v19.1"/>
				<path class="st4" d="M654,262.5c0,0-2.2-3.3-7-2.8c-4.8,0.4-5.7,3.7-6.1,5.3s0,28.7,0,28.7s0.2,3.7,6.6,3.7h122.7
		c0,0,4.4-0.2,4.4-4.6V266c0-2.2-1.1-4.6-3.1-5.7c-1.3-0.9-3.1-1.3-5.3-0.9c-3.1,0-5.5,2.2-5.5,4.4"/>
				<path class="st4" d="M764.2,297.3V310c0,1.5-1.1,2.6-2.6,2.6h-3.5c-1.5,0-2.6-1.3-2.6-2.6v-12.7 M658.4,297.3V310
		c0,1.5-1.1,2.6-2.6,2.6h-3.5c-1.5,0-2.6-1.3-2.6-2.6v-12.7"/>
</g>
			<g>
	<path class="st4" d="M1360.5,601.7l7.3-69.6h14.6l2.3,23.2"/>
				<path class="st4" d="M1380.4,601.7v-48.3l30.1,15.6v-15.6l28.1,15.6v-15.6h31.9v48.3 M1408.6,498.6c0,0-11.1-9.7-19.2-2.4
		c-5,4.5-3.3,16.3-3.3,16.3s0-0.2-0.2-0.3c-2.4-5-9.5-3.5-8.7,3.3c0.2,0.9,0.7,1.9,1.4,2.8c-4.9-1.2-6.4,2.9-5,6.2
		c-5.5-0.7-5.2,6.8-2.3,8"/>
				<path class="st4" d="M1378.8,531.2c0,0,2.6-2.1,0.7-6.4c5.5,0.2,7.4-0.9,8-5.9c6.8,1.9,8.8-0.2,9.5-4.3c1.7,3.3,5.5,6.6,9.4,4
		c4.2-2.8,2.3-9,1.7-10.7 M1384.5,601.7v-6.1h13.2v6.1 M1412.3,601.7v-6.1h13.2v6.1 M1440.5,601.7v-6.1h13.2v6.1 M1346.1,601.7h137
		v11.6h-137V601.7z M1442.6,558.2h6.9v4.2h-6.9V558.2z M1442.6,565.8h6.9v4.2h-6.9V565.8z M1459.2,558.2h6.9v4.2h-6.9V558.2z
		 M1459.2,565.8h6.9v4.2h-6.9V565.8z"/>
</g>
			<g class="a9 ani">
	<g>
		<g>
			<path d="M1291.2,410l0.8-0.9c1.1,1.2,2.6,2,4.3,2c2.2,0,3.6-1.2,3.6-2.9c0-1.8-1.2-2.4-2.7-3l-2.2-1c-1.3-0.6-3-1.5-3-3.8
				c0-2.2,1.9-3.8,4.5-3.8c1.8,0,3.3,0.8,4.2,1.8l-0.7,0.8c-0.9-0.9-2.1-1.5-3.5-1.5c-1.9,0-3.2,1-3.2,2.6c0,1.7,1.5,2.3,2.6,2.8
				l2.2,1c1.7,0.8,3.2,1.7,3.2,4s-1.9,4.1-4.9,4.1C1294.1,412.2,1292.4,411.4,1291.2,410z M1303.7,397.5c0-0.6,0.5-1,1-1s1,0.4,1,1
				s-0.5,0.9-1,0.9C1304.1,398.5,1303.7,398,1303.7,397.5z M1304.1,401h1.2v11h-1.2V401z M1309.2,401h1l0.1,1.7l0,0
				c1-1.1,2.2-2,3.5-2c1.8,0,2.6,0.9,3,2.2c1.2-1.3,2.4-2.2,3.7-2.2c2.2,0,3.3,1.4,3.3,4.2v7h-1.2v-6.9c0-2.3-0.8-3.3-2.4-3.3
				c-1,0-2,0.7-3.2,2v8.2h-1.2v-6.9c0-2.3-0.7-3.3-2.4-3.3c-1,0-2,0.7-3.2,2v8.2h-1.2V401H1309.2z M1326.8,406.5
				c0-3.7,2.3-5.8,5-5.8s5,2.1,5,5.8c0,3.6-2.3,5.7-5,5.7C1329.1,412.2,1326.8,410.1,1326.8,406.5z M1335.5,406.5
				c0-2.8-1.6-4.7-3.7-4.7s-3.7,1.9-3.7,4.7s1.6,4.7,3.7,4.7S1335.5,409.4,1335.5,406.5z M1340.1,401h1l0.1,1.7l0,0
				c1.1-1.1,2.2-2,3.8-2c2.3,0,3.3,1.4,3.3,4.2v7h-1.2v-6.9c0-2.3-0.7-3.3-2.4-3.3c-1.3,0-2.2,0.7-3.5,2v8.2h-1.2L1340.1,401
				L1340.1,401z M1357.2,397h1.2v14h6.8v1.1h-8.1L1357.2,397L1357.2,397z M1367.5,397.5c0-0.6,0.5-1,1-1s1,0.4,1,1s-0.5,0.9-1,0.9
				C1367.9,398.5,1367.5,398,1367.5,397.5z M1367.9,401h1.2v11h-1.2V401z"/>
		</g>
		<g>
			<path d="M1377.5,404.8h7v8.6h-1v-1h-5v1.2h-0.9L1377.5,404.8L1377.5,404.8z M1378.4,405.6v5.7h5v-5.7H1378.4z M1391.4,402.2
				h-10.8v-6.5h10.8V402.2z M1390.4,396.8h-8.8v4.6h8.8V396.8z M1394.5,404.8v8.7h-1v-1h-5.5v1.2h-1v-8.8h7.5V404.8z M1393.5,411.5
				v-5.7h-5.5v5.7H1393.5z M1399.2,403.2c0,0.6,0,1.1,0,1.7h4v8.6h-0.9V406h-3.1c-0.1,2.6-0.4,5.4-1.4,7.7c-0.2-0.1-0.6-0.3-0.9-0.4
				c1.2-2.9,1.4-6.9,1.4-10v-8h0.9v5.5h2.2v-5.9h0.9v5.9h1.8v0.9h-5L1399.2,403.2L1399.2,403.2z M1415.8,409.1h-4.1v4.4h-0.9v-4.4
				h-6.6v-0.9h6.6v-3.5h0.9v3.5h4.1V409.1z M1409.4,404.8c-0.7,1.2-1.9,2.3-3.7,3.4c-0.2-0.2-0.5-0.5-0.7-0.6
				c1.5-0.8,2.6-1.8,3.3-2.7h-3v-7.7h3.2c0.3-0.7,0.6-1.5,0.7-2.2l1.1,0.2c-0.2,0.7-0.5,1.4-0.8,2h5.4v7.7L1409.4,404.8
				L1409.4,404.8z M1406.2,400.5h3.5c0-0.2,0-0.5,0-0.7v-1.9h-3.6L1406.2,400.5L1406.2,400.5z M1408.9,403.9
				c0.5-0.9,0.7-1.8,0.8-2.6h-3.5v2.6H1408.9z M1413.9,401.2h-3.2c-0.1,0.8-0.3,1.7-0.7,2.6h3.9L1413.9,401.2L1413.9,401.2z
				 M1413.9,397.9h-3.2v1.9c0,0.2,0,0.4,0,0.7h3.2V397.9z"/>
		</g>
		<g>
			<path d="M1301,423.4c-0.2,0.8-0.5,1.6-0.7,2.3h6.7v12.6h-1V437h-11.2v1.3h-1v-12.5h5.4c0.2-0.7,0.4-1.6,0.6-2.3h-8.6v-0.9h11.5
				c0.7-0.8,1.6-2,2-2.9l1,0.4c-0.6,0.9-1.3,1.8-1.9,2.6h5.5v0.9h-8.3V423.4z M1306.1,426.5h-11.2v2.5h11.2V426.5z M1306.1,430
				h-11.2v2.6h11.2V430z M1306.1,436v-2.6h-11.2v2.6H1306.1z M1296,419.5c0.7,0.7,1.5,1.8,1.9,2.5l-0.9,0.5
				c-0.4-0.7-1.2-1.8-1.9-2.5L1296,419.5z M1328,427.5c-1,0.8-2.3,1.8-3.5,2.6c1,2.9,3.2,5.4,5.9,6.5c-0.2,0.2-0.5,0.5-0.7,0.8
				c-2.7-1.2-4.9-3.7-6.1-6.8c-0.4,0.3-0.8,0.5-1.2,0.7c0.8,2.7,0.3,5.4-0.9,6.2c-0.6,0.5-1.1,0.6-1.9,0.6c-0.4,0-1.1,0-1.8-0.1
				c0-0.3-0.1-0.7-0.3-0.9c0.7,0.1,1.5,0.1,1.9,0.1c0.6,0,1,0,1.4-0.4c0.8-0.5,1.2-2.3,0.9-4.4c-2.3,1.9-6,3.8-9.1,4.7
				c-0.1-0.3-0.4-0.6-0.5-0.9c3.3-0.8,7.4-2.8,9.4-4.8c-0.2-0.6-0.4-1.2-0.7-1.9c-2,1.4-5.3,3-7.8,3.8c-0.1-0.2-0.4-0.6-0.5-0.8
				c2.6-0.7,6.1-2.3,7.9-3.7c-0.3-0.5-0.7-1.1-1.2-1.5c-1.9,1.1-4.1,2-6.1,2.6c-0.1-0.2-0.4-0.6-0.6-0.8c2.7-0.7,5.7-1.9,7.7-3.4
				h-5.3v-0.9h12.1v0.9h-5.5c-0.5,0.4-1,0.8-1.5,1.2c1.1,1.1,1.8,2.3,2.3,3.5c1.6-1,3.7-2.5,4.9-3.6L1328,427.5z M1313.6,425.5h-1
				v-4h7.9c-0.2-0.6-0.6-1.2-0.9-1.8l1-0.3c0.4,0.6,0.9,1.4,1.1,2h7.8v4h-1v-3h-15L1313.6,425.5L1313.6,425.5z M1339.1,430.5
				c0,0.2,0,0.6,0,0.8c-5.2,1.1-5.8,1.3-6.2,1.5c0-0.2-0.2-0.7-0.3-1c0.4-0.1,0.9-0.6,1.5-1.4c0.4-0.5,1.4-1.7,2.4-3.2
				c-2.9,0.4-3.4,0.5-3.6,0.7c-0.1-0.2-0.2-0.7-0.3-1c0.3-0.1,0.7-0.6,1.1-1.3c0.5-0.7,2-3.4,2.8-6l0.9,0.5
				c-0.9,2.3-2.2,4.7-3.5,6.6l3.1-0.4c0.5-0.7,0.9-1.5,1.4-2.3l0.9,0.5c-1.4,2.5-3.1,4.9-4.8,6.9L1339.1,430.5z M1339.4,435
				c-2.4,0.7-4.8,1.3-6.7,1.8l-0.2-1c1.7-0.4,4.2-1,6.8-1.7L1339.4,435z M1350.7,430c-1.1,1.7-2.6,3.2-4.3,4.5
				c0.8,1.8,1.7,2.7,2.9,2.7c0.6,0,0.9-0.5,1-2.4c0.2,0.2,0.5,0.4,0.8,0.5c-0.2,2.2-0.6,2.8-1.9,2.8c-1.5,0-2.7-1.1-3.5-3.1
				c-1.7,1.1-3.6,2.1-5.7,2.8c-0.1-0.2-0.4-0.6-0.6-0.8c2.1-0.7,4.2-1.6,6-2.9c-0.5-1.4-0.8-3.1-1.1-5l-4.1,0.8l-0.2-0.9l4.1-0.8
				c-0.1-1-0.2-2.1-0.3-3.2l-3.3,0.5l-0.2-0.9l3.4-0.5c-0.1-1.5-0.1-3-0.1-4.6h1c0,1.6,0,3,0.1,4.4l5.2-0.8l0.2,0.9l-5.4,0.8
				c0.1,1.1,0.2,2.2,0.3,3.2l5.5-1l0.2,0.9l-5.6,1.1c0.2,1.8,0.6,3.4,1,4.6c1.5-1.2,2.9-2.6,3.8-4L1350.7,430z M1349,422.5
				c-0.7-0.6-2.1-1.4-3.2-1.9l0.6-0.6c1.1,0.4,2.5,1.2,3.2,1.7L1349,422.5z M1362.3,422v4l0.2-0.2c2.6,1.2,5.9,3.2,7.5,4.4l-0.6,0.9
				c-1.6-1.2-4.6-3-7.1-4.3v11.4h-1v-16.1h-8.2v-1h18.2v1h-9V422z M1374.6,423.5h1v14.8h-1V423.5z M1376.1,419.6
				c1.1,1.1,2.3,2.7,2.9,3.6l-0.8,0.6c-0.6-1-1.8-2.6-2.9-3.8L1376.1,419.6z M1391.1,436.6c0,0.9-0.2,1.2-0.9,1.4
				c-0.7,0.2-1.9,0.2-3.9,0.2c0-0.3-0.2-0.7-0.4-1c1.7,0,3.2,0,3.6,0s0.6-0.1,0.6-0.6v-15.3h-10.3v-0.9h11.3L1391.1,436.6
				L1391.1,436.6z M1412.4,422.2v0.9h-15.5v4.5c0,3.1-0.3,7.5-2.1,10.6c-0.2-0.2-0.6-0.5-0.8-0.6c1.8-2.9,2-7,2-10v-5.4h8.3
				c-0.3-0.7-0.8-1.6-1.3-2.3l0.9-0.3c0.6,0.8,1.2,1.8,1.5,2.6L1412.4,422.2L1412.4,422.2z M1404.7,426.6h6.9v0.9h-6.9v3.3h5.9v7h-1
				V437h-9.6v0.8h-1v-7.1h4.7v-7h1V426.6z M1409.6,431.9h-9.6v4.4h9.6V431.9z M1421.5,424c-0.7,1.5-1.5,2.9-2.5,4.3v10h-1v-8.8
				c-0.8,0.9-1.7,1.8-2.7,2.5c-0.1-0.2-0.4-0.6-0.6-0.8c2.5-1.8,4.4-4.4,5.7-7.2h-5.3v-1h5.7c0.5-1.1,0.9-2.2,1.2-3.4l1,0.3
				c-0.3,1.1-0.7,2.1-1.1,3.1h11v1H1421.5z M1432.9,436.9v0.9h-12.5v-0.9h5.7v-6.5h-4.9v-0.9h4.9v-4.3h1v4.3h5v0.9h-5v6.5H1432.9z
				 M1453.7,436.2v1h-18.3v-1h7.9v-16.4h1v6.6h7.9v1h-7.9v8.8H1453.7z M1459.2,428.6c-0.7-0.6-2.2-1.5-3.4-2.1l0.5-0.7
				c1.2,0.5,2.6,1.4,3.4,2L1459.2,428.6z M1456.5,437.4c0.8-1.6,2-4.4,2.8-6.7l0.8,0.6c-0.7,2.2-1.9,4.9-2.7,6.7L1456.5,437.4z
				 M1457.4,419.9c1.3,0.5,2.8,1.4,3.6,2l-0.6,0.8c-0.8-0.7-2.3-1.6-3.6-2.1L1457.4,419.9z M1463.7,423c-0.7,1.4-1.5,2.7-2.3,3.6
				c-0.2-0.1-0.6-0.4-0.9-0.6c1.5-1.6,2.8-4,3.6-6.5l1,0.2c-0.3,0.8-0.6,1.5-0.9,2.3h9.9v0.9h-10.4V423z M1472.8,430.6
				c-0.1,1.5-0.2,2.8-0.3,3.8h1.5v0.9h-1.6c-0.2,1.2-0.4,1.8-0.7,2.2c-0.4,0.4-0.7,0.6-1.3,0.6c-0.6,0-1.6,0-2.6-0.1
				c0-0.3-0.1-0.6-0.3-0.9c1.2,0.1,2.2,0.1,2.6,0.1s0.6,0,0.8-0.3c0.2-0.2,0.4-0.7,0.6-1.6h-9.5c0.2-1.2,0.5-2.9,0.8-4.7h-2v-0.9
				h2.1c0.2-1.5,0.4-3.1,0.5-4.3h9.7c0,0,0,0.4,0,0.6c-0.1,1.4-0.1,2.7-0.2,3.8h1.7v0.9h-1.8V430.6z M1471.5,434.4
				c0.1-0.9,0.2-2.2,0.3-3.8h-8.3c-0.2,1.4-0.4,2.7-0.5,3.8H1471.5z M1464.2,426.2c-0.1,1.1-0.3,2.3-0.5,3.4h8.2
				c0.1-1,0.1-2.1,0.2-3.4H1464.2z M1468.3,434c-0.5-0.8-1.6-2-2.6-2.8l0.7-0.4c1,0.8,2.1,1.9,2.6,2.7L1468.3,434z M1466.9,426.5
				c1,0.7,2.1,1.8,2.6,2.5l-0.7,0.5c-0.5-0.7-1.5-1.8-2.5-2.5L1466.9,426.5z M1494.9,429.2h-4.8v9h-1v-9h-6.4
				c-0.2,3.3-1.3,6.6-5.2,9c-0.2-0.2-0.5-0.6-0.7-0.7c3.7-2.3,4.7-5.3,4.9-8.3h-5v-0.9h5.1c0-0.4,0-0.7,0-1.1V422h-4.3v-0.9h16.8
				v0.9h-4.1v6.4h4.8v0.9H1494.9z M1489.1,428.4V422h-6.3v5.3c0,0.4,0,0.7,0,1.1H1489.1z M1515.3,436.1v1h-17.9v-1h6v-16.3h1v16.3
				h3.9v-16.3h1v16.3H1515.3z M1501,431.8c-0.5-1.7-1.8-4.7-3-6.9l0.9-0.3c1.2,2.2,2.5,5.1,3.1,6.8L1501,431.8z M1514.8,425
				c-1,2.2-2.5,5-3.7,6.9l-0.8-0.4c1.2-1.9,2.7-4.8,3.6-6.9L1514.8,425z"/>
		</g>
		<g>
			<path d="M1291.8,358.4v-2.2c1.9-1.5,3.8-2.3,5.9-2.3s3.8,0.7,5.3,2.1c1.4,1.4,2.2,3.1,2.2,5.1c0,4-3.1,9.6-9.3,16.6h11.8v1.7h-16
				c7.8-7.5,11.7-13.6,11.7-18.3c0-1.6-0.5-2.9-1.6-3.9c-1.1-1.1-2.4-1.6-4-1.6c-1.1,0-2,0.2-2.9,0.7
				C1293.9,356.6,1292.9,357.4,1291.8,358.4z"/>
			<path d="M1317.9,353.9c2.3,0,4.2,1.1,5.7,3.4c1.6,2.3,2.3,5.5,2.3,9.7c0,3.9-0.8,7-2.3,9.3s-3.4,3.5-5.7,3.5
				c-2.4,0-4.4-1.2-5.9-3.4c-1.5-2.3-2.3-5.3-2.3-9.1c0-4.7,0.8-8.1,2.5-10.2C1314,354.9,1315.8,353.9,1317.9,353.9z M1317.9,378
				c1.9,0,3.4-1.1,4.5-3.2c1.2-2.1,1.7-4.8,1.7-8.1c0-3.2-0.6-5.8-1.7-8c-1.1-2.1-2.6-3.2-4.5-3.2c-1.8,0-3.3,1-4.4,3.1
				c-1.2,2.1-1.7,4.8-1.7,8.1c0,3.3,0.6,6,1.7,8.1C1314.6,377,1316.1,378,1317.9,378z"/>
			<path d="M1337.4,354.1v25.3h-1.9v-25.3H1337.4z"/>
			<path d="M1351.6,366.2c-2.2-1.5-3.3-3.4-3.3-5.7c0-1.8,0.7-3.4,2-4.7c1.3-1.3,2.9-2,4.7-2c1.9,0,3.4,0.7,4.8,2
				c1.3,1.3,2,2.9,2,4.7c0,2.4-1.1,4.3-3.2,5.7c2.5,1.5,3.7,3.6,3.7,6.3c0,2-0.7,3.7-2.1,5.1s-3.1,2.1-5.1,2.1s-3.7-0.7-5.2-2.1
				c-1.4-1.4-2.1-3-2.1-5C1347.8,370,1349.1,367.8,1351.6,366.2z M1360.4,372.5c0-1.4-0.5-2.7-1.6-3.7c-1-1-2.3-1.5-3.8-1.5
				s-2.7,0.5-3.7,1.6s-1.5,2.3-1.5,3.8s0.5,2.8,1.6,3.8c1,1,2.3,1.6,3.8,1.6s2.8-0.5,3.8-1.6C1359.9,375.4,1360.4,374,1360.4,372.5z
				 M1350.2,360.5c0,1.4,0.5,2.5,1.4,3.5s2.1,1.4,3.4,1.4c1.4,0,2.5-0.5,3.4-1.4c0.9-1,1.4-2.1,1.4-3.6c0-1.3-0.5-2.5-1.4-3.4
				c-1-0.9-2.1-1.4-3.4-1.4s-2.4,0.5-3.4,1.4C1350.7,358,1350.2,359.1,1350.2,360.5z"/>
		</g>
	</g>
				<g>
		<path class="st1" d="M1222.1,379.9c-4.6,0-8.3,3.7-8.3,8.3s3.7,8.3,8.3,8.3c4.6,0,8.3-3.7,8.3-8.3S1226.7,379.9,1222.1,379.9z
			 M1233.9,386.2h-4.2v4.2h4.2V386.2z M1242.2,386.2h-4.2v4.2h4.2V386.2z M1250.5,386.2h-4.2v4.2h4.2V386.2z M1258.8,386.2h-4.2v4.2
			h4.2V386.2z M1267.1,386.2h-4.2v4.2h4.2V386.2z M1275.4,386.2h-4.2v4.2h4.2V386.2z"/>
					<path class="st2" d="M1222.1,398.1c-5.4,0-9.8-4.4-9.8-9.8s4.4-9.8,9.8-9.8c4.1,0,7.7,2.6,9.2,6.2h2.7c0.8,0,1.5,0.7,1.5,1.5v4.2
			c0,0.8-0.7,1.5-1.5,1.5h-2.7C1229.8,395.5,1226.2,398.1,1222.1,398.1z M1222.1,381.5c-3.7,0-6.8,3-6.8,6.8c0,3.8,3,6.8,6.8,6.8
			c2.8,0,5.2-1.7,6.3-4.1c-0.1-0.2-0.1-0.4-0.1-0.6v-4.2c0-0.2,0-0.4,0.1-0.6C1227.3,383.2,1224.9,381.5,1222.1,381.5z
			 M1231.9,388.8h0.5v-1.1h-0.5c0,0.2,0,0.4,0,0.6C1231.9,388.4,1231.9,388.6,1231.9,388.8z M1275.4,391.9h-4.2
			c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C1277,391.2,1276.3,391.9,1275.4,391.9z
			 M1272.8,388.8h1.1v-1.1h-1.1V388.8z M1267.1,391.9h-4.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2
			c0.8,0,1.5,0.7,1.5,1.5v4.2C1268.6,391.2,1268,391.9,1267.1,391.9z M1264.5,388.8h1.1v-1.1h-1.1V388.8z M1258.8,391.9h-4.2
			c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.2c0.8,0,1.5,0.7,1.5,1.5v4.2C1260.3,391.2,1259.7,391.9,1258.8,391.9z
			 M1256.2,388.8h1.1v-1.1h-1.1V388.8z M1250.5,391.9h-4.1c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.1
			c0.8,0,1.5,0.7,1.5,1.5v4.2C1252,391.2,1251.3,391.9,1250.5,391.9z M1247.9,388.8h1.1v-1.1h-1.1V388.8z M1242.2,391.9h-4.1
			c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h4.1c0.8,0,1.5,0.7,1.5,1.5v4.2C1243.7,391.2,1243,391.9,1242.2,391.9z
			 M1239.6,388.8h1.1v-1.1h-1.1V388.8z"/>
	</g>
</g>
</svg>


		<svg version="1.1" id="svg-mob" class="mobile" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
				 viewBox="0 0 343 919.8" style="enable-background:new 0 0 343 919.8;" xml:space="preserve">
			<g>
	<path class="st0" d="M206,50v28c0,21.6-17.7,39.3-39.3,39.3H82.5 M203.4,269.3h-134c-21.6,0-39.3-17.7-39.3-39.3v-73.4
		c0-21.6,17.7-39.3,39.3-39.3h19.7 M153.6,421.3h81.9c21.6,0,39.3-17.7,39.3-39.3v-73.4c0-21.6-17.7-39.3-39.3-39.3h-34.4
		 M241.2,733.4h49.2c21.6,0,39.3-17.7,39.3-39.3v-73.4c0-21.6-17.7-39.3-39.3-39.3h-19.7 M274.8,886.4h-49.2
		c-21.6,0-39.3-17.7-39.3-39.3v-74.4c0-21.6,17.7-39.3,39.3-39.3h19.7 M271.2,581.3H136.1c-21.6,0-39.3-17.7-39.3-39.3v-81.4
		c0-21.6,17.7-39.3,39.3-39.3h19.7"/>
</g>
			<path class="st1 orange-long-mobile" d="M206,50v28c0,21.6-17.7,39.3-39.3,39.3H82.5h6.6H69.4c-21.6,0-39.3,17.7-39.3,39.3V230
	c0,21.6,17.7,39.3,39.3,39.3h134h-2.3h34.4c21.6,0,39.3,17.7,39.3,39.3V382c0,21.6-17.7,39.3-39.3,39.3h-81.9h2.2h-19.7
	c-21.6,0-39.3,17.7-39.3,39.3V542c0,21.6,17.7,39.3,39.3,39.3h135.1l-0.5,0.1h19.7c21.6,0,39.3,17.7,39.3,39.3v73.4
	c0,21.6-17.7,39.3-39.3,39.3h-49.2h4.1h-19.7c-21.6,0-39.3,17.7-39.3,39.3v74.4c0,21.6,17.7,39.3,39.3,39.3h49.2"/>
			<circle class="st2" cx="282.2" cy="886.4" r="7.3"/>
			<circle class="st2" cx="206" cy="42.9" r="7.3"/>
			<circle class="st2" cx="82.5" cy="313.9" r="3.6"/>
			<g>
	<path class="st3" d="M82.4,681.4v-22.1c0-5.1-4.1-9.2-9.2-9.2H29.6c-5.1,0-9.2,4.1-9.2,9.2v22.1H82.4L82.4,681.4z"/>
				<path class="st3" d="M20.4,667.2h29.1c1,0,1.9,0.6,1.9,1.5v11.1"/>
				<path class="st3" d="M82.4,667.2H53.3c-1,0-1.9,0.6-1.9,1.5v11.1"/>
				<path class="st3" d="M20.4,667.6c0,0-1.3-1.9-4.1-1.7c-2.8,0.3-3.3,2.2-3.6,3.1c-0.3,0.9,0,16.7,0,16.7s0.1,2.2,3.8,2.2H88
		c0,0,2.6-0.1,2.6-2.7v-15.4c0-1.3-0.6-2.7-1.8-3.3c-0.8-0.5-1.8-0.8-3.1-0.5c-1.8,0-3.2,1.3-3.2,2.6 M84.7,687.9v7.4
		c0,0.9-0.6,1.5-1.5,1.5h-2c-0.9,0-1.5-0.6-1.5-1.5v-7.4 M23,687.9v7.4c0,0.9-0.6,1.5-1.5,1.5h-2c-0.9,0-1.5-0.6-1.5-1.5v-7.4"/>
</g>
			<g>
	<path class="st3" d="M84,199.1c0,6.9-5.6,12.4-12.4,12.4c-6.9,0-12.4-5.5-12.4-12.4s5.5-12.4,12.4-12.4c4,0,7.5,1.9,9.8,4.8
		 M71.5,190.1v8.1 M72.2,200.1l4,4.1"/>
				<circle class="st3" cx="71.6" cy="199.1" r="1"/>
				<path class="st3" d="M79.8,191.7l1.9,0.4l0.2-2"/>
				<path class="st3" d="M92.4,175.3H95c2.9,0,5.3,2.4,5.3,5.3v35c0,3-2.4,5.3-5.3,5.3H47.9c-2.9,0-5.3-2.4-5.3-5.3v-35
		c0-2.9,2.4-5.3,5.3-5.3h3.7 M59.5,175.3H84"/>
				<path class="st3" d="M56.3,168.8h-1.2c-1.7,0-3.1,1.4-3.1,3.1v5.4c0,1.7,1.4,3.1,3.1,3.1h1.2c1.7,0,3.1-1.4,3.1-3.1v-5.4
		C59.5,170.2,58.1,168.8,56.3,168.8z M88.8,168.8h-1.2c-1.7,0-3.1,1.4-3.1,3.1v5.4c0,1.7,1.4,3.1,3.1,3.1h1.2c1.7,0,3.1-1.4,3.1-3.1
		v-5.4C92,170.2,90.6,168.8,88.8,168.8z"/>
</g>
			<g>
	<path class="st3" d="M192.5,406.2l2.7-25.6h5.4l0.8,8.5"/>
				<path class="st3" d="M199.9,406.2v-17.8l11,5.8v-5.8l10.4,5.8v-5.8H233v17.8 M210.2,368.2c0,0-4.1-3.6-7.1-0.9
		c-1.8,1.6-1.2,6-1.2,6s0-0.1-0.1-0.1c-0.9-1.8-3.5-1.3-3.2,1.2c0.1,0.3,0.3,0.7,0.5,1c-1.8-0.4-2.4,1.1-1.8,2.3
		c-2-0.3-1.9,2.5-0.8,2.9 M199.3,380.2c0,0,1-0.8,0.3-2.4c2,0.1,2.7-0.3,2.9-2.2c2.5,0.7,3.2-0.1,3.5-1.6c0.6,1.2,2,2.4,3.4,1.5
		c1.5-1,0.8-3.3,0.6-3.9"/>
				<path class="st3" d="M201.4,406.2v-2.3h4.8v2.3 M211.6,406.2v-2.3h4.8v2.3 M222,406.2v-2.3h4.8v2.3 M187.3,406.2h50.4v4.3h-50.4
		V406.2z M222.8,390.1h2.5v1.5h-2.5V390.1z M222.8,393h2.5v1.5h-2.5V393z M228.9,390.1h2.5v1.5h-2.5V390.1z M228.9,393h2.5v1.5h-2.5
		V393z"/>
</g>
			<g class="a1-mobile ani">
	<g>
		<circle class="st4" cx="160.8" cy="116.7" r="7.5"/>
		<circle class="st4" cx="160.8" cy="116.7" r="6.1"/>
		<circle class="st5" cx="160.8" cy="116.7" r="4.4"/>
	</g>
				<circle class="st2" cx="160.8" cy="71.7" r="3.6"/>
				<path class="st6" d="M160.8,111.7V74.6"/>
				<text transform="matrix(1 0 0 1 127.1154 38.8999)" class="st7 st8">1987</text>
				<text transform="matrix(1 0 0 1 104.0745 49.2068)"><tspan x="0" y="0" class="st9 st10 st11">CEO来到上海学习</tspan><tspan x="9.2" y="12" class="st9 st10 st11">中文和中国文化</tspan></text>
</g>
			<g class="a2-mobile ani">
	<g>
		<circle class="st4" cx="82.5" cy="116.7" r="7.5"/>
		<circle class="st4" cx="82.5" cy="116.7" r="6.1"/>
		<circle class="st5" cx="82.5" cy="116.7" r="4.4"/>
	</g>
				<circle class="st2" cx="82.5" cy="71.7" r="3.6"/>
				<path class="st6" d="M82.5,111.7V74.6"/>
				<text transform="matrix(1 0 0 1 53.9825 62.9465)" class="st7 st8">1993</text>
				<text transform="matrix(1 0 0 1 44.9621 73.2535)"><tspan x="0" y="0" class="st9 st10 st11">CEO在中国开始</tspan><tspan x="4.6" y="12" class="st9 st10 st11">他的商旅生涯</tspan></text>
</g>
			<g class="a8-mobile ani">
	<g>
		<circle class="st4" cx="143.4" cy="421.9" r="7.5"/>
		<circle class="st4" cx="143.4" cy="421.9" r="6.1"/>
		<circle class="st5" cx="143.4" cy="421.9" r="4.4"/>
	</g>
				<circle class="st2" cx="143.3" cy="391.3" r="3.6"/>
				<path class="st6" d="M143.3,394.3v22.4"/>
				<text transform="matrix(1 0 0 1 92.3839 383.9933)" class="st7 st8">2016</text>
				<text transform="matrix(1 0 0 1 85.8279 394.3002)"><tspan x="0" y="0" class="st9 st10 st11">Simon Li品牌</tspan><tspan x="-36.7" y="12" class="st9 st10 st11">在中国开启线上零售业务</tspan></text>
</g>
			<g class="a9-mobile ani">
	<g>
		<circle class="st4" cx="96.7" cy="491.1" r="7.5"/>
		<circle class="st4" cx="96.7" cy="491.1" r="6.1"/>
		<circle class="st5" cx="96.7" cy="491.1" r="4.4"/>
	</g>
				<circle class="st2" cx="65.9" cy="491.1" r="3.6"/>
				<path class="st6" d="M91.3,491.1H69.5"/>
				<text transform="matrix(1 0 0 1 51.5401 457.5466)" class="st7 st8">2018</text>
				<text transform="matrix(1 0 0 1 6.1345 467.8536)"><tspan x="0" y="0" class="st9 st10 st11">Simon Li品牌首家线下门店</tspan><tspan x="33.7" y="12" class="st9 st10 st11">在中国上海开业</tspan></text>
</g>
			<g class="a11-mobile ani">
	<text transform="matrix(1 0 0 1 238.3398 607.7468)" class="st7 st8">2020</text>
				<g>
		<g>
			<circle class="st4" cx="330" cy="615.5" r="7.5"/>
			<circle class="st4" cx="330" cy="615.5" r="6.1"/>
			<circle class="st5" cx="330" cy="615.5" r="4.4"/>
		</g>
					<circle class="st2" cx="285.6" cy="615.5" r="3.6"/>
					<path class="st6" d="M325.6,615.5h-37.1"/>
					<text transform="matrix(1 0 0 1 229.7751 618.0537)"><tspan x="0" y="0" class="st9 st10 st11">打造NEST品牌</tspan><tspan x="-5.3" y="12" class="st9 st10 st11">在中国各大城市</tspan><tspan x="-20" y="24" class="st9 st10 st11">设立几十家零售门店</tspan></text>
	</g>
</g>
			<g class="a10-mobile ani">
	<g>
		<circle class="st4" cx="97.1" cy="533.3" r="7.5"/>
		<circle class="st4" cx="97.1" cy="533.3" r="6.1"/>
		<circle class="st5" cx="97.1" cy="533.3" r="4.4"/>
	</g>
				<circle class="st2" cx="66.9" cy="581.3" r="3.6"/>
				<path class="st6" d="M89.7,533.3H79.5v47.9h-6.9"/>
				<text transform="matrix(1 0 0 1 62.3001 610.0465)" class="st7 st8">2019</text>
				<text transform="matrix(1 0 0 1 62.3002 620.3535)"><tspan x="0" y="0" class="st9 st10 st11">麦熊新工厂投产</tspan><tspan x="0" y="12" class="st9 st10 st11">嘉兴展厅及研发中心成立</tspan></text>
</g>
			<g class="a13-mobile ani">
	<g>
		<circle class="st4" cx="186.3" cy="794.5" r="7.5"/>
		<circle class="st4" cx="186.3" cy="794.5" r="6.1"/>
		<circle class="st5" cx="186.3" cy="794.5" r="4.4"/>
	</g>
				<circle class="st2" cx="234.5" cy="794.4" r="3.6"/>
				<path class="st6" d="M190.4,794.5h38.9"/>
				<text transform="matrix(1 0 0 1 245.7191 787.6464)" class="st7 st8">2024</text>
				<text transform="matrix(1 0 0 1 245.7193 797.9533)"><tspan x="0" y="0" class="st9 st10 st11">特雷通全球智造研发总部</tspan><tspan x="0" y="12" class="st9 st10 st11">一期项目于5月正式投产</tspan></text>
</g>
			<g class="a12-mobile ani">
	<g class="">
		<circle class="st4" cx="330" cy="697" r="7.5"/>
		<circle class="st4" cx="330" cy="697" r="6.1"/>
		<circle class="st5" cx="330" cy="697" r="4.4"/>
	</g>
				<circle class="st2" cx="285.6" cy="697" r="3.6"/>
				<path class="st6" d="M325.6,697h-37.1"/>
				<text transform="matrix(1 0 0 1 235.9897 687.7645)" class="st7 st8">2022</text>
				<text transform="matrix(1 0 0 1 195.1246 698.0715)"><tspan x="0" y="0" class="st9 st10 st11">特雷通全球智造研发总部</tspan><tspan x="-23.2" y="12" class="st9 st10 st11">于10月在浙江省嘉兴高新区奠基</tspan></text>
</g>

			<g class="a3-mobile ani">
	<g>
		<circle class="st4" cx="82.5" cy="269.5" r="7.5"/>
		<circle class="st4" cx="82.5" cy="269.5" r="6.1"/>
		<circle class="st5" cx="82.5" cy="269.5" r="4.4"/>
	</g>
				<path class="st6" d="M82.5,273.9V311"/>
				<text transform="matrix(1 0 0 1 90.9001 305.8465)" class="st7 st8">1995</text>
				<text transform="matrix(1 0 0 1 90.8998 316.1534)"><tspan x="0" y="0" class="st9 st10 st11">特雷通集团成立</tspan><tspan x="0" y="12" class="st9 st10 st11">在中国创造北欧风情</tspan><tspan x="0" y="24" class="st9 st10 st11">BoConcept品牌</tspan></text>
</g>
			<g class="a4-mobile ani">
	<g>
		<circle class="st4" cx="132.4" cy="269.5" r="7.5"/>
		<circle class="st4" cx="132.4" cy="269.5" r="6.1"/>
		<circle class="st5" cx="132.4" cy="269.5" r="4.4"/>
	</g>
				<circle class="st2" cx="228.4" cy="218" r="3.6"/>
				<path class="st6" d="M132.4,265.1v-21.8h96v-21.8"/>
				<text transform="matrix(1 0 0 1 236.3669 209.2465)" class="st7 st8">1997</text>
				<text transform="matrix(1 0 0 1 236.3666 219.5534)"><tspan x="0" y="0" class="st9 st10 st11">建立小型沙发制造车间</tspan><tspan x="0" y="12" class="st9 st10 st11">为北欧风情制造沙发</tspan></text>
</g>
			<g class="a5-mobile ani">
	<g>
		<circle class="st4" cx="188.9" cy="269.5" r="7.5"/>
		<circle class="st4" cx="188.9" cy="269.5" r="6.1"/>
		<circle class="st5" cx="188.9" cy="269.5" r="4.4"/>
	</g>
				<circle class="st2" cx="188.9" cy="313.9" r="3.6"/>
				<path class="st6" d="M188.9,273.9V311"/>
				<text transform="matrix(1 0 0 1 184.5002 337.5966)" class="st7 st8">1999</text>
				<text transform="matrix(1 0 0 1 184.4999 347.9035)"><tspan x="0" y="0" class="st9 st10 st11">特雷通上海投产</tspan><tspan x="0" y="12" class="st9 st10 st11">拥有自己的制造工厂</tspan></text>
</g>
			<g class="a6-mobile ani">
	<g>
		<circle class="st4" cx="234.5" cy="421.9" r="7.5"/>
		<circle class="st4" cx="234.5" cy="421.9" r="6.1"/>
		<circle class="st5" cx="234.5" cy="421.9" r="4.4"/>
	</g>
				<circle class="st2" cx="234.5" cy="466.3" r="3.6"/>
				<path class="st6" d="M234.5,426.3v37"/>
				<text transform="matrix(1 0 0 1 245.7193 458.1465)" class="st7 st8">2005</text>
				<text transform="matrix(1 0 0 1 245.719 468.4534)"><tspan x="0" y="0" class="st9 st10 st11">特雷通嘉善投产</tspan><tspan x="0" y="12" class="st9 st10 st11">自有品牌Simon Li </tspan><tspan x="0" y="24" class="st9 st10 st11">首次在美国高点参展</tspan></text>
</g>
			<g class="a7-mobile ani">
	<g>
		<circle class="st4" cx="181.3" cy="421.9" r="7.5"/>
		<circle class="st4" cx="181.3" cy="421.9" r="6.1"/>
		<circle class="st5" cx="181.3" cy="421.9" r="4.4"/>
	</g>
				<circle class="st2" cx="181.3" cy="466.3" r="3.6"/>
				<path class="st6" d="M181.3,426.3v37"/>
				<text transform="matrix(1 0 0 1 141.6002 487.1271)" class="st7 st8">2014</text>
				<text transform="matrix(1 0 0 1 141.5999 497.434)"><tspan x="0" y="0" class="st9 st10 st11">嘉兴麦熊工厂投产</tspan><tspan x="0" y="12" class="st9 st10 st11">开启功能沙发研发制造</tspan></text>
</g>
</svg>


	</div>
</template>

<script>
export default {
  name: 'History',
  methods: {
    test() {

			console.log(document.querySelector('.mobile-svg').getTotalLength())
      // console.log(this.$refs['line-1'].getTotalLength())
    }
  },
  mounted() {
		// setTimeout(()=> {
		// 	this.test()
		// },100)

  }
}
</script>

<style lang="scss" scoped>
@use 'styles/varibles' as *;
@use 'styles/common' as *;

.history {
  margin: 13rem auto 0;
  width: 90%;
}

.title {
  margin: 0 0 0 0;
  opacity: 0;
}

.title-cn {
  margin: 1rem 0 5rem 0;
  letter-spacing: 1rem;
  opacity: 0;
}

.mobile-svg {
  display: none;
}

.orange-long {
  //stroke-dasharray: 0, 1767.353271484375;
  stroke-dasharray: 0, 1767.353271484375;
  stroke-dashoffset: 0;
}
.blue-long {
  //stroke-dasharray: 0, 1767.353271484375;
  stroke-dasharray: 0, 3560.72412109375;
  stroke-dashoffset: 0;
}
.orange-long-mobile {
  stroke-dasharray: 0, 1767.16162109375;
  stroke-dashoffset: 0;
}

.line-1,
.line-2,
.line-3,
.line-5,
.line-6,
.line-7,
.line-8,
.line-9,
.line-11,
.line-12,
.line-13,
.line-14,
{
  //stroke-dasharray: 0, 37;
  stroke-dasharray: 0, 152.9429473876953;
}

.line-4 {
  stroke-dasharray: 0, 139.60000610351562;
}

.line-10 {
  stroke-dasharray: 0, 85.70004272460938;
}

.line-1-mobile,
.line-2-mobile,
.line-3-mobile,
{
  stroke-dasharray: 0, 37.099998474121094;
}

.line-4-mobile,
{
  stroke-dasharray: 0, 139.60000610351562;
}

.line-5-mobile,
{
  stroke-dasharray: 0, 37.100006103515625;
}

.line-6-mobile {
  stroke-dasharray: 0, 37;
}

.line-7-mobile {
  stroke-dasharray: 0, 37.100006103515625;
}

.line-8-mobile {
  stroke-dasharray: 0, 22.399993896484375;
}

.line-9-mobile {
  stroke-dasharray: 0, 21.800003051757812;
}

.line-10-mobile {
  stroke-dasharray: 0, 65.0000228881836;
}

.line-11-mobile,
.line-12-mobile,
.line-13-mobile,
{
  stroke-dasharray: 0, 37.100006103515625;
}

.line-14-mobile,
{
  stroke-dasharray: 0, 38.899993896484375;
}

.orange-1,
.orange-1-mobile,
.circle-1,
.circle-1-mobile,
.t1987,
.t1987-mobile,
.orange-2,
.orange-2-mobile,
.circle-2,
.circle-2-mobile,
.t1993,
.t1993-mobile,
.clock,
.clock-mobile,
.orange-3,
.orange-3-mobile,
.circle-3,
.circle-3-mobile,
.t1994,
.t1994-mobile,
.orange-4,
.orange-4-mobile,
.circle-4,
.circle-4-mobile,
.t1995,
.t1995-mobile,
.orange-5,
.orange-5-mobile,
.circle-5,
.circle-5-mobile,
.t1997,
.t1997-mobile,
.sofa,
.sofa-mobile,
.orange-6,
.orange-6-mobile,
.circle-6,
.circle-6-mobile,
.t1999,
.t1999-mobile,
.orange-7,
.orange-7-mobile,
.circle-7,
.circle-7-mobile,
.t2002,
.t2002-mobile,
.orange-8,
.orange-8-mobile,
.circle-8,
.circle-8-mobile,
.t2006,
.t2006-mobile,
.orange-9,
.orange-9-mobile,
.circle-9,
.circle-9-mobile,
.t2012,
.t2012-mobile,
.factory,
.factory-mobile,
.orange-10,
.orange-10-mobile,
.circle-10,
.circle-10-mobile,
.t2014,
.t2014-mobile,
.orange-11,
.orange-11-mobile,
.circle-11,
.circle-11-mobile,
.t2016,
.t2016-mobile,
.orange-12,
.orange-12-mobile,
.circle-12,
.circle-12-mobile,
.t2018,
.t2018-mobile,
.orange-13,
.orange-13-mobile,
.circle-13,
.circle-13-mobile,
.t2019-1,
.t2019-1-mobile,
.orange-14,
.orange-14-mobile,
.circle-14,
.circle-14-mobile,
.t2019-2,
.t2019-2-mobile,
{
  opacity: 0;
}

.animate .title {
  animation: fadeInUp .5s linear forwards;
}

.animate .title-cn {
  animation: fadeInUp .5s .3s linear forwards;
}

.animate .orange-long, .animate .orange-long-mobile {
  animation: orange-long 10s .5s linear forwards;
}
.animate .blue-long, .animate .blue-long-mobile {
  animation: blue-long 10s .5s linear forwards;
}
.animate .orange-1,
.animate .orange-1-mobile,
{
  animation: opacityIn .2s 1s linear forwards;
}

.animate .line-1,
.animate .line-1-mobile {
  animation: line-1 .2s 1.2s linear forwards;
}

.animate .circle-1,
.animate .circle-1-mobile,
{
  animation: opacityIn .2s 1.4s linear forwards;
}

.animate .t1987,
.animate .t1987-mobile,
{
  animation: opacityIn .2s 1.6s linear forwards;
}
.animate .ani {
  opacity: 0;
  animation: opacityIn linear forwards;
  animation-duration: .2s;
}
.animate .b1 {
  animation-delay: 1.5s;
}

.animate .a1
{
  animation-delay: 1.6s;
}
.animate .b1-mobile, .animate .a1-mobile {
	animation-delay: .8s;
}
.animate .b2
{
  animation-delay: 1.7s;
}
.animate .b2-mobile,.animate .a2-mobile
{
	animation-delay: 1.2s;
}
.animate .a2,
{
  animation-delay: 1.8s;
}
.animate .b3,
{
  animation-delay: 1.9s;
}
.animate .b3-mobile,
.animate .a3-mobile,
{
	animation-delay: 2.4s;
}
.animate .a3,
{
  animation-delay: 2s;
}
.animate .b4,
.animate .b4-mobile,
{
  animation-delay: 3s;
}
.animate .a4,
.animate .a4-mobile,
{
  animation-delay: 3.1s;
}
.animate .b5,
.animate .b5-mobile,
{
  animation-delay: 3.4s;
}
.animate .a5,
.animate .a5-mobile,
{
  animation-delay: 3.5s;
}
.animate .b6,
{
  animation-delay: 3.6s;
}
.animate .a6-mobile,
.animate .b6-mobile {
	animation-delay: 4.6s;
}
.animate .a6,
{
  animation-delay: 3.7s;
}
.animate .b7,
.animate .b7-mobile,
{
  animation-delay: 5.3s;
}
.animate .a7,
.animate .a7-mobile,
{
  animation-delay: 5.4s;
}
.animate .b8,
.animate .b8-mobile,
{
  animation-delay: 5.5s;
}
.animate .a8,
.animate .a8-mobile,
{
  animation-delay: 5.6s;
}
.animate .b9,
.animate .b9-mobile,
{
  animation-delay: 7.3s;
}
.animate .a9
{
  animation-delay: 7.4s;
}
.animate .b9,

{
  animation-delay: 7.3s;
}
.animate .a9-mobile,
.animate .b9-mobile,
{
  animation-delay: 6.2s;
}
.animate .b10
{
  animation-delay: 7.5s;
}
.animate .b10-mobile,
.animate .a10-mobile {
	animation-delay: 6.5s;
}
.animate .a10
{
  animation-delay: 7.6s;
}
.animate .b11,

{
  animation-delay: 7.8s;
}
.animate .a11,
{
  animation-delay: 7.9s;
}
.animate .a11-mobile,
.animate .b11-mobile,
{
	animation-delay: 7s;
}
.animate .b12,

{
  animation-delay: 9s;
}
.animate .a12,
{
  animation-delay: 9.1s;
}
.animate .a12-mobile,
.animate .b12-mobile {
	animation-delay: 7.5s;
}
.animate .b13,
{
  animation-delay: 9.2s;
}
.animate .a13-mobile,
.animate .b13-mobile {
	animation-delay: 8.5s;
}
.animate .a13
{
  animation-delay: 9.3s;
}
.animate .b14,
{
  animation-delay: 9.8s;
}
.animate .a14-mobile,
.animate .b14-mobile {
	animation-delay: 9s;
}
.animate .a15-mobile,
.animate .b15-moble {
	animation-delay: 9.5s;
}
.animate .a14,
{
  animation-delay: 9.9s;
}
.animate .orange-2,
.animate .orange-2-mobile,
{
  animation: opacityIn .2s 1.4s linear forwards;
}

.animate .line-2,
.animate .line-2-mobile,
{
  animation: line-1 .2s 1.6s linear forwards;
}

.animate .circle-2,
.animate .circle-2-mobile,
{
  animation: opacityIn .2s 1.8s linear forwards;
}

.animate .t1993,
.animate .t1993-mobile,
{
  animation: opacityIn .2s 2s linear forwards;
}

.animate .clock,
.animate .clock-mobile,
{
  animation: opacityIn .2s 2.2s linear forwards;
}

.animate .orange-3,
.animate .orange-3-mobile,
{
  animation: opacityIn .2s 2.6s linear forwards;
}

.animate .line-3,
.animate .line-3-mobile,
{
  animation: line-1 .2s 2.8s linear forwards;
}

.animate .circle-3,
.animate .circle-3-mobile,
{
  animation: opacityIn .2s 3s linear forwards;
}

.animate .t1994,
.animate .t1994-mobile,
{
  animation: opacityIn .2s 3.2s linear forwards;
}

.animate .orange-4,
.animate .orange-4-mobile,
{
  animation: opacityIn .2s 3s linear forwards;
}

.animate .line-4,
.animate .line-4-mobile,
{
  animation: line-4 .2s 3.2s linear forwards;
}

.animate .circle-4,
.animate .circle-4-mobile,
{
  animation: opacityIn .2s 3.4s linear forwards;
}

.animate .t1995,
.animate .t1995-mobile,
{
  animation: opacityIn .2s 3.6s linear forwards;
}

.animate .orange-5,
.animate .orange-5-mobile,
{
  animation: opacityIn .2s 3.4s linear forwards;
}

.animate .line-5,
.animate .line-5-mobile,
{
  animation: line-4 .2s 3.6s linear forwards;
}

.animate .circle-5,
.animate .circle-5-moblie,
{
  animation: opacityIn .2s 3.8s linear forwards;
}

.animate .t1997,
.animate .t1997-mobile,
{
  animation: opacityIn .2s 4s linear forwards;
}

.animate .sofa,
.animate .sofa-mobile,
{
  animation: opacityIn .3s 4.2s linear forwards;
}

.animate .orange-6,
.animate .orange-6-mobile,
{
  animation: opacityIn .2s 4.8s linear forwards;
}

.animate .line-6,
.animate .line-6-mobile,
{
  animation: line-1 .2s 5s linear forwards;
}

.animate .circle-6,
.animate .circle-6-mobile,
{
  animation: opacityIn .2s 5.2s linear forwards;
}

.animate .t1999,
.animate .t1999-mobile,
{
  animation: opacityIn .2s 5.4s linear forwards;
}

.animate .orange-7,
.animate .orange-7-mobile,
{
  animation: opacityIn .2s 5s linear forwards;
}

.animate .line-7,
.animate .line-7-mobile,
{
  animation: line-1 .2s 5.2s linear forwards;
}

.animate .circle-7,
.animate .circle-7-mobile,
{
  animation: opacityIn .2s 5.4s linear forwards;
}

.animate .t2002,
.animate .t2002-mobile,
{
  animation: opacityIn .2s 5.6s linear forwards;
}

.animate .orange-8,
.animate .orange-8-mobile,
{
  animation: opacityIn .2s 5.4s linear forwards;
}

.animate .line-8,
.animate .line-8-mobile,
{
  animation: line-1 .2s 5.6s linear forwards;
}

.animate .circle-8,
.animate .circle-8-mobile,
{
  animation: opacityIn .2s 5.8s linear forwards;
}

.animate .t2006,
.animate .t2006-mobile,
{
  animation: opacityIn .2s 6s linear forwards;
}

.animate .orange-9,
.animate .orange-9-mobile,
{
  animation: opacityIn .2s 6.6s linear forwards;
}

.animate .line-9,
.animate .line-9-mobile,
{
  animation: line-1 .2s 7s linear forwards;
}

.animate .circle-9,
.animate .circle-9-mobile,
{
  animation: opacityIn .2s 7.2s linear forwards;
}

.animate .t2012,
.animate .t2012-mobile,
{
  animation: opacityIn .2s 7.4s linear forwards;
}

.animate .factory,
.animate .factory-mobile,
{
  animation: opacityIn .2s 7.6s linear forwards;
}

.animate .orange-10,
.animate .orange-10-mobile,
{
  animation: opacityIn .2s 7.4s linear forwards;
}

.animate .line-10,
.animate .line-10-mobile,
{
  animation: line-10 .2s 7.6s linear forwards;
}

.animate .circle-10,
.animate .circle-10-mobile,
{
  animation: opacityIn .2s 7.8s linear forwards;
}

.animate .t2014,
.animate .t2014-mobile,
{
  animation: opacityIn .2s 8s linear forwards;
}

.animate .orange-11,
.animate .orange-11-mobile,
{
  animation: opacityIn .2s 7.8s linear forwards;
}

.animate .line-11,
.animate .line-11-mobile,
{
  animation: line-1 .2s 8s linear forwards;
}

.animate .circle-11,
.animate .circle-11-mobile,
{
  animation: opacityIn .2s 8.2s linear forwards;
}

.animate .t2016,
.animate .t2016-mobile,
{
  animation: opacityIn .2s 8.4s linear forwards;
}

.animate .orange-12,
.animate .orange-12-mobile,
{
  animation: opacityIn .2s 8.6s linear forwards;
}

.animate .line-12,
.animate .line-12-mobile,
{
  animation: line-1 .2s 8.8s linear forwards;
}

.animate .circle-12,
.animate .circle-12-mobile,
{
  animation: opacityIn .2s 9s linear forwards;
}

.animate .t2018,
.animate .t2018-mobile,
{
  animation: opacityIn .2s 9.2s linear forwards;
}

.animate .orange-13,
.animate .orange-13-mobile,
{
  animation: opacityIn .2s 9.4s linear forwards;
}

.animate .line-13,
.animate .line-13-mobile,
{
  animation: line-1 .2s 9.6s linear forwards;
}

.animate .circle-13,
.animate .circle-13-mobile,
{
  animation: opacityIn .2s 9.8s linear forwards;
}

.animate .t2019-1,
.animate .t2019-1-mobile,
{
  animation: opacityIn .2s 10s linear forwards;
}

.animate .orange-14,
.animate .orange-14-mobile,
{
  animation: opacityIn .2s 9.8s linear forwards;
}

.animate .line-14,
.animate .line-14-mobile,
{
  animation: line-1 .2s 10s linear forwards;
}

.animate .circle-14,
.animate .circle-14-mobile,
{
  animation: opacityIn .2s 10.2s linear forwards;
}

.animate .t2019-2,
.animate .t2019-2-mobile {
  animation: opacityIn .2s 10.4s linear forwards;
}

@keyframes orange-long {
  100% {
    stroke-dasharray: 1767.353271484375, 1767.353271484375;
  }
}
@keyframes blue-long {
  100% {
    stroke-dasharray: 3560.72412109375, 3560.72412109375;
  }
}
@keyframes orange-long-mobile {
  100% {
    stroke-dasharray: 1767.16162109375, 1767.16162109375;
  }
}

@keyframes line-1 {
  100% {
    stroke-dasharray: 3, 3;
  }
}

@keyframes line-4 {
  100% {
    stroke-dasharray: 3, 3;
  }
}

@keyframes line-10 {
  100% {
    stroke-dasharray: 3, 3;
  }
}

@media screen and (max-width: 750px) {
  .history {
    margin: 3rem auto 0;
    width: 90%;
  }
  .title-cn {
    margin: 1rem 0 3rem 0;
  }
  .pc-svg {
    display: none;
  }
  .mobile-svg {
    display: block;
  }

}

//.st0{fill:#3B3838;}
//.st1{clip-path:url(#SVGID_00000042701650468511154230000009472287616154531250_);}
.st0{fill:none;stroke:#006287;stroke-width:2;stroke-miterlimit:10;}
.st1{fill:#006483;}
.st2{display:none;fill:#595959;}
.st3{display:none;}
.st4{fill:none;stroke:#B7B7B7;stroke-miterlimit:10;}
#svg-mob .st0{fill:none;stroke:#A3A3A3;stroke-miterlimit:10;}
#svg-mob .st1{fill:none;stroke:#006287;stroke-miterlimit:10;}
#svg-mob .st2{fill:none;stroke:#898989;stroke-miterlimit:10;}
#svg-mob .st3{display:block;fill:none;stroke:#B7B7B7;stroke-miterlimit:10;}
#svg-mob .st4{opacity:0.2;fill:#006287;enable-background:new    ;}
#svg-mob .st5{fill:#006287;}
#svg-mob .st6{fill:none;stroke:#231815;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:4;}
#svg-mob .st7{font-family:'AvantGarde-Book';}
#svg-mob .st8{font-size:18px;}
#svg-mob .st9{fill:#666666;}
#svg-mob .st10{font-family:'SourceHanSansSC-Light';}
#svg-mob .st11{font-size:7px;}
//#svg-mob .st10{font-family:'SourceHanSansSC-Light';}

</style>
